/* eslint no-template-curly-in-string: 0 */
export const appName = 'ezManage' as const;

export const timeFormats = {
  twelveHourWithMinutes: 'h:mm a',
  twelveHourWithMinutesCapitalized: 'h:mm A',
  twelveHourWithBothMinutes: 'hh:mm A',
  twelveHourNoMinutes: 'h a',
  twelveHourNoMinutesCapitalized: 'h A',
  militaryTime: 'Hmm',
};

export const dateFormats = {
  longDate: 'MMMM D, YYYY',
  abbreviatedDate: 'MMM. D, YYYY',
  longMonthYearDate: 'MMMM YYYY',
  longMonthDay: 'MMMM D',
  abbreviatedMonthDay: 'MMM. D',
  longDayMonthDate: 'dddd, MMMM D',
  longDayMonthDateYear: 'dddd, MMMM D, YYYY',
  longDayMonthDateShortYear: 'dddd, MMMM D, YY',
  abbreviatedDayMonthDate: 'ddd, MMMM D',
  abbreviatedDayMonthDateShortYear: 'ddd, MMMM D, YY',
  shortDayShortDate: 'ddd MM/DD/YY',
  shortDate: 'MM/DD/YY',
  monthYearDate: 'MM/YY',
  shortDayMonthDay: 'ddd, M/DD',
  day: 'dddd',
  abbreviatedDay: 'ddd',
  isoFormat: 'YYYY-MM-DD',
  compact: 'M/D/YY',
};

export default {
  pluralize: {
    choice_one: '{{count}} choice',
    choice_other: '{{count}} choices',
    hour_one: '{{count}} hour',
    hour_other: '{{count}} hours',
  },
  connectors: {
    and: 'and',
    or: 'or',
  },
  distance: 'Distance: {{distance}} mi',
  time: {
    twelveHourWithMinutes: `{{time, ${timeFormats.twelveHourWithMinutes}}}`,
    twelveHourWithMinutesCapitalized: `{{time, ${timeFormats.twelveHourWithMinutesCapitalized}}}`,
    twelveHourNoMinutes: `{{time, ${timeFormats.twelveHourNoMinutes}}}`,
    twelveHourNoMinutesCapitalized: `{{time, ${timeFormats.twelveHourNoMinutesCapitalized}}}`,
    range: `{{start, ${timeFormats.twelveHourWithMinutes}}} - {{end, ${timeFormats.twelveHourWithMinutes}}}`,
  },
  timeWindow: {
    sameAMPM: '{{startAt, h:mm}}-{{endAt, h:mm A}}',
    differentAMPM: '{{startAt, h:mm A}}-{{endAt, h:mm A}}',
  },
  temporalNouns: {
    noon: 'Noon',
    today: 'Today',
    tomorrow: 'Tomorrow',
    yesterday: 'Yesterday',
  },
  date: {
    longDate: `{{date, ${dateFormats.longDate}}}`,
    abbreviatedDate: `{{date, ${dateFormats.abbreviatedDate}}}`,
    shortDate: `{{date, ${dateFormats.shortDate}}}`,
    shortDatePlaceholder: `${dateFormats.shortDate}`,
    longMonthYearDate: `{{date, ${dateFormats.longMonthYearDate}}}`,
    longMonthDayDate: `{{date, ${dateFormats.longMonthDay}}}`,
    abbreviatedMonthDayDate: `{{date, ${dateFormats.abbreviatedMonthDay}}}`,
    longDayMonthDate: `{{date, ${dateFormats.longDayMonthDate}}}`,
    longDayMonthDateShortYear: `{{date, ${dateFormats.longDayMonthDateShortYear}}}`,
    abbreviatedDayMonthDate: `{{date, ${dateFormats.abbreviatedDayMonthDate}}}`,
    abbreviatedDayMonthDateShortYear: `{{date, ${dateFormats.abbreviatedDayMonthDateShortYear}}}`,
    shortDayShortDate: `{{date, ${dateFormats.shortDayShortDate}}}`,
    longDayMonthDateYear: `{{date, ${dateFormats.longDayMonthDateYear}}}`,
    day: `{{date, ${dateFormats.day}}}`,
    abbreviatedDay: `{{date, ${dateFormats.abbreviatedDay}}}`,
    isoFormat: `{{date, ${dateFormats.isoFormat}}}`,
    range: `{{start, ${dateFormats.shortDate}}}–{{end, ${dateFormats.shortDate}}}`,
  },
  daysOfWeek: {
    abbreviations: {
      monday: 'Mon',
      tuesday: 'Tue',
      wednesday: 'Wed',
      thursday: 'Thu',
      friday: 'Fri',
      saturday: 'Sat',
      sunday: 'Sun',
      unknown: 'N/A',
    },
    full: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
    },
  },
  enums: {
    phoneLabels: {
      PHONE: 'Phone',
      MOBILE: 'Mobile',
      WORK: 'Work',
      HOME: 'Home',
      OFFICE: 'Office',
      KITCHEN: 'Kitchen',
      CATERING: 'Catering',
      STORE: 'Store',
      DIRECT_ENTRY: 'Direct Entry',
    },
    daysOfWeek: {
      MONDAY: 'Monday',
      TUESDAY: 'Tuesday',
      WEDNESDAY: 'Wednesday',
      THURSDAY: 'Thursday',
      FRIDAY: 'Friday',
      SATURDAY: 'Saturday',
      SUNDAY: 'Sunday',
    },
    operatingScheduleTypes: {
      DELIVERY: 'Delivery Hours',
      TAKEOUT: 'Takeout Hours',
    },
  },
  errors: {
    unknownError: 'There was an unknown error.',
    required: '{{fieldLabel}} is required.',
    number: '{{fieldLabel}} must be a number.',
    positive: '{{fieldLabel}} must be a positive value.',
    invalid: '{{fieldLabel}} is invalid.',
  },
  emDash: '—',
  missingValue: '--',
  hoursAndMinutes: {
    hour_one: '{{count}} hour',
    hour_other: '{{count}} hours',
    minutes_one: '{{count}} minute',
    minutes_other: '{{count}} minutes',
    hoursAndMinutes_one: '{{count}} hour {{minutesCount}} minutes',
    hoursAndMinutes_other: '{{count}} hours {{minutesCount}} minutes',
  },
  ContactUs: {
    title: 'Contact Us',
    supportPhone: 'Phone: {{catererSupportPhoneNumber}}',
    supportFax: 'Fax: {{supportFaxNumber}}',
    privacyPolicyLink: 'ezCater Privacy Policy',
    partnerSupportHours: '24/7 Support',
    form: {
      labels: {
        name: 'Name',
        email: 'Email',
        message: 'Your message',
      },
      placeholders: {
        name: 'Joe Smith',
        email: 'joe@gmail.com',
        message: 'Add a message',
      },
    },
    buttons: {
      cancel: 'Cancel',
      sendEmail: 'Send Email',
    },
  },
  orderActions: {
    accept: 'Order Accepted',
    ezOrderingMarketing: {
      description: 'Want to get more orders? <a>{{action}}</a> to your website for free.',
      link: 'Add online catering ordering',
    },
  },
  orderSources: {
    ALL_SOURCES: 'All Sources',
    MARKETPLACE: 'Marketplace',
    EZ_ORDERING: 'ezOrdering',
    DIRECT_ENTRY: 'Direct Entry',
    CLUB_SODA: 'Relish',
  },
  commonLabels: {
    demographicInfo: 'Demographic info',
    businessDemographicProfile: 'Business demographic profile',
    editDemographicInfo: 'Edit demographic info',
  },
  genericValues: {
    yes: 'Yes',
    no: 'No',
  },
  components: {
    automaticTempClosureBanner: {
      daily: `
        <strong>Capacity met for {{date}}: temporary closure is in effect</strong>
        <br/>
        You've reached your daily capacity, so we've closed your store to new orders based on your settings.
        <br /><br/>
        <a>Learn more</a>
      `,
      mealtime: `
        <strong>Capacity met for {{date}}: temporary closure is in effect for {{meal}}</strong>
        <br/>
        You've reached your capacity for a particular time of day, so we've closed your store to new orders based on your settings.
        <br /><br/>
        <a>Learn more</a>
      `,
    },
    downloadContactsList: {
      generateReport: 'Download Customers List',
      generatingReport: 'Creating your report...',
      downloadReport: 'Download my report',
    },
    PromoStatusBadge: {
      activeText: 'Active',
      expiredText: 'Expired',
    },
    SettingsDemographicDataCard: {
      subheading:
        'Amplify your restaurant owners and your business on ezCater by providing demographic data.',
    },
    StoreDetailsDemographicDataCard: {
      subheading:
        "Help customers more easily find what they're looking for by providing information about your restaurant ownership.",
    },
    deliveryManagement: {
      pageLayoutHeader: {
        defaultTitle: 'Delivery Management',
        deliveriesTabLabel: 'Deliveries',
        driversTabLabel: 'Drivers',
        reportingTabLabel: 'Reporting',
      },
      storesSelect: {
        selectAllLabel: 'All stores',
        placeholder: 'Choose Store(s)',
      },
      assignDriver: {
        assignDriverModalToggler: 'Assign in-house driver',
        changeDriverModalToggler: 'Change driver',
        serverErrorMessage:
          'Please refresh the page and try again. If the problem continues, contact support.',
        flashMessages: {
          submitSuccess: 'Driver successfully assigned for order #{{orderNumber}}',
        },
        assignDriverModal: {
          headerText: 'Assign driver for Order #{{orderNumber}}',
          searchPlaceholder: 'Search drivers...',
          searchLabel: 'Search drivers',
          dismissLabel: 'Cancel',
          submitLabel: 'Assign driver',
          addDriverButton: 'Add new driver',
          driverSmsOptedOut: 'SMS Notifications Disabled',
          driverSmsOptInPending: 'Driver Login Pending',
          errorHeadline: 'There was an error assigning the driver',
        },
        createDriverModal: {
          headerText: 'Assign driver for Order #{{orderNumber}}',
          subheader:
            'Enter your driver’s information below. The driver will receive a link to update the delivery status, allowing customers to receive updates throughout the delivery.',
          submitLabel: 'Save and Assign Driver',
          dismissLabel: 'Cancel',
          emptyDriversPrompt: 'You don’t have any drivers in the system yet.',
          creationErrorHeadline: 'There was an error creating the driver',
          assignmentErrorHeadline: 'There was an error assigning the driver',
          fields: {
            firstNameLabel: 'First Name',
            lastNameLabel: 'Last Name',
            phoneLabel: 'Driver Phone Number',
            makeModelLabel: 'Make/Model/Color',
          },
        },
      },
      unassignDriver: {
        modalSubmitLabel: 'Yes, unassign',
        modalDismissLabel: 'Cancel',
        modalHeaderText: 'Unassign Driver',
        modalBody: 'Are you sure you want to unassign this driver?',
        modalToggler: 'Unassign driver',
        flashMessages: {
          submitSuccess: 'Driver successfully unassigned for order #{{orderNumber}}',
          submitError:
            'There was an unexpected error when unassigning the driver for order #{{orderNumber}}. Please try again.',
        },
      },
    },
    deliverySetupDisplay: {
      notApplicable: 'N/A',
      deliverySetup: {
        NONE: 'No',
        REQUIRED: 'Yes',
        NO_RESPONSE: 'No response',
      },
    },
    deliveryTrackingLinkCard: {
      body: 'This order has live delivery tracking',
      buttonLabel: 'View',
    },
    orderCapacityModal: {
      newHeader: 'Need to pause orders?',
      newBody: `Looks like customers love ordering from you! <strong>You're at your capacity limit for {{mealTime}}{{orderDate}}.</strong> Want to set up a temporary closure to pause new orders just for that meal?`,
      dismissLabel: 'Continue receiving orders',
      submitLabel: 'Set temporary closure',
      flashMessages: {
        error: 'There was an error processing your request',
        successHeadline: `Temporary closure successfully set for {{date, ${dateFormats.longMonthDay}}}`,
        message: 'Want to change or delete it? <a>Click here</a>',
      },
    },
    assignDriverReminderModal: {
      title: 'Please assign a driver',
      dismissLabel: 'Remind me later',
      firstBulletPoint: 'Put your customers at ease by providing them with delivery updates.',
      secondBulletPoint:
        'Give your drivers access to order details, GPS navigation and the ability to call customers from a masked number.',
      back: 'Go back',
      dismissFlashMessage:
        'No problem! We will send a reminder to assign your driver when we get closer to the delivery time.',
      printOrderModal: {
        openButton: 'Print order with delivery QR code',
        header: 'Printing order {{orderNumber}}:',
        confirm: 'Print order sheet',
        secondaryConfirm: 'Download PDF',
      },
    },
    StoresModalWithBanner: {
      title_one: 'Updates to this form will reflect across 1 store.',
      title_other: 'Updates to this form will reflect across all {{count}} stores.',
      modalOpenButton: 'View store list',
      modalTitle_one: '{{count}} store',
      modalTitle_other: '{{count}} stores',
      dismissButton: 'Close',
    },
    StatusBadge: {
      pending_payment: 'pending payment',
    },
    AuthorizeForFeature: {
      error: 'Sorry, but you do not have access to this feature',
    },
    CateringPartnerAccountName: {
      deactivatedTooltip:
        'This account is deactivated. Contact us if you have any questions or would like to reactivate this user.',
      brandAdminTooltip: 'Only Brand Admins can access this account',
      currentUserTooltip: 'You can edit your personal info in Account',
      thisIsYou: '(this is you)',
    },
    DemographicDataNudgeBanner: {
      title: 'Help us get to know you better!',
      subtitle:
        "Sharing your ownership's demographic info helps us better understand our network and enhance our search options. Your response is voluntary and we’ll never share data without consent.",
      linkText: 'Take the demographic survey',
    },
    form: {
      CreditCardForm: {
        fields: {
          cardholderName: {
            label: 'Full Name',
            description: 'Full name as it appears on the card.',
            placeholder: 'Full Name',
            required: 'Enter valid a full name.',
          },
          cardNumber: {
            label: 'Card Number',
            description: '',
            placeholder: 'Card Number',
            required: 'Enter a valid card number.',
          },
          expiration: {
            label: 'Expiration Date',
            description: '',
            placeholder: 'MM/YY',
            required: 'Enter a valid expiration date.',
          },
          cvv: {
            label: 'CVV',
            description: '',
            placeholder: '123',
            required: 'Enter a valid CVV code.',
          },
        },
        errors: {
          invalidFields:
            'One or more payment method fields are invalid. Please double check the card number and expiration date.',
          networkError: 'There was a network error processing this credit card. Please try again.',
          unknownError:
            'There was an unknown error processing this credit card. Please try again or contact support.',
        },
      },
    },
    FormModal: {
      cancel: 'Cancel',
    },
    hoursOfOperation: {
      range: '{{openTimeFormatted}} – {{closeTimeFormatted}}',
      rangeInEasternStandardTime: '{{range}} EST',
      closed: 'Closed',
    },
    MetricComparedToLastYear: {
      noHistoricalData: 'no historical data available',
    },
    Navigation: {
      sections: {
        dailyOperations: 'Daily operations',
        businessInsights: 'Business insights',
        engageCustomers: 'Engage customers',
        manageAccount: 'Manage account',
        supportResources: 'Support resources',
      },
      Delivery: {
        subnav: {
          deliveries: 'Deliveries',
          deliveryPerformanceReporting: 'Reporting',
          drivers: 'Drivers',
          ezDispatch: 'ezDispatch',
          reporting: 'Reporting',
        },
      },
      Settings: {
        subnav: {
          storeSettings: 'Store settings',
          groups: 'Groups',
          servicesAndFees: 'Services & fees',
          usersAndPermissions: 'Users & permissions',
          account: 'Account',
          addNewStore: 'Add new store',
          apiCredentials: 'Integrations',
        },
      },
      Marketing: {
        subnav: {
          sponsoredListings: 'Sponsored listings',
          sponsoredPromos: 'Marketplace promos',
          marketingActivity: 'Activity',
          ezrewardsAndPPP: 'ezRewards & PPP',
          promotions: 'ezOrdering',
        },
      },
      SupportResources: {
        liveChat: 'Live chat',
        support: '24/7 support',
      },
    },
    ExistingCreditCard: {
      editCreditCard: 'Update Credit Card',
      submitCreditCard: 'Save Credit Card',
      cancelEditCreditCard: 'Cancel',
      validThrough: `Valid thru {{expDate, ${dateFormats.monthYearDate}}}`,
      noChargeUntilSubmittedNote:
        'Note: Updating the credit card will not charge the card. The card will not be charged until the order is submitted.',
      failedPayment: 'Please update this credit card.',
    },
    RowsPerPage: {
      label: 'Rows per page',
    },
    OrderAlreadySubmitted: {
      title: 'Order {{orderNumber}} was successfully submitted!',
      description: 'Click the link below to view the details of this order',
      button: 'View Order',
    },
    OperatingSchedulesForm: {
      daily: {
        from: 'from',
        to: 'to',
        open: 'Open',
        closed: 'Closed',
        selectOpenClosed: 'Select open or closed',
        selectTime: 'Select time',
        copy: 'Copy',
      },
      takeoutHours: {
        takeoutOffered: 'Can customers pick up orders themselves?',
        yes: 'Yes',
        no: 'No',
        takeoutSameAsDelivery: 'Are your takeout hours the same as your delivery hours?',
        sameLabel: "Yes, they're the same",
        differentLabel: 'No, our takeout hours are different',
      },
      errors: {
        both: 'Open time and close time are required, and open time must be earlier than close time.',
        missingValue: 'Open time and close time are required',
        range: 'Open time must be earlier than close time',
        closed:
          'Partners must be open for at least one day of the week to be on the ezCater Marketplace. If you need to turn off all orders temporarily, use Temporary Closures.',
        default: 'Oh crumbs! Something went wrong.',
      },
    },
    HolidayClosuresForm: {
      label: 'Holidays',
      saveChanges: 'Save Changes',
      cancel: 'Cancel',
      successPlural: 'Success! The Holiday Closures have been updated for these caterers.',
      successSingular: 'Success! The Holiday Closures have been updated for this caterer.',
      error: 'Oh crumbs! There was an error saving the Holiday Closures.',
    },
    LeadTimeForm: {
      advanceNoticeOptions: {
        label: 'Advance notice options',
        prompt: 'How far in advance do you need to know about orders?',
        sameDay: 'I accept same day orders',
        dayBefore: 'I need to know the day before',
        manyDays: "I need multiple days' notice",
      },
      sameDay: {
        prompt: 'How many hours of notice do you need?',
        description:
          'The number of hours you need to prepare and deliver an order after it has been placed.',
        label: 'Select a time',
      },
      dayBefore: {
        prompt: "What's your day before cutoff time?",
        description: 'The latest time in a day we can send you orders for the following day',
        label: 'Select a cutoff time',
      },
      manyDays: {
        prompt: 'How much advance notice do you need?',
        description:
          'The amount of time you need to prepare and deliver an order after it has been placed',
        label: 'Select a time',
      },
      optionsForSelect: {
        hour_one: '{{count}} hour',
        hour_other: '{{count}} hours',
        minutes_one: '{{count}} minute',
        minutes_other: '{{count}} minutes',
        hoursAndMinutes_one: '{{count}} hour {{minutesCount}} minutes',
        hoursAndMinutes_other: '{{count}} hours {{minutesCount}} minutes',
      },
      submitButton: 'Save Changes',
    },
    LeadTimeMarketing: {
      alerts: {
        dayBeforeCutoff: {
          header: 'Low lead times — risk and reward',
          content:
            'Shorter lead times can generate more orders, but these orders have a higher rate of customer-reported issues. Focus on maximizing the number of orders you can fulfill <strong>reliably</strong>.',
        },
        shorterLeadTime: {
          header: 'Choose a low lead time to get more orders',
          content:
            'We recommend 2-4 hour lead times. Partners with shorter lead times typically see more orders.',
        },
        longerLeadTime: {
          header: '35% of orders have lead times of 24 hours or less',
          content:
            "We recommend avoiding requiring multiple days' notice to maximize how many orders you get.",
        },
      },
    },
    TemporaryClosuresForm: {
      addTemporaryClosure: 'Add another',
      columns: {
        duration: 'Time closed',
        from: 'From',
        through: 'Through',
        marketplace: 'ezCater',
        relish: 'Relish',
        startAt: 'Starting at (optional)',
        endAt: 'Ending at (optional)',
      },
      timePickerPlaceholder: 'Select time',
      confirmation: {
        labels: {
          add: 'Add',
          remove: 'Remove',
        },
        dateSpanDescriptionWithTime:
          '{{durationDisplay}} closure from {{startDate}} at {{startAt}} to {{endDate}} at {{endAt}}',
      },
      errors: {
        field: 'Choose a date',
      },
      removeTemporaryClosure: 'Remove',
      submit: {
        actionText: 'Save Changes',
        failure: 'Changes to temporary closures could not be saved',
        success: 'Changes to temporary closures were successfully saved',
      },
      zeroState: {
        message: 'No temporary closures scheduled.',
        action: 'Add a closure',
      },
      channelClosuresWarning: {
        message: {
          one: 'Note: There is already 1 temporary closure scheduled for these stores on different channels (ezCater/Relish)',
          many: 'Note: There are already {{count}} temporary closures scheduled for these stores on different channels (ezCater/Relish)',
        },
      },
    },
    DailyCapacityForm: {
      multiple: 'Multiple',
      noMax: 'No max',
      dayCountLabel: 'Daily order max for {{dayOfWeek}}',
      submit: 'Save Changes',
      cancel: 'Cancel',
      formTitle: 'Daily Capacity Form',
      zeroWarningTooltip:
        "You can't set a daily maximum of 0. If you don't want notifications, uncheck the day.",
      breakfast: {
        helperText: 'Breakfast (Open - 11 AM)',
        label: 'Breakfast order max for {{dayOfWeek}}',
      },
      lunch: {
        helperText: 'Lunch (11 AM - 3:30 PM)',
        label: 'Lunch order max for {{dayOfWeek}}',
      },
      dinner: {
        helperText: 'Dinner (3:30 PM - Close)',
        label: 'Dinner order max for {{dayOfWeek}}',
      },
      dailyLimit: {
        helperText: 'Daily limit',
        label: 'Daily order max for {{dayOfWeek}}',
      },
    },
    DiscountOrFeeForm: {
      addDiscountOrFee: 'Add Discount or Fee',
      save: 'Save',
      remove: 'Remove',
      fee: 'Fee',
      discount: 'Discount',
      errors: {
        type: 'Type must be selected',
        amount: 'Amount must be positive',
        name: 'Reason must be provided',
      },
      placeholders: {
        type: 'Discount or Fee',
        amount: 'Amount',
        name: 'e.g. First time order, etc.',
      },
      amountDropdown: {
        exactAmount: '$',
        percent: '%',
      },
    },
    PosLockedMessage: {
      modified: {
        header: 'This modified order did not sync with your POS system.',
        body: "Last-minute changes don't automatically sync. Please manually update the order in your POS system.",
      },
      cancelled: {
        header: 'This cancelled order did not sync with your POS system.',
        body: "Last-minute changes don't automatically sync. Please manually update this order in your POS system.",
      },
    },
    ProceedPaymentButton: {
      newOrder: 'Continue to Payment',
      quoteModification: 'Approve Quote',
    },
    StarRating: {
      rating_one: '{{count}} star',
      rating_other: '{{count}} stars',
    },
    StoreSelector: {
      label: 'Change store',
      allStores: 'All Stores',
      groupDisplay: '(Group) - {{name}}',
    },
    StoreSelectionSidePanel: {
      changeSelectionAction: 'Change selected stores',
      title_one: "You're editing info for {{formattedCount}} store",
      title_other: "You're editing info for {{formattedCount}} stores",
    },
    MarketingListingsPreview: {
      deliveryFee: '$0 Delivery fee',
      distance: '0.8mi',
      heading: {
        listings: 'Preview of sponsored listing',
        promos: 'Preview of promo on your listing',
      },
      rating: '4.8',
      sponsored: 'Sponsored',
      altText: 'Listing preview',
      text: 'This example is for illustrative purposes',
      title: 'Local favorite',
      discount: '$10 off orders over $500',
    },
    SponsoredListingPreview: {
      heading: 'Preview of sponsored listing',
    },
    SponsoredPromoPreview: {
      heading: 'Preview of promo on your listing',
    },
    EmailSupportModal: {
      backToSupport: 'Back to 24/7 Support',
      header: 'Send us a message',
      dismiss: "Don't Send",
      submit: 'Send Message',
      form: {
        fields: {
          name: {
            label: 'Name',
          },
          email: {
            label: 'Email',
          },
          message: {
            label: 'Message',
          },
        },
      },
    },
    SwitchStoreAlert: {
      content:
        'Your selected menu items will be lost when you switch stores. Do you wish to continue?',
      header: 'Store Switch',
      continue: 'Continue',
      cancel: 'Cancel',
    },
    SmsCompliance: {
      SmsOptInModal: {
        continue: 'Continue',
        info: "We'll send you information about orders for your location by text message to: {{phoneNumber}}",
        link: 'Terms apply.',
        terms: 'If you agree, we will continue sending text messages to the number on file',
        title: 'Welcome to ezCater!',
      },
      error: {
        generalError:
          'Oh Crumbs! There was a problem submitting your SMS opt-in status. Please try again or contact support.',
      },
    },
    TipForm: {
      amount: {
        type: 'Amount must be a positive number',
      },
    },
    DeliveryFeeForm: {
      amount: {
        type: 'Amount must be a positive number',
      },
    },
    ReviewCard: {
      title: 'Order {{formattedOrderNumber}}',
      reviewTitle: 'Review',
    },
    TopBar: {
      createOrderButton: 'Create New Order',
      lastUpdated: 'Last updated: {{lastUpdated}}',
    },
    Totals: {
      subTotal: 'Subtotal',
      tip: 'Tip',
      total: 'Total',
      pricePerHead: 'Price Per Head',
      salesTax: 'Sales Tax',
      taxExempt: {
        label: 'Tax Exempt?',
        tooltip:
          'If selected, taxes will not be collected. You will not be required to submit a tax exempt certificate.',
      },
      error: {
        negativeTotal:
          'The discounts in this order make the total balance negative. Please either adjust the discounts or add more items to the order.',
      },
      catererTotalDue: 'Caterer Total Due',
      houseAccount: '(House Account: {{houseAccount}})',
      paymentTransactionFee: 'Payment Transaction Fee',
      preferedPartnerProgram: 'Prefered Partner Program',
      paidByEzCater: {
        label: {
          line1: 'You will be paid by ezCater.',
          line2: 'Do NOT collect payment or tips on-site.',
        },
        value: 'PAID',
      },
      cancelled: {
        label: 'Order is cancelled.',
        value: 'CANCELLED',
      },
    },
    NotificationMethods: {
      contactMethodsDisplay: {
        title: 'Contact Info',
        ownAccountSubtitle: 'How ezCater sends notifications to or contacts you',
        otherAccountSubtitle: 'How ezCater sends notifications to or contacts this user',
        actions: {
          edit: 'Edit Contact Info',
        },
        contactMethods: {
          email: 'EMAIL',
          phone: 'PHONE NUMBERS',
        },
      },
      storeCard: {
        header: 'Notification Preferences',
        email: {
          table: {
            title: 'Email Notifications',
            headers: {
              orders: 'Orders',
              billingStatements: 'Billing Statements',
              deliveryReminders: 'Delivery Management Reminders',
            },
            toggles: {
              email: 'Email',
            },
            tooltips: {
              disabledDeliveryReminders:
                'Delivery Management permissions must be enabled to receive Delivery Management Reminders.',
            },
          },
        },
        phone: {
          table: {
            header: 'Phone Notifications (<a>SMS Terms</a> apply)',
            title: 'Phone notifications for orders',
            phoneNumbers: 'Phone Numbers',
            optedOutTooltipMessage:
              'This phone number has been opted out of ezCater SMS messages. You can opt-in to SMS messages by texting START to {{smsNumber}}.',
            orderNotifications: 'Order Notifications',
            toggles: {
              sms: 'SMS',
              fax: 'Fax',
            },
            smsAllowed: 'Order SMS allowed?',
            invalidWarning:
              'This phone number is invalid. Please update it in the Contact Info section.',
          },
        },
        update: {
          error:
            "Can't save changes due to a system error. Try again in a few minutes or contact support.",
        },
        updateAll: {
          callToAction: 'Copy settings to all stores',
          header: 'Copy notification settings',
          cancel: 'Cancel',
          submit: 'Copy to all {{totalCount}} stores',
          content:
            'This will copy notification settings exactly from {{storeName}} - {{storeNumber}} to all {{totalCount}} stores this user has access to. This will replace the current notification settings for these stores.',
          successMessage:
            'Notification settings from {{storeName}} - {{storeNumber}} were copied to all of your stores.',
          errorMessage:
            'Unable to copy settings to all stores. Try again in a few minutes or contact support.',
        },
      },
      SmsAllowed: {
        termsAccepted: {
          smsAllowed: 'Yes',
        },
        pending: {
          smsAllowed: 'Pending',
          tooltipMessage:
            'SMS opt-in is pending for this phone number. This user can opt-in to SMS messages from their Account page in ezManage or when they reply to an order by text.',
        },
        termsRejected: {
          smsAllowed: 'No',
          tooltipMessage:
            'This phone number has been opted out of ezCater SMS messages. If you believe this was a mistake, this user can opt-in to SMS messages from the Account Page in ezManage or by texting START to 61210.',
        },
        optedOut: {
          smsAllowed: 'No',
          tooltipMessage:
            'This phone number has been opted out of ezCater SMS messages. If you believe this was a mistake, this user can opt-in to SMS messages by texting START to 61210.',
        },
      },
    },
    StoreList: {
      showFewerStores: 'See fewer stores',
      showMoreStores_one: 'See {{formattedCount}} more store',
      showMoreStores_other: 'See {{formattedCount}} more stores',
    },
    BulkEditSettings: {
      ProposedChangeReview: {
        heading: 'Confirm Changes',
        confirmAction: 'Confirm & Save Changes',
        cancelAction: "Don't Change",
        titles: {
          actionDescription: "You're about to:",
          storeList_one: '{{formattedCount}} Store will be changed:',
          storeList_other: '{{formattedCount}} Stores will be changed:',
          actionPrompt_one: 'Do you want to make changes to this store?',
          actionPrompt_other: 'Do you want to make changes to these stores?',
        },
      },
      CompletedChangeSummary: {
        changes: {
          title: 'Changes',
          subtitle: 'Large changes may take a few minutes to take effect',
        },
        titles: {
          storeList_one: '{{formattedCount}} Store was changed:',
          storeList_other: '{{formattedCount}} Stores were changed:',
          page: 'Success!',
        },
      },
      SummaryPageContent: {
        header: 'Success!',
        subNav: {
          backLink: 'Back to Settings Selection',
        },
      },
    },
    CustomerOrderHistory: {
      title: 'Past Orders ({{totalCount}})',
      viewOrderHistory: 'View Order History',
      viewMore: 'View 5 More',
      viewAll: 'View All',
    },
    ServicesAndFeesModal: {
      header: 'Services and Fees',
    },
    TermsAndConditionsModal: {
      agreeAndContinue: 'Agree and continue',
      dismiss: 'Dismiss',
      error: {
        networkError:
          'Oh Crumbs! There was a network error while accepting the Terms & Conditions. Please try again.',
        generalError:
          'Oh Crumbs! There was a problem accepting the Terms & Conditions. Please try again or contact support.',
      },
      title: 'ezCater & Catering Partner Terms and Conditions',
      titleNew: 'Please agree to our Terms & Conditions',
      paragraph1: 'All catering partner businesses must agree to the current',
      link: 'ezCater & Catering Partner Terms and Conditions.',
      paragraph2:
        'By clicking “Agree and continue,” you are accepting the ezCater & Catering Partner Terms and Conditions on behalf of each catering partner business that has not otherwise executed an offline services agreement with ezCater.',
      expandSummary: 'Expand list of businesses covered by this agreement',
    },
    MismatchedUsernameEmailModal: {
      title: 'Update your account information',
      message:
        'To make your account more secure, ezManage is changing how you sign in. We now require you to use an email address instead of a username.',
      optionChoiceMessage:
        'Choose an existing email address, or enter a different one below. <strong>This will be what you use to login from now on.</strong>',
      newEmail: {
        label: 'New email address',
      },
      currentPassword: {
        message: 'Your password is required to update your username. Please enter it below:',
        label: 'Current password',
        forgotPassword1: 'Forgot your password?',
        forgotPassword2: 'and reset it.',
      },
      currentUsernameAndEmailInvalid:
        "Enter the email address you'd like to use to sign in. <strong>This will be what you use to login from now on.</strong>",
      validations: {
        newEmail: {
          invalidFormat: 'Invalid email format',
        },
        currentPassword: {
          required: 'Password is required',
        },
      },
      flashMessages: {
        genericSuccess: 'Your sign-in email has been saved.',
        success: 'Your sign-in email has been saved as {{email}}.',
      },
    },
    ReliabilityStatusCallout: {
      linkText: 'See your Reliability Rockstar status',
      canceled: {
        line1Text: 'Canceled orders for this period',
      },
      rejected: {
        line1Text: 'Rejected orders for this period',
      },
    },
    OrdersTableCallout: {
      CANCELLED_NOT_REJECTED: {
        line1Text: 'Never cancel an order again.',
        line1BoldText: "Here's how.",
        linkText: 'Tips to avoid canceling orders',
      },
      REJECTED: {
        line1Text: 'Accept more orders.',
        line1BoldText: 'Make more money.',
        linkText: 'Tips to avoid rejecting orders (1 min. 30 sec.)',
      },
      PAST: {
        line1Text: 'Download your ezOrdering customer list now.',
        line1BoldText: '',
        linkText: 'Download customers list',
      },
    },
    FormDispute: `Disagree with a {{reason}}? <br/> <a>Dispute Here</a>`,
    EzManageNav: {
      labels: {
        chat: 'Chat',
        defaultHome: 'home',
        defaultUserAccountName: 'Your Account',
        support: '24/7 Support',
      },
    },
    SupportModal: {
      SupportOptionsModal: {
        chat: {
          header: 'Chat',
          subText: 'Talk to us now',
        },
        dismiss: 'Close',
        email: {
          header: 'Email',
          subText: 'Send us a message',
        },
        header: '24/7 Support',
        help: {
          header: 'Help Center',
          subText: 'Answers to frequently asked questions',
        },
        phone: {
          header: 'Phone',
        },
      },
      EmailModal: {
        backToSupport: 'Back to 24/7 support',
        dismiss: 'Dont Send',
        email: 'email',
        emailError: 'Email must be a valid email address',
        header: 'Send us a Message',
        message: 'message',
        messageError: 'Message cannot be blank',
        name: 'Name',
        nameError: 'Name cannot be blank',
        submit: 'Send Message',
      },
    },
    sponsoredListingForm: {
      title: {
        storeSelection: 'Which locations do you want to promote?',
        budgetScreen: 'How much do you want to budget each week per store?',
        singleStoreBudgetScreen: 'How much do you want to budget each week at {{storeAddress}}?',
        spendingStrategy: 'Select your spending strategy',
        reviewScreen: "Let's review all the details before launching",
      },
      subTitle: {
        storeSelection:
          'Boost multiple locations with one campaign or create separate ones. Your budget will be allocated dynamically across locations based on customer search activity.',
        budgetScreen:
          'Your budget resets each Monday, but you can adjust your budget or pause your campaign any time. Reminder: you’ll only be charged for orders you get.',
        singleStoreBudgetScreen:
          'Select the most you want to spend each week your campaign is active. You can pause your campaign any time. Reminder: You’ll only be charged for orders you get.',
        spendingStrategy:
          'Most advertisers choose Automatic, but you can also set a manual limit on what you pay per listing.',
        reviewScreen: 'Does everything look correct? This will go into effect immediately.',
      },
      backButton: 'Back',
      nextButton: 'Next',
      boxedRadio: {
        recommend: 'Recommended',
        perPeriod: ' / week',
        dollar: '$',
      },
      storeSelectionTable: {
        headers: {
          storeName: 'Name',
          campaignStatus: 'Campaign Status',
          storeNumber: 'Store Number',
          state: 'State',
          storeGroup: 'Caterer Group',
        },
        searchPlaceholder: 'Search locations',
        title: 'Select locations',
      },
      budgetScreen: {
        distributeByDemand: 'Distribute by demand',
        distributeByDemandHelperText:
          'Automatically optimize spending based on search demand across your stores.',
        distributeEvenly: 'Distribute evenly',
        distributeEvenlyHelperText:
          'Each store will be allocated the same budget (${{budget}}/week)',
        duration: 'How long do you want this campaign to run?',
        untilPause: 'Until I pause it',
        scheduledDate: 'Schedule a start and end date',
        customValuePlaceholder: 'Add budget',
        groupType: 'How would you like to distribute your budget?',
        groupTypeHelperText:
          'Budget distribution can’t be changed for live campaigns. To change between budget distribution types, you will need to create a new campaign.',
      },
      spendingStrategy: {
        info: 'To change spending strategy after your campaign is live, you’ll have to create a new campaign.',
        automatic: {
          label: 'Automatic',
          helperText: 'We’ll optimize bids based on budget, market, and campaign duration.',
        },
        manual: {
          label: 'Set a manual limit',
          helperText: 'Set the maximum amount you want to spend per order.',
          customInputHelperText: 'This can be changed at any time.',
        },
        disabled: {
          tooltip: 'Spending strategy can’t be changed for live campaigns.',
        },
        efficiency: {
          title: 'Efficiency',
          description:
            "Aim for a lower cost per order. May limit your ad's visibility and drive fewer orders.",
        },
        balanced: {
          title: 'Balanced',
          description:
            'Win more customers at the right price. Optimize for both ad spend and visibility.',
        },
        visibility: {
          title: 'Visibility',
          description:
            'Get seen by more customers. Can help win more orders at a higher cost per order.',
        },
        recommended: 'Recommended',
      },
      flashMessages: {
        successHeadline: 'Your {{campaignName}} campaign is live',
        successMessage: 'You can pause your campaign at any time',
        genericError: 'There was an error processing your request',
      },
      faq: {
        title: 'Help and tips',
        storeSelectionStep: {
          howAreBudgetsDistributedAcrossLocations: {
            question: 'How are budgets distributed across locations?',
            answer: `
If you select multiple locations, each store will get its own identical budget, which you’ll set on the next screen. If you want to budget a different maximum for certain stores, only select those with the same budget now.

Stores with identical budgets will not spend them uniformly. If one store is in an area that gets significantly more search, it may get more orders through its sponsored listing, and will therefore be more likely to hit its maximum.
`,
            answerEnterprise: `
If you select multiple locations, you’ll be able to set a budget strategy on the next screen.

Note that if you split your budget equally, stores may not spend them uniformly. If one store is in an area that gets significantly more search, it may get more orders through its sponsored listing, and will therefore be more likely to hit its maximum.
`,
          },
        },
        budgetStep: {
          howIsARecommendedBudgetDetermined: {
            question: 'How is a recommended budget determined?',
            answer: `
  Our recommendation is based on what we’ve observed as the average amount restaurant locations spend to generate 4-7 incremental orders over the course of a month.

  If you want fewer additional orders to start, set a lower amount. If you can handle more orders, you may want to budget more to attract more orders.
  `,
          },
          willIAlwaysSpendThisAmount: {
            question: 'Will I always spend this amount?',
            answer: `
No. This reflects the maximum you will spend on sponsored listings over a week. If there are not enough people searching in your area or you don’t win enough auctions to spend your budget, you will not spend the maximum.

You will also only be charged for orders you get. On your “My campaigns” page, you’ll be able to see if people are seeing your ad and visiting your menu but not ordering. In those cases, you will not be charged.
`,
          },
          whatHappensIfIChangeMyBudgetMidweek: {
            question: 'What happens if I change my budget mid-week?',
            answer: `
Changes you make will take effect right away. If you increase your budget, that new limit will be available for the remaining part of the week.

If you reduce your budget and have already spent more than the new limit, your campaign will not serve any new sponsored listings until next Monday, when your budget resets.
`,
          },
        },
        spendingStrategyStep: {
          howDoesAutoBiddingWork: {
            question: 'How does auto bidding work?',
            answer: `
Each sponsored listing spot is filled by comparing the bids offered by different restaurants. Based on the local search volume for restaurants like yours, automatic bids are optimized to stay within your allocated overall budget and win you customers in a sustained manner over the course of each week.

We monitor your campaign continuously and adjust your bids based on the expected value of an order, to help get the best return from your budget.
`,
          },
          howDoManualLimitsWork: {
            question: 'How do manual limits work?',
            answer: `
Some advertisers set a manual limit based on the most they’d pay to bring in an average catering order.

For example, if your average catering order is $500, you might set a max bid of $100 to target a return on your ad spend (ROAS) of 5x or higher, or a max bid of $167 to try to win more placements and more orders, at a lower ROAS of 3x.

Lower limits may result in fewer people seeing your ads and fewer sales. Higher limits may win more auctions, but will cost more per order.
`,
          },
          canIChangeMyBiddingStrategyOrLimitsAfterACampaignIsLive: {
            question: 'Can I change my bidding strategy or limits after a campaign is live?',
            answer: `
You can change your limits any time from the “My campaigns” page, where you can pause and edit your campaign.

To change your strategy between automatic bidding and manual limits, you’ll need to stop your campaign and start another one with the change. This makes sure your data is accurate and you can compare the strategies you’ve employed.
`,
          },
        },
        reviewStep: {
          doINeedToNameMyCampaign: {
            question: 'Do I need to name my campaign?',
            answer: `If you plan to run multiple campaigns, giving each a distinct name will help you manage them easily on the “My campaigns” page.`,
          },
          ifCampaignIsPerforming: {
            question: 'How will I know how this campaign is performing?',
            answer: `
Once you’ve launched your campaign, you can view the results and manage its settings on your “My campaigns” page.

You’ll be able to track all the financial details, pause the campaign, and more. You always maintain control of your spending.
`,
          },
        },
      },
    },
    sponsoredPromoForm: {
      title: {
        storeSelection: 'Which locations do you want to apply promo to?',
        discountScreen: 'Set your promo’s details',
        reviewScreen: 'Let’s review all the details before launching',
      },
      subTitle: {
        storeSelection:
          'You can choose multiple locations as part of one campaign, or offer your promo at an individual location.',
        discountScreen:
          'Choose the type of discount you want to offer, and its value. All promotions must have an expiration date. If you choose to, you can also require a minimum order value below which the promotion can not be applied.\n\nDiscounts are applied to the food & beverage subtotal only.',
        reviewScreen: 'Does everything look correct?',
      },
      step: 'Step {{step}}/3',
      faq: {
        title: 'Help and tips',
      },
      storeSelectionTable: {
        headers: {
          storeName: 'Name',
        },
        searchPlaceholder: 'Search locations',
        title: 'Select locations',
      },
      discountScreen: {
        setDiscountType: 'Set promo discount type and value',
        optionalConfigurations: 'Optional configurations',
        label: {
          requireOrderMinimum: 'Require order minimum',
          expirationDate: 'Expiration date',
          expirationDateHelperText:
            'After this date, customers can no longer view the promotion or apply it at checkout.',
          weekdaysOnly: 'Valid only on weekdays orders',
        },
        placeholder: {
          discountType: 'Select discount type',
          discountValue: '10',
          orderMinimum: 'Order minimum',
        },
      },
      reviewScreen: {
        locations: {
          titleForSingleLocation: 'At 1 location',
          titleForMultiLocations: 'At {{count}} locations',
        },
        longTitle: '{{discountValue}} off food & beverage total',
        longTitleWithOrderMinimum:
          '{{discountValue}} off food & beverage total over ${{orderMinimum}}',
        promoTitle: '{{discountValue}} off',
        promoTitleWithOrderMinimum: '{{discountValue}} off orders over ${{orderMinimum}}',
        runningEverydayUntil: 'Running everyday until {{date}}',
        runningWeekdaysUntil: 'Running weekdays until {{date}}',
      },
      flashMessages: {
        successHeadline: 'Your {{promoTitle}} promo is live',
        successMessage: 'You can pause your promo at any time',
        genericError: 'There was an error processing your request',
      },
    },
    ExpandableList: {
      showMore: 'Show more',
      showLess: 'Show less',
    },
    WebcamCapture: {
      retakePhoto: 'Retake the photo',
      submitPhoto: 'Submit photo',
      takePhoto: 'Take photo',
    },
    TimeFrameFilter: {
      label: 'Time Frame',
      options: {
        SEVEN_DAYS: 'Last 7 days',
        THIRTY_DAYS: 'Last 30 days',
        MONTH: 'Month to Date',
        WEEK: 'Week to Date',
        YEAR: 'Year to Date',
        CUSTOM: 'Custom',
      },
    },
  },
  pages: {
    AddCateringPartnerAccount: {
      fromUsers: {
        breadcrumb: 'Back to users & permissions',
        accessibilityLabel: 'Back to users & permissions',
      },
      fromStore: {
        breadcrumb: 'Back to Store',
        accessibilityLabel: 'Back to Store',
      },
      title: 'Add New User',
      contactInformation: {
        title: 'New User Information',
        subtitle: 'We’ll use this information for account login and order communications.',
        form: {
          email: 'Email',
          name: 'Full Name',
          phone: 'Phone Number (optional)',
          phoneType: 'Phone Type (optional)',
          errors: {
            name: 'Please enter a name',
            email: 'Please enter a valid email address',
            phone: 'Please enter a valid 10-digit phone number',
          },
        },
      },
      formSubmission: {
        title: 'Send Invitation',
        subtitle:
          "An invitation will be sent to the email address you've provided. The user will need to accept this invitation and create a password in order to gain access to their account on ezManage.",
        actions: {
          sendInvitation: 'Send Invitation',
        },
        success: {
          header: "{{name}}'s invitation is on its way!",
          body: 'Customize their settings here, including permissions and notifications.',
        },
        storeSelectedTooltip: 'Provide a full name and email to proceed.',
        noStoreSelectedTooltip:
          'Provide a full name, email, and access to at least one store to proceed.',
        errors: {
          contactIsVisible: {
            header: 'A user already has this email address',
            body: 'You can edit <a>{{fullName}}</a>, or contact support for assistance.',
          },
          contactIsNotVisible: {
            header: 'Whoops! This email address is already in our system.',
            body: 'You cannot send an invitation to this email address. Please contact support for assistance.',
          },
          default: {
            body: 'Sorry, something went wrong. Please try again.',
          },
        },
      },
      availableStoresList: {
        title: 'Select stores for this user',
        subtitle_one: '{{storeCount}} store',
        subtitle_other: '{{storeCount}} stores',
        storeSelection_one: '{{storeCount}} store selected',
        storeSelection_other: '{{storeCount}} stores selected',
        select: 'Select',
        headers: {
          nickname: 'Store Nickname',
          storeNumber: 'Store Number',
          address: 'Address',
        },
        emptyState: {
          title: 'You have selected all stores',
          copy: 'All available stores have been selected for this invitation.',
        },
        emptySearch: {
          title: 'No stores match your search',
          copy: "The store you're looking for might already be selected. Clear filters and try again.",
          clear: 'Clear Filters',
        },
      },
      selectedStoresList: {
        emptyState: {
          title: 'Scroll down to select stores for this user.',
          copy: 'Selected stores will appear here. Select at least one to continue.',
        },
      },
    },
    AddNewStore: {
      topCard: {
        headerTagline: 'Want to get another location onto the ezCater Marketplace? Easy.',
        description:
          'Adding all of your locations is the best way to increase the orders you get through ezCater.',
        linkCopy: 'Review our onboarding requirements',
        finalDescriptionLine:
          "and then complete the steps below. We'll get to work adding your store.",
      },
      steps: {
        listingInformation: {
          header: 'Provide your listing information',
          body: 'This form provides all the info we need to set your store up in the marketplace with your settings and menu as you prefer.',
        },
        tellUsHowYouPay: {
          header: 'Tell us how to pay you (If needed)',
          body: 'Provide business and banking information to establish how you’ll receive payments for this new location. If you’re using info from your current stores, skip this step.',
        },
        thankYou: {
          header: 'Thank you! We’ll take it from here.',
          body: 'We’ll email you when your store is ready and listed on the marketplace.',
        },
      },
      uploadPhotos: {
        header: 'Upload or schedule photos',
        body1: 'Good photos get orders. Learn how to',
        bodyLinkCopy1: 'book a photo session',
        body3: 'or get guidance on',
        bodyLinkCopy2: 'sending us your own photos.',
      },
      breadcrumb: 'Back to Add new store',
      listingInformationPage: {
        title: 'Listing info',
      },
      ACHFormPage: {
        title: 'Payment info',
      },
    },
    BulkEditStoreSettings: {
      header: 'Choose setting to edit',
      backLink: 'Back to Store Selection',
      settingsCard: {
        permissionError: 'You do not have permission to edit this',
        dailyCapacity: {
          action: 'Edit',
          title: 'Daily capacity Target',
          description:
            "Tell us how many orders you can handle each day. When you hit your daily limit, we'll send you a notification, giving you the choice to set a Temporary Closure. We won't stop new orders automatically.",
        },
        holidayClosures: {
          action: 'Edit',
          title: 'Holiday Closures',
          description: 'Recurring holidays when your business is closed.',
        },
        leadTimes: {
          action: 'Edit',
          title: 'Lead Time',
          description: 'The minimum advance notice required for new orders.',
        },
        operatingHours: {
          action: 'Edit',
          title: 'Operating Hours',
          description: 'Hours your business is open for delivery and takeout.',
        },
        temporaryClosures: {
          action: 'Edit',
          title: 'Temporary Closures',
          description:
            "Select a period of time in which your store won't receive new orders from ezCater",
        },
      },
    },
    CateringPartnerAccountSettings: {
      title: 'Profile',
      tabs: {
        access: 'Store access',
        notifications: 'Notifications',
        permissions: 'Permissions',
        accessibilityLabels: {
          access: 'Edit Access',
          notifications: 'Edit Notifications',
          permissions: 'Edit Permissions',
        },
      },
      actions: {
        deactivateCateringPartnerAccount: {
          deactivate: {
            button: 'Deactivate User',
            header: 'Deactivate User',
            content:
              'This user will be removed from all associated stores and will stop receiving notifications. They will be unable to log into ezManage and will be marked as deactivated in Freedom.',
            submit: 'Deactivate User',
            dismiss: "Don't Deactivate",
            success: '{{name}} was successfully deactivated.',
            error: 'Sorry, something went wrong! Please refresh the page and try again.',
          },
          revoke: {
            button: 'Revoke Invitation',
            header: 'Revoke Invitation',
            content:
              'Revoking this invitation means this user can no longer accept their invitation. If you want to invite this user again in the future, you will need to contact us.',
            submit: 'Revoke Invitation',
            dismiss: "Don't Revoke",
            success: "We’ve revoked {{name}}'s invitation. The account is deactivated.",
            error: 'Sorry, something went wrong! Please refresh the page and try again.',
          },
          tooltip: {
            brandAdmin:
              "You can't deactivate a brand admin account. Please contact support for help.",
            missingStores:
              "You can't deactivate a user attached to stores you do not have access to.",
          },
        },
        resendInvitation: {
          button: 'Resend Invitation',
          error: {
            header: 'Oh crumbs! Something went wrong with this invitation.',
            body: 'Please refresh the page and try again. If the problem continues, contact support.',
          },
          success: "We've resent {{name}}'s invitation.",
          tooltip: {
            brandAdmin:
              "You can't resend an invitation to a brand admin. Please contact support for help.",
            missingStores:
              "You can't resend an invitation to a user attached to stores you do not have access to.",
          },
        },
        reactivate: {
          button: 'Reactivate User',
          header: 'Reactivate User',
          content:
            'This user will receive an invitation to reactivate their ezManage account. The invitation will expire in 14 days.',
          submit: 'Send Invitation',
          dismiss: 'Cancel',
          error: {
            header: 'Oh crumbs! Something went wrong.',
            body: 'Please refresh the page and try again. If the problem continues, contact support.',
          },
          success: '{{name}} has been sent an email to reactivate their account.',
          tooltip: {
            brandAdmin:
              "You can't reactivate a brand admin account. Please contact support for help.",
            missingStores:
              "You can't reactivate a user attached to stores you do not have access to.",
          },
        },
        invite: {
          button: 'Invite to ezManage',
          header: 'Invite to ezManage',
          content:
            'This user will receive an invitation to create an ezManage account. The invitation will expire in 14 days.',
          submit: 'Send Invitation',
          dismiss: 'Cancel',
          error: {
            header: 'Oh crumbs! Something went wrong.',
            body: 'Please refresh the page and try again. If the problem continues, contact support.',
          },
          success: '{{name}} was successfully invited to use ezManage.',
          tooltip: {
            brandAdmin: "You can't invite a brand admin account. Please contact support for help.",
            missingStores: "You can't invite a user attached to stores you do not have access to.",
          },
        },
      },
    },
    DeliveryManagement: {
      deliveries: {
        titleTag: 'Deliveries - ezManage',
        deliveriesTimelineHeader_one: '{{count}} Delivery',
        deliveriesTimelineHeader_other: '{{count}} Deliveries',
        deliverySetup: {
          NO_RESPONSE: 'No response',
          NONE: 'No',
          REQUIRED: 'Yes',
        },
        deliveryValidationErrorsHelp:
          'Please call ezCater at 1-800-488-2085 to get this fixed before assigning a driver.',
        driverInfoCardLabel: 'Driver',
        driverInfoCardEzDispatchLabel: 'ezDispatch',
        driversSummaryPanel: {
          panelTitle: '{{date}} available drivers',
          assignedDeliveriesButtonLabel_one: '{{count}} delivery',
          assignedDeliveriesButtonLabel_other: '{{count}} deliveries',
        },
        dropoffInstructionsPlaceholder: 'No delivery instructions',
        feedbackModal: {
          button: 'View Photo & Feedback',
          title: 'Delivery Photo & Feedback',
          photoText: 'Setup Photo',
          noPhotoText: 'Driver did not attach a photo',
          feedbackText: {
            liked: 'How did this delivery go?',
            dropoffLocation: 'Where was the food delivered?',
            message: 'Notes about this delivery.',
          },
        },
        requestEzDispatch: {
          modalToggler: 'Request ezDispatch',
          modalSubmitLabel: 'Request ezDispatch',
          modalDismissLabel: 'Never mind',
          modalHeaderText: 'Request ezDispatch',
          modalSummaryOne:
            'ezDispatch lets you hand delivery off to ezCater’s vetted network of reliable delivery providers.',
          modalSummaryTwo:
            'The customer pays you your standard delivery fee. You pay {{deliveryCharge}} for ezDispatch, and tips go to the driver.',
          modalSummaryTwoDefault:
            'The customer pays you your standard delivery fee. You pay 10% of the order subtotal with a $30 minimum for ezDispatch, and tips go to the driver.',
          learnMoreLabel: 'Learn more about ezDispatch',
          nonCreditCardOrderErrorMessage:
            'ezDispatch is currently only available for orders paid with a credit card.',
          genericErrorMessage:
            'There was an unexpected error when validating this order. Please refresh the page and try again.',
        },
      },
      drivers: {
        titleTag: 'Drivers - ezManage',
        table: {
          title: 'Drivers',
          subtitle_one: '{{count}} driver',
          subtitle_other: '{{count}} drivers',
          actions: {
            addNewDriverLabel: 'Add new driver',
          },
          smsNotificationsColumn: {
            statusOptedOut: 'No',
            statusOptedIn: 'Yes',
            statusOptInPending: 'Pending',
            optedOutTooltip:
              'This driver has opted out of SMS notifications and will not receive text messages for the deliveries that they are assigned. To opt back in, drivers must text START to 1-855-699-0551.',
            optInPendingTooltip:
              'Driver has not yet accepted the terms for receiving SMS notifications. This can be achieved by following the SMS link sent to them upon their first assignment, downloading the app, or texting START to 1-855-699-0551.',
          },
        },
        driverDeleteModal: {
          successFlashMessage: 'Driver successfully deleted',
          serverErrorMessage: 'There was an error deleting the driver. Please try again later.',
        },
      },
      driverEdit: {
        newDriverTitleTag: 'New driver - ezManage',
        newDriverTitle: 'Add new driver',
        editDriverTitleTag: 'Edit driver - ezManage',
        editDriverTitle: 'Edit driver',
        phoneHelperText:
          'To change the driver phone number, please delete the existing driver profile and add a new driver with the updated information.',
        storeSelectHelperText:
          'If the driver is removed from a store, they will be unassigned from any future deliveries and will not receive notifications about them or about this change.',
      },
      reporting: {
        titleTag: 'Reporting - ezManage',
        title: 'Reporting',
        timeRangeOptions: {
          currentWeek: 'Time: Current week',
          lastWeek: 'Time: Last week',
          twoWeeks: 'Time: Last 2 weeks',
          oneMonth: 'Time: Last 1 month',
          threeMonths: 'Time: Last 3 months',
          sixMonths: 'Time: Last 6 months',
          oneYear: 'Time: Last year',
        },
        deliveriesTable: {
          title: 'Deliveries',
          subtitle_one: '{{count}} delivery',
          subtitle_other: '{{count}} deliveries',
          headings: {
            date: 'Date',
            orderNumber: 'Order #',
            driver: 'Driver',
            eventTime: 'Event Time',
            deliveryCompleted: 'Delivery Completed',
            distance: 'Distance',
            tip: 'Tip',
          },
        },
        deliveriesStat: {
          title: 'Deliveries Assigned to a Driver',
          subtitle: '{{assignedCount}} of {{totalCount}}',
          at100PercentCurrentWeekDescription:
            'This week every delivery order is assigned a driver. Keep it up, this makes you a top-performing partner with deliveries.',
          at100PercentDescription:
            'In the last {{timePeriod}}, every delivery order was assigned a driver. This makes you a top-performing partner with deliveries.',
          over65under100PercentDescription:
            'Aim for 100% driver assignments to deliver the best possible customer experience and improve your ratings.',
          under65Percent:
            'Stand out from the competition by assigning drivers to more deliveries. Customers will receive SMS updates that let them know when to expect their food.',
          zeroDescription:
            'Assigning drivers to delivery orders allows for customers to recieve SMS updates on their delivery, leading to better customer experience and ratings.',
        },
        videoBlockTitle: 'Assign a driver in seconds.',
        videoBlockDescription:
          'When delivering orders, easily assign a driver from the Orders page or following instructions on the order print-out.',
      },
    },
    DeliveryPerformanceReporting: {
      filters: {
        allStoresOption: 'All stores',
        includeEzDispatchLabel: 'Include ezDispatch',
        selectStore: 'Select a store',
        storeSelectLabel: 'Stores',
        timeRangeSelections: {
          lastSevenDays: 'Last 7 days',
          lastThirtyDays: 'Last 30 days',
          lastSixtyDays: 'Last 60 days',
          lastNinetyDays: 'Last 90 days',
        },
        timeRangeLabel: 'Time range',
      },
      title: 'Delivery reporting',
      summary: {
        fullyTracked: {
          title: 'Fully tracked',
          description: 'These orders were fully tracked.',
        },
        partiallyTracked: {
          title: 'Partially tracked',
          description:
            'Orders are missing an event such as dropoff or have timestamps too close together to represent the full delivery.',
        },
        untracked: {
          title: 'Untracked',
          description: 'We received no tracking records for these deliveries.',
        },
        howToTrack: {
          title: 'How to track orders',
          subTitle: 'Three ways to track an ezCater order:',
          use: 'Use',
          useOur: 'Use our',
          links: {
            ezDispatch: 'ezDispatch',
            deliveryApp: 'delivery app',
            deliveryApi: 'delivery API',
          },
        },
        onTimeDelivery: {
          title: 'On-time delivery',
          description:
            'An order is <strong>on time</strong> if it is delivered in the 15 minutes before the event time.',
        },
        veryEarlyDelivery: {
          title: 'More than 15 minutes early',
          description:
            'Orders delivered more than 15 minutes before the event time are <strong>not on time.</strong>',
        },
        lateDelivery: {
          title: '1-15 minutes late',
          description:
            'Orders delivered anytime 1-15 minutes after the event time are considered <strong>late.</strong>',
        },
        veryLateDelivery: {
          title: 'More than 15 minutes late',
          description:
            'Orders delivered over 15 minutes after the event time are considered <strong>very late.</strong>',
        },
      },
      orders: {
        label: 'Orders table',
        fallbackValues: {
          driverName: 'None listed',
        },
        columns: {
          orderNumber: 'ORDER #',
          tracking: 'TRACKING',
          driver: 'DRIVER',
          eventDate: 'EVENT DATE',
          pickedUp: 'DELIVERY START',
          droppedOff: 'DELIVERY COMPLETE',
          customerEventTime: 'CUSTOMER EVENT TIME',
        },
        trackingStatuses: {
          FULLY_TRACKED: 'Fully tracked',
          PARTIALLY_TRACKED: 'Partially tracked',
          UNTRACKED: 'Untracked',
          OUTSOURCED: 'Outsourced',
          OVERTURNED: 'Overturned',
        },
        tooltipDescriptions: {
          FULLY_TRACKED: 'This order was fully tracked.',
          PARTIALLY_TRACKED:
            'This order is missing an event such as <br /> dropoff, or the timestamps are too close <br /> together to represent the full delivery time.',
          UNTRACKED: 'We received no tracking records for this order.',
          OUTSOURCED:
            'You used a third party to deliver this order <br /> outside of our delivery service.',
          OVERTURNED: 'This orders tracking status was overturned <br /> based on your appeal.',
        },
      },
    },
    EditAccountAccess: {
      accountStoresList: {
        title: 'Stores this user can access',
        subtitle_one: '{{storeCount}} store',
        subtitle_other: '{{storeCount}} stores',
        emptyState: {
          title: 'This user does not have access to any stores',
          subtitle:
            'Select stores and add access for this user. Users without store access will not see data for any stores in ezManage.',
        },
        headers: {
          nickname: 'Store Nickname',
          storeNumber: 'Store Number',
          address: 'Address',
        },
        removal: {
          callToAction: 'Remove',
          confirmRemoval: {
            header: 'Remove Access',
            content:
              "This user will no longer be able to see {{storeName}} - {{storeNumber}} in their account, and no longer have access to that store's data.",
            submit: 'Remove Access',
            dismiss: 'Cancel',
          },
          error: 'Unable to remove access to this store. Try again or contact support.',
          success: 'The user has had their access to the store removed.',
        },
        brandAdminAlert: {
          headline: 'This user is a Brand Admin',
          tagline:
            "Brand Admins always have access to all stores in a brand. Stores can not be added or removed from this user's account unless you set them to a Standard User in Permissions.",
        },
      },
      allStoresList: {
        title: 'Add access to more stores',
        subtitle_one: '{{storeCount}} store',
        subtitle_other: '{{storeCount}} stores',
        storeSelection_one: '{{storeCount}} store selected',
        storeSelection_other: '{{storeCount}} stores selected',
        addStores: {
          callToAction: 'Add Access',
          success_one:
            'Access added for {{storeCount}} store. Notifications will be sent by default. You can make changes in Notification Settings.',
          success_other:
            'Access added for {{storeCount}} stores. Notifications will be sent by default. You can make changes in Notification Settings.',
          failure: 'Unable to add access. Try again in a few minutes.',
        },
        headers: {
          nickname: 'Store Nickname',
          storeNumber: 'Store Number',
          address: 'Address',
        },
        emptyState: {
          title: 'This user has access to all stores',
          subtitle: "All available stores have been added to this user's account.",
        },
        search: 'Filter stores',
        clearFilters: 'Clear filters',
        emptySearch: {
          title: 'No stores match your search',
          subtitle: 'Clear filters and try again',
          clear: 'Clear Filters',
        },
      },
    },
    EditAccountContactMethods: {
      title: 'Edit Contact Methods',
      backToUserLabel: 'Back to {{userName}}',
      backToAccountLabel: 'Back to Account',
      sidePanel: {
        headers: {
          storeAccess: 'Store access',
          userType: 'User Type',
        },
        storesSubtitle_one: '{{storeCount}} store',
        storesSubtitle_other: '{{storeCount}} stores',
        accountType: {
          unrestricted: 'Brand Admin',
          standard: 'Standard User',
        },
      },
      headers: {
        contactMethods: 'Contact Methods',
        emailAddresses: 'Email Addresses',
        phoneNumbers: 'Phone Numbers',
        phoneNumber: 'Phone Number',
        typeOfNumber: 'Type of Number',
        fax: 'Fax Number (optional)',
      },
      subheaders: {
        contactMethodsSelfEdit: 'How ezCater sends notifications or contacts you',
        contactMethods: 'How ezCater sends notifications or contacts this user',
        emailAddresses: 'ezCater will send email notifications to this email address',
        phoneNumber:
          'ezCater will call and text notifications to this phone number. You may opt out at any time by replying STOP.',
        auth0Message: 'In order to edit your email, please log out and back in',
      },
      placeholders: {
        emailAddress: 'Add another email address (optional)',
        phoneNumber: 'Add a phone (optional)',
        fax: 'Fax',
      },
      actions: {
        saveChanges: 'Save Changes',
      },
      phoneLabels: {
        PHONE: 'Phone',
        MOBILE: 'Mobile',
        WORK: 'Work',
        HOME: 'Home',
        OFFICE: 'Office',
        KITCHEN: 'Kitchen',
        CATERING: 'Catering',
        STORE: 'Store',
        DIRECT_ENTRY: 'Direct Entry',
      },
      validationErrors: {
        phoneNumber: 'Please enter a valid 10-digit phone number',
        email: 'Please enter a valid email address',
        fax: 'Please enter a valid 10-digit fax number',
      },
      formSubmission: {
        error:
          'Unable to update your contact methods. Try again in a few minutes or contact support.',
        success: 'Contact methods updated.',
      },
    },
    EditDemographicData: {
      backToAccountSettingsLabel: 'Back to Account Settings',
      backToStoreSettingsLabel: 'Back to Store Settings',
      selectStoresTitle: 'Manage demographic info across stores',
      selectStoresSubtitle:
        'You can update this information for multiple stores at once. Choose the stores you want to edit below.',
      selectStoresSideCard: {
        title: 'How ezCater uses demographic information',
        body: 'Our goal is to better understand our network and help customers find different businesses through the use of filters and carousels. This data is never shared without your consent and you may opt to keep this information private.',
        linkText: 'Learn more',
      },
      form: {
        subheading:
          'Our goal in collecting demographic data is to better understand our network and amplify small businesses and restaurant owners from underrepresented groups with search filters and carousels. You may opt to keep this data private and we will not share it without your consent. For more information on this program, please visit our ',
        questions: {
          ownershipCategory: "Which best describes your restaurant's business structure?",
          ownershipPercentage: "Which best describes your restaurant's majority ownership?",
          smallBusiness: 'Is your restaurant a small business with under $13.5 million in revenue?',
          smallBusinessSubtext:
            'For limited-service restaurants, the Small Business Administration defines a small business as one with annual receipts under $13.5 million.',
          gender: 'How does your owner(s) describe their gender identity? (select all that apply)',
          race: 'How does your owner(s) describe their racial/ethnic background? (select all that apply)',
          lgbtqPlusCommunity:
            'Is your owner(s) a member of the Lesbian, Gay, Bisexual, Transgender (LGBTQ+) community?',
          disability:
            'Does your owner(s) have a disability or chronic condition that substantially limits one or more of their major life activities?',
          veteran: 'Is your owner(s) a veteran or active member of the United States Armed Forces?',
          disabledVeteran: 'If yes, is the owner(s) a service-disabled veteran?',
          certification:
            'Has your organization been certified as a diverse business by a federal, state, local or third-party organization?',
          certificationSubtext:
            'Check with your state government to learn about your certification options.',
          certificationDetails: 'If yes, please share your certification designation:',
          consentForDataUse:
            'I consent to ezCater sharing this information externally on its platform and in marketing efforts.',
        },
        questionHeadings: {
          ownershipStructure: 'OWNER STRUCTURE',
          businessSize: 'BUSINESS SIZE',
          genderIdentity: 'GENDER IDENTITY',
          raceEthnicity: 'RACE AND ETHNICITY',
          lgbtqPlusCommunity: 'LGBTQ+ COMMUNITY',
          disability: 'DISABILITY STATUS',
          veteran: 'VETERAN STATUS',
          certification: 'CERTIFICATION STATUS',
        },
        responses: {
          independentEntity: 'An independent entity',
          corporateOwned: 'Owned by a parent corporation',
          groupFranchiseOwned: 'Owned by a franchise group',
          independentFranchiseeOwned: 'Owned by an independent franchisee',
          singleMajorityOwner: '1 person owns at least 50%',
          dualOwners: '2 people each own 50% each',
          dontKnowOwner: "I don't know who owns the business",
          noMajorityOwner: 'There is no majority owner',
          yes: 'Yes',
          no: 'No',
          declineToAnswer: 'Decline to answer',
          man: 'Man',
          nonBinary: 'Non-binary',
          woman: 'Woman',
          asianNhPi: 'Asian, Native Hawaiian, or Pacific Islander',
          blackAfrican: 'Black or African descent',
          hispanicLatinxSpanish: 'Hispanic, Latine, or Spanish',
          indigenousAmericanIndianOrAlaskaNative: 'Indigenous, American Indian, or Alaska Native',
          middleEasternOrNorthAfrican: 'Middle Eastern or North African',
          whiteEuropean: 'White or European',
          other: 'A different description',
          yesVeteran: 'Yes, they are a veteran or active member',
          noVeteran: 'No, they are not a veteran or active member',
        },
        sectionHeadings: {
          businessDetails: 'Business details',
          ownerDetails: 'Owner details',
          ownerDetailsSubtitle:
            'Answer on behalf of the person who owns at least 50% of the business, franchise, or franchise group. If there are two owners who each own 50%, answer for both and select all that apply.',
        },
        flashMessages: {
          success: 'Your demographic info has been saved.',
          error: 'There was an error submitting your demographic info. Please try again later.',
        },
        consentSubtitle:
          'By submitting this information, I attest to its truthfulness and accept responsibility for keeping it updated.',
        submitButton: 'Save changes',
        cancelButton: 'Cancel',
        cancelModal: {
          header: 'Discard changes',
          dismissLabel: 'Stay on this page',
          submitLabel: 'Yes, exit without saving',
          body: 'Do you want to exit this page without saving your responses?',
        },
      },
    },
    EditAccountPermissions: {
      title: 'Edit Permissions',
      links: {
        backToAccountsList: 'Back to users & permissions',
        backToStore: 'Back to Store',
      },
      accountDetails: {
        userType: {
          title: 'User Type',
          brandAdmin: 'Brand Admin',
          standardUser: 'Standard User',
        },
      },
      permissionsUpdate: {
        inProgress: 'Saving...',
        completed: 'Changes saved!',
      },
      permissionsContent: {
        brandAdmin: {
          title: 'Brand Admin',
          description:
            'This user always has complete control over all stores in this brand. They can see and do everything for all stores. This user will be authorized to make changes to any stores and brand information when contacting ezCater support.',
          requestChanges:
            'To change this user to a Standard User and customize their permission levels, or to remove this user entirely, <contactLink>contact Partner Success</contactLink> or call <phoneLink>{{updateEzManageSettingsPhoneNumber}}</phoneLink>.',
        },
        standardUser: {
          title: 'Standard User permissions',
          deliveryManagement: {
            title: 'Delivery Management',
            subtitle: 'Permissions to view deliveries and manage driver profiles',
            canViewDeliveryManagement: 'Enable Delivery Management',
          },
          orders: {
            title: 'Orders',
            subtitle: 'Permissions to see orders and ways this user can process those orders',
            canViewOrders: 'View the Orders page',
            canPerformOrderActions: 'Accept and reject orders',
            canViewOrderPrices: 'See prices on orders',
            canViewDirectEntry: 'Create Direct Entry orders',
            subSection: {
              title: 'On the Orders page, this user can:',
            },
            directEntry: {
              canAddCustomLineItems: 'Add discounts and fees',
              canAddCustomMenuItems: 'Add custom menu items',
              subSection: {
                title: 'When creating a direct entry order, this user can:',
              },
            },
            directConnect: {
              canViewDirectConnectMessages: 'See order messages from customers',
              canWriteDirectConnectMessages: 'Send order messages to customers',
            },
          },
          payments: {
            title: 'Payments',
            subtitle: 'Viewing payments and payment details',
            canViewPayments: 'View the Payments page',
          },
          performance: {
            title: 'Performance',
            subtitle: 'Viewing store performance over time',
            canViewPerformance: 'View the Performance page',
          },
          promos: {
            title: 'Promotions',
            subtitle: 'Viewing and creating promotions for ezO and Marketplace orders',
            canManagePromos: 'View the Promotions page',
          },
          demographicData: {
            title: 'Demographic Info',
            subtitle: 'Viewing and changing your demographic info settings',
            canViewDemographicData: 'View the Demographic Info page',
          },
          rankings: {
            title: 'Marketing Tools',
            subtitle: 'Viewing and changing your search ranking settings',
            canViewRankings: 'View the Marketing Tools page',
            canEditRankingsSettings: 'Update ezRewards and Preferred Partner Program settings',
            subSection: {
              title: 'On the Marketing Tools page, this user can:',
            },
          },
          integrations: {
            title: 'Integrations',
            subtitle: 'Setting up external integrations',
            canCreatePublicApiCredentials:
              'Authorized to create credentials for external integrations',
            modal: {
              title: 'Enable Integrations Permission',
              body: 'Are you sure you want to enable Integrations permission? Enabling this permission will disable all other permissions.',
              submitLabel: 'Enable',
              dismissLabel: 'Dismiss',
            },
          },
          reports: {
            title: 'Reports',
            subtitle: 'Viewing and creating reports about orders and financials',
            canViewReports: 'View the Reports page',
          },
          reviews: {
            title: 'Reviews',
            subtitle: 'Viewing customer reviews from ezMarketplace orders',
            canViewReviews: 'View the Reviews page',
          },
          settings: {
            title: 'Settings',
            subtitle: 'Viewing and changing brand or store settings',
            canViewStoreSettings: 'View the settings page',
            canRequestUpdatesStoreSettings: 'Request changes to settings',
            canEditStoreSettings: 'Make changes to settings',
            subSection: {
              title: 'On the Settings page, this user can:',
            },
          },
        },
      },
      disabledToggleTooltip: "You don't have access to edit this permission",
    },
    EditHolidayClosures: {
      backLink: 'Back to Store Settings',
      formSubtitle:
        "By checking the boxes below your store won't show up in customer searches on our marketplace for the selected days.",
      formTitle: 'Add Holiday Closures (Recurring)',
    },
    GuidedOnboarding: {
      navItems: {
        dashboard: 'Dashboard',
        onboardingChecklist: 'Onboarding checklist',
        hoursAndDelivery: 'Hours & delivery',
        storeAndContactInfo: 'Store & contact info',
        paymentInfo: 'Payment info',
        menu: 'Menu',
      },
      header: {
        title: {
          default: 'Welcome, {{name}}!',
          storeAndContactInfo1: 'Store & contact info (1 of 2)',
          storeAndContactInfo2: 'Store & contact info (2 of 2)',
          hoursAndDelivery1: 'Hours & delivery (1 of 2)',
          hoursAndDelivery2: 'Hours & delivery (2 of 2)',
          paymentInfo1: 'Payment info (1 of 2)',
          paymentInfo2: 'Payment info (2 of 2)',
          menu: 'Menu',
        },
        subtitle: {
          default: 'Let’s get your restaurant listed and taking your first orders.',
        },
        addMoreStores: 'Add more stores',
        breadcrumb: 'Back to dashboard',
      },
      formLevelError: 'An error occurred while submitting the form',
      submissionModal: {
        title: 'Almost done!',
        body: 'Thanks for providing your store info! Our team will build out your store on the ezCater marketplace. This should only take a few days. We’ll reach out to you if we have any questions. If you have any questions in the meantime, please email ',
        cancelButton: 'Cancel',
        submitButton: 'Submit',
      },
      forms: {
        next: 'Next',
        finish: 'Finish',
        saveAndReturnLater: 'Save & return later',
        backButtonLabel: 'Back',
        Menu: {
          title: 'Menu',
          description:
            "Please provide your catering menu below. If you'd like to offer individually packaged items that aren't on your catering menu, provide that as well. You can upload files, provide links, or both.",
          learnMore: 'Learn more about our menu requirements',
          requirement: 'Your restaurant cannot go live on ezCater without a menu, so please',
          atMinimum: 'at a minimum',
          requirementEnd: 'either upload or provide a link to your menu.',
          option1Title: 'Option 1: Menu links',
          option1Description: 'Copy and paste the entire URL (for example, https://www.menu.com)',
          addAnotherUrl: 'Add another URL',
          option2Title: 'Option 2: Upload menu files',
          fileSizeLimit: 'Files cannot exceed 10 MB.',
          dragAndDrop: 'Drag and drop or',
          selectFile: 'select a file',
          filesAdded: '{{count}} files added',
          utensilsTitle: 'Do you charge for utensils?',
          utensilsRequired: 'Utensils response is required',
          utensilsFree: 'Utensils are free',
          utensilsFee: 'Utensils are included for a fee (per person)',
          perPerson: 'per person',
          packagingTitle: 'How is your food packaged for customers?',
          packagingRequired: 'Packaging response is required',
          packagingIndividual: 'Items are individually packaged',
          packagingTrays: 'Our food is delivered in trays and platters',
          packagingVaries: "Our packaging varies by item. I'll detail this below.",
          packagingDetailsTitleOptional: 'Packaging details (optional)',
          packagingDetailsTitleRequired: 'Packaging details (required)',
          packagingDetailsDescription:
            "If there's anything the menu team should know about how your food is packaged, please let us know.",
          packagingDetailsDescriptionIndividual:
            "If there's anything the menu team should know about how your food is packaged, please let us know.",
          packagingDetailsDescriptionTrays:
            'Please include the serving size details for your trays (for example, 10 servings per tray, 8 servings per platter).',
          packagingDetailsDescriptionVaries:
            'Please provide details of which items or menu sections are individually packaged. For trays and platters, provide serving size details (for example, 10 servings per tray, 8 servings per platter).',
          packagingDetailsRequired: 'Packaging details are required.',
          dietaryTitle: 'Dietary details (optional)',
          dietaryDescription:
            "If it's not already clear on your menu, please indicate which items are appropriate for customers with particular dietary requirements. Which items on your menu are:",
          catererNotesTitle:
            'Do you have a desired go-live date, or any additional details you would like to share with our onboarding team? (optional)',
          catererNotesDescription:
            "If you don't provide a desired go-live date, your store will be live on our marketplace within 3 business days.",
          dietaryVegetarian: 'Vegetarian',
          dietaryVegan: 'Vegan',
          dietaryGlutenFree: 'Gluten-free',
          dietaryHalal: 'Halal',
          dietaryKosher: 'Kosher',
          menuLinksUrlValidation: 'Please enter a valid URL',
          menuFilesLabel: 'Upload menu files',
          menuFilesSelected: '{{count}} files selected',
          foodPhotos: 'Do you have great photos of your menu items you can upload now?',
          foodPhotosUploadTitle: 'Upload your menu photos',
          foodPhotosUploadDescription:
            "Menus with photos convert up to 60% more. If you have photos of your menu items, upload them now. If you don't have photos ready, you can upload or send them later.",
          foodPhotosUploadButton: 'Upload photos',
          linkOrFileRequired: 'At least one menu link or menu file is required',
          optionRequired: 'Option 1 or 2 required',
        },
        Delivery: {
          title: 'Delivery settings',
          disclaimer:
            'You can change your delivery settings anytime, and can use our 3rd-party delivery network for any order, regardless of what you select above. ',
          learnMoreLinkCopy: 'Learn more',
          ezDispatch: {
            label: 'Would you like ezCater to deliver all of your orders?',
            yes: 'Yes',
            no: 'No',
            validation: {
              required: 'Delivery settings are required',
              orderMinimum: 'Order minimum must be $300 or less',
              orderMinimumRequired: 'Order minimum is required',
              pickupInstructionsMax: 'Pickup instructions must be less than 1000 characters',
            },
            description1:
              "We offer delivery through our ezDispatch network of 3rd-party drivers. Each time you accept an order, we'll assign a driver for you.",
            description2:
              "Delivery fees are added to the customer's total. The ezDispatch fee is 10% of the order subtotal, with a minimum fee of $30. The amount you pay to ezCater is offset by the delivery fee paid by the customer, as shown in ",
            description3:
              'Business catering customers expect tracking and delivery updates for orders, we offer our partners the ability to meet this tracking standard through our app, our delivery API, or through use of ezDispatch. Restaurants will incur a $2.25 fee for each untracked order.',
            ezDispatchExampleLinkCopy: 'examples on our ezDispatch pricing page',
            orderMinimumLabel: 'ezDispatch order minimum',
            orderMinimumDescription:
              'This is the minimum order amount you’ll accept. Order minimums must be $300 or less.',
            orderMinimumPlaceholder: '$',
            pickupInstructionsLabel: 'Pickup instructions (optional)',
            pickupInstructionsDescription:
              'This will be provided to the driver for any order you choose to deliver through ezDispatch.',
          },
          deliveryFeesType: {
            label: 'How will you set delivery fees?',
            description1: 'Select the best option for your delivery fees.',
            description2:
              'If you want to offer free delivery, choose fixed-rate, and set your delivery range and order minimum with a fee of $0.',
            validation: {
              required: 'Delivery fees type is required',
            },
            options: {
              addTierLabel: 'Add a tier',
              maxTiersLabel: '(max 5 tiers)',
              removeTierLabel: 'Remove',
              fixed: {
                label: 'Fixed-rate',
                description: 'Charge a set fee based on the distance drivers travel.',
                whatToKnowHeader: 'What to know about fixed-rate fees',
                whatToKnowDescription1:
                  'Delivery ranges vary widely. In a major metro area, .5 miles may be appropriate. Set your distances with drive time in mind.',
                whatToKnowDescription2:
                  "We may reduce your delivery area based on what's appropriate for your metro area, or to comply with local laws and regulations.",
                whatToKnowDescription3: 'Lower order minimums and fees will bring in more orders.',
                whatToKnowDescription4:
                  "If you use ezCater's delivery network for an order, we'll set customer fees based on these settings.",
                whatToKnowDescription5Note: 'Note',
                whatToKnowDescription5:
                  'Order minimums must be $300 or less, and the maximum delivery distance for an order is 50 miles.',
                tableLabel: 'Example of a fixed-rate fee structure',
                tableHeaders: {
                  tier: 'Tier',
                  deliveryRange: 'Delivery range',
                  orderMinimum: 'Order minimum',
                  deliveryFee: 'Delivery fee',
                },
                deliveryRangeUnits: 'miles',
                exampleBreakdownText1: 'For delivery within',
                exampleBreakdownText2: 'the order must be at least',
                exampleBreakdownText3: 'and the delivery fee will be',
                exampleBreadownCategories: {
                  deliveryRange: 'Max. delivery range',
                  orderMinimum: 'Order minimum',
                  deliveryFee: 'Delivery fee',
                },
                tiers: {
                  labels: {
                    tier: 'Tier',
                    deliveryRange: 'Max. delivery range',
                    orderMinimum: 'Order minimum',
                    deliveryFee: 'Delivery fee',
                  },
                  placeholders: {
                    deliveryRange: '5 miles',
                    orderMinimum: '$50',
                    deliveryFee: '$0',
                  },
                  validations: {
                    required: {
                      deliveryRange: 'Delivery range is required',
                      orderMinimum: 'Order minimum is required',
                      deliveryFee: 'Delivery fee is required',
                    },
                    min: 'Value must positive number',
                  },
                },
                validation: {
                  required: 'At least one tier is required',
                },
              },
              percent: {
                label: 'Percent of food',
                description: 'Charge a percentage based on the order subtotal.',
                whatToKnowHeader: 'What to know about percentage-based fees',
                whatToKnowDescription1:
                  'Tiers can be especially important when charging a percentage. Consider reducing the percentage as orders get bigger.',
                whatToKnowDescription2:
                  "We may reduce your delivery area based on what's appropriate for your metro area, or to comply with local laws and regulations.",
                whatToKnowDescription3: 'Lower order minimums and fees will bring in more orders.',
                whatToKnowDescription4:
                  "If you use ezCater's delivery network for an order, we'll set customer fees based on these settings.",
                whatToKnowDescription5Note: 'Note',
                whatToKnowDescription5:
                  'Order minimums must be $300 or less, and the maximum delivery distance for an order is 50 miles.',
                tableLabel: 'Example of a percentage-based fee structure',
                tableHeaders: {
                  tier: 'Tier',
                  orderMinimum: 'Order minimum',
                  deliveryFee: 'Delivery fee (% of order)',
                  deliveryRange: 'Delivery range',
                },
                deliveryRangeUnits: 'miles',
                exampleBreakdownText1: 'For orders of',
                exampleBreakdownText2: "or more, I'll charge",
                exampleBreakdownText3: 'for delivery, and deliver up to',
                exampleBreadownCategories: {
                  orderMinimum: 'Order minimum',
                  deliveryFee: 'Delivery fee (% of order)',
                  deliveryRange: 'Max. delivery range',
                },
                tiers: {
                  labels: {
                    tier: 'Tier',
                    orderMinimum: 'Order minimum',
                    deliveryFee: 'Delivery fee (% of order)',
                    deliveryRange: 'Max. delivery range',
                  },
                  placeholders: {
                    deliveryRange: '5 miles',
                    deliveryFee: '0%',
                    orderMinimum: '$50',
                  },
                  validations: {
                    required: {
                      deliveryRange: 'Delivery range is required',
                      orderMinimum: 'Order minimum is required',
                      deliveryFee: 'Delivery fee is required',
                    },
                    min: 'Value must positive number',
                    max: 'Value must be less than 100',
                  },
                },
              },
              other: {
                label: 'Other',
                description: 'Use custom maps or a different fee structure? Tell us what you need.',
                inputLabel:
                  "Describe how you set your fees. We'll reach out with questions or confirmation of your settings.",
                validations: {
                  required: 'Other reason is required',
                },
              },
            },
          },
        },
        businessInfoForm: {
          registeredBusinessAddress1: 'Registered business address',
          registeredBusinessAddress2: '(it appears on box 1 of your W-9)',
          taxIdentificationNumber: 'Tax identification number (EIN or TIN)',
          registeredBusinessName1: 'Registered business name',
          registeredBusinessName2: '(as it appears on the W-9)',
          legalEntityType: 'Type of legal entity',
          fieldsRequired: 'All fields are required unless marked optional.',
          registeredBusinessInfo:
            'Your registered business information is necessary for us to establish payments to you.',
          businessInfo: 'Business information',
          validations: {
            legalEntityTypeRequired: 'Legal entity type is required',
            businessNameRequired: 'Business name is required',
            taxIdRequired: 'Tax ID is required',
            taxIdFormat: 'Tax ID must be a 9 digit number',
          },
        },
        businessInfoFormTwo: {
          bankingInfo: 'Banking information',
          paymentAccount:
            'We will send payments to this account, so be sure to double-check your information.',
          fieldRequired: 'All fields are required unless marked optional.',
          checkingAccountInfo: 'Bank account info',
          bankName: 'Bank name',
          bankAccountType: 'Account type',
          bankAccountTypeChecking: 'Checking',
          bankAccountTypeSavings: 'Savings',
          routingNumber: 'Routing number',
          bankAccountNumber: 'Bank account number',
          confirmBankAccountNumber: 'Reconfirm bank account number',
          accountHolderName: 'Account holder name',
          accountHolderInfo: 'Account holder info',
          accountHolderStreetAddress: 'Account holder street address',
          accountHolderStreetAddressTwo: 'Account holder street address 2 (optional)',
          accountHolderCity: 'Account holder city',
          accountHolderState: 'Account holder state',
          accountHolderZipCode: 'Account holder zip code',
          validations: {
            bankNameRequired: 'Bank name is required',
            routingNumberRequired: 'Routing number is required',
            routingNumberInvalid: 'Routing number must be exactly 9 digits',
            routingNumberStartInvalid: 'Routing numbers must start with 0-3',
            bankAccountNumberRequired: 'Bank account number is required',
            bankAccountNumberInvalid: 'Bank account number must be between 4 and 17 digits',
            reconfirmBankAccountNumberRequired: 'Reconfirm bank account number is required',
            bankAccountNumbersDoNotMatch: 'Bank Account Numbers Entered Do Not Match',
            accountHolderNameRequired: 'Account holder name is required',
            accountHolderZipCodeInvalid:
              'Account holder zip code must be in format 12345 or 12345-6789',
          },
          accountHolder: 'Account holder ',
        },
        hoursOfOperation: {
          title: 'Hours of operation',
          sendOrderDescription:
            'This information will be visible to customers and used by ezCater to send you orders.',
          selectTime: 'Select a time',
          description:
            'These are the hours your restaurant is open for business. Customers will see these hours when placing orders.',
          fieldsRequired: 'All fields are required.',
          advanceNotice: 'How far in advance do you need to know about orders?',
          cutoffTime: "What's your day before cutoff time?",
          followingDayCutoffTime:
            'The latest time in a day we can send you orders for the following day',
          deliveryHours: 'What are your delivery hours?',
          deliveryNotice:
            'Note: if you use ezDelivery, food must be ready up to 30 minutes before the order. Adjust your opening hours if you need time to account for this.',
          copyButton: 'Copy',
          pickUpOrder: 'Can customers pick up orders themselves?',
          pickUpHoursDifferent:
            'Are your customer pickup hours different from your delivery hours?',
          pickUpHoursSame: 'No, theyre the same',
          pickUpHours: 'Yes, our takeout hours are different',
          yes: 'Yes',
          monday: 'Monday',
          tuesday: 'Tuesday',
          wednesday: 'Wednesday',
          thursday: 'Thursday',
          friday: 'Friday',
          saturday: 'Saturday',
          sunday: 'Sunday',
          closed: 'Closed',
          openTime: 'Open time',
          closeTime: 'Close time',
          validation: {
            noticeType: {
              required: 'Please select how far in advance you need to know about orders',
            },
            noticeInMinutes: {
              required: 'Please select when you need notice for orders',
            },
            cutoffTime: {
              required: 'Please select a cutoff time',
            },
            deliveryHours: {
              required: 'Please set your delivery hours',
            },
            pickupHours: {
              required: 'Please set your pickup hours',
            },
            open: {
              required: 'Please select if the store is open',
            },
            from: {
              required: 'Please select opening time',
            },
            to: {
              required: 'Please select closing time',
            },
            pickup: {
              required: 'Please select if customers can pick up orders',
            },
            pickupDiff: {
              required: 'Please select if pickup hours are different from delivery hours',
            },
          },
        },
        contactInfo: {
          title: 'Contacts',
          description: 'All fields are required unless marked optional.',
          storeContactInfoSection: {
            title: 'Store contact info',
            description: "We'll use this to reach you about orders and customer service questions.",
            phoneField: {
              label: 'Phone number',
              description: "Number for the physical store, not an individual person's contact",
              validation: {
                required: 'Phone number is required',
                invalid: 'Invalid phone number',
              },
            },
            emailField: {
              label: 'Store email address (optional)',
            },
          },
          personalContactFields: {
            firstNameField: {
              label: 'First name',
              validation: {
                required: 'First name is required',
              },
            },
            lastNameField: {
              label: 'Last name',
              validation: {
                required: 'Last name is required',
              },
            },
            jobTitleField: {
              label: 'Job title',
              validation: {
                required: 'Job title is required',
              },
            },
            phoneField: {
              label: 'Phone number (optional)',
              validation: {
                invalid: 'Invalid phone number',
              },
            },
            emailField: {
              label: 'Email address',
            },
            phoneOrEmailValidation: 'Phone number or email address is required',
          },
          primaryContactInfoSection: {
            title: 'My contact info',
            description: 'Provide your contact information and select what roles you fill.',
            footer: {
              listTitle: "In ezManage, you'll be able to:",
              listItem1: 'Change store and account settings',
              listItem2: 'See billing information',
              listItem3: 'Accept and confirm orders',
              additionalInfo:
                'If you want to share any of these roles with others, add an additional contact below.',
            },
          },
          additionalContactSection: {
            title: 'Contact {{index}}',
            delete: 'Delete',
            permissionsLabel: 'In ezManage, this person should be able to (select all that apply):',
            changeStoreAndAccountSettings: 'Change store and account settings',
            seeBillingInformation: 'See billing information',
            acceptAndConfirmOrders: 'Accept and confirm orders',
          },
          addContact: 'Add contact',
          emailAlreadyUsed: 'Email addresses for store and contacts must be unique',
        },
        StoreInfo: {
          title: 'Location',
          description1: 'Which specific location are you adding to ezCater?',
          description2: 'All fields are required unless marked optional.',
          brandName: {
            label: 'Brand name',
            validation: {
              required: 'Brand name is required',
            },
          },
          storeNickname: {
            label: 'Store nickname (optional)',
            helperText: 'If you have multiple stores, this label will help distinguish them',
          },
          storeNumber: {
            label: 'Store number (optional)',
            helperText: 'If you number your stores, we can reflect that in data views',
          },
          catererWebsite: {
            label: 'Website',
            helperText:
              'Provide the entire URL most relevant to this location (for example, https://www.store.com)',

            validation: {
              url: 'Please enter a valid URL',
              required: 'Website is required',
            },
          },
          addressInfo: {
            label: 'Store address',
            header: 'Address',
            lineOne: {
              label: 'Address line 1',
              validation: {
                required: 'Address line 1 is required',
              },
            },
            lineTwo: {
              label: 'Address line 2 (optional)',
            },
            city: {
              label: 'City',
              validation: {
                required: 'City is required',
              },
            },
            state: {
              label: 'State',
              placeholder: 'Select an option',
              validation: {
                required: 'State is required',
                oneOf: 'Must select valid state',
              },
            },
            zipCode: {
              label: 'ZIP code',
              validation: {
                valid: 'ZIP code not valid',
                required: 'ZIP code is required',
              },
            },
            validation: {
              required: 'Store address information is required',
            },
          },
          storeContactInfo: {
            label: 'Store contact info',
            validation: {
              required: 'Store contact information is required',
            },
          },
          phoneNumber: {
            label: 'Store phone number',
            validation: {
              valid: 'Invalid phone number',
              required: 'Phone is required',
            },
          },
          faxNumber: {
            label: 'Store fax number',
          },
          email: {
            label: 'Store email',
            validation: {
              email: 'Invalid email',
            },
          },
        },
      },
      steps: {
        resume: 'Resume',
        start: 'Start',
      },
      dashboard: {
        headerSection: {
          title: 'Drive growth with the #1 site for business catering!',
          description:
            'Join the marketplace where high-value, corporate customers find reliable restaurants and place large orders.',
        },
        buildingStoreInProgressSection: {
          title_one: 'We are building your new store at {{addresses}}',
          title_other: 'We are building your new stores at {{addresses}}',
          description:
            "We've got all the info we need to build your listing. This usually only takes a few days.",
          email: 'Email your onboarding specialist at ',
        },
        nextStepsPhotosSection: {
          title: 'Did you upload menu photos yet?',
          description: 'Good photos get orders.',
          uploadPhotos: 'Upload photos',
          bookPhotoSession: 'Book a free photo session',
        },
        otherNextStepsSection: {
          title: 'Get a strong start with ezCater',
          description: 'These video categories are key to getting started. We also have ',
          trainingWebinars: 'training webinars you can join.',
          recommendationFirst: 'Getting started with ezManage',
          recommendationSecond: 'Accepting & reconfirming orders',
          recommendationThird: 'Account & store settings',
        },
        questions: 'Questions?',
        questionsBody: 'Email your onboarding specialist at',
        faqs: [
          {
            question: 'How long is the onboarding process? When will I go live?',
            answer:
              'Once you have submitted all of the required onboarding information, typical turnaround time is 1 week. There are exceptions that require longer setups, in which case you will hear from a member of our onboarding team to discuss requirements and next steps.',
            detailLink: '',
            detailLinkText: '',
          },
          {
            question: 'Why should I put my restaurant on the ezCater marketplace?',
            answer:
              'ezCater is uniquely focused on connecting restaurants with large orders from workplace customers. We support you with a platform and services that make it easy to get and manage orders, deliver them, and promote your business to the largest nationwide network of catering buyers.',
            detailLink: '',
            detailLinkText: '',
          },
          {
            question: "What are ezCater's menu requirements?",
            answer:
              'We can work with you to craft a menu based on your online or PDF menu. We require that your catering menu include dish descriptions, serving sizes, packaging info, and indications of which dishes meet various dietary restrictions (vegan, gluten-free, vegetarian, kosher, etc), and that your prices match your in-store prices.',
            detailLink:
              'https://catering.ezcater.com/en/help/ezcater-marketplace/what-are-menu-best-practices',
            detailLinkText: 'View full menu requirements',
          },
          {
            question: 'What fees does ezCater charge?',
            answer:
              'Our standard commission for orders from the ezCater Marketplace is 15% of the order subtotal (meal and delivery cost). We also charge a 2.99% payment transaction fee that applies to meal subtotal, delivery, and tax. ',
            detailLink: 'https://catering.ezcater.com/en/help/selling-fees',
            detailLinkText: 'View full selling fee details',
          },
          {
            question: 'How do I receive orders?',
            answer:
              'When a customer orders from your restaurant on the ezCater marketplace, we will send you notifications by SMS, email, or through push notifications if you use our app. Orders are also immediately reflected in ezManage. You can choose who receives these notificatons during signup.',
            detailLink: 'https://catering.ezcater.com/en/help/ezmanage-tutorials',
            detailLinkText: 'Learn about accepting orders in ezManage',
          },
          {
            question: 'How do I get paid?',
            answer: 'We provide weekly payment by direct deposit.',
            detailLink:
              'https://catering.ezcater.com/en/help/knowledge/payment-billing/how-does-payment-work',
            detailLinkText: 'View payment information and resources',
          },
          {
            question: 'How much does ezDispatch cost?',
            answer:
              'The ezDispatch fee is 10% of the food subtotal, with a minimum of $30. However, you don’t pay this entire fee to ezCater. It’s offset by the delivery fees paid by the customer. If you choose to always use ezDispatch, you pay a commission of 15% of the delivery fee.',
            detailLink: 'https://catering.ezcater.com/en/help/ezdispatch-pricing',
            detailLinkText: 'View full ezDispatch pricing information',
          },
          {
            question: 'How will I manage my ezCater presence?',
            answer:
              'ezManage (our portal where you manage orders & settings) is available on desktop and mobile devices. You are also able to communicate with our team by SMS, phone, and email.',
            detailLink: '',
            detailLinkText: '',
          },
          {
            question: 'Can I pause orders if we reach our order limit or have to schedule closure?',
            answer:
              'We have capacity management and temporary closure tools within ezManage that you can use when you need them.',
            detailLink: '',
            detailLinkText: '',
          },
        ],
        onboardingSteps: {
          completed: {
            title: "Everything's ready! Submit your info.",
          },
          buttons: {
            resume: 'Resume',
            start: 'Start',
            finish: 'Finish',
          },
          status: {
            complete: 'Complete',
            inProgress: 'In progress',
            notStarted: 'Not started',
          },
          storeAndContactInfo: {
            title: 'Store & contact info',
            description: 'Provide location and contact details for your new store.',
          },
          hoursAndDelivery: {
            title: 'Hours & delivery',
            description: 'Set your delivery policies and hours of operation.',
          },
          paymentInfo: {
            title: 'Payment info',
            description: 'Provide business and banking info so we can send you payments.',
          },
          menu: {
            title: 'Menu',
            description: 'Provide your catering menu and pricing for ezCater orders.',
          },
        },
        timeline: {
          title: 'What to expect',
          steps: ['You provide store info', 'We build your store', 'You go live!'],
        },
      },
    },
    PersonalStoreGroupDetails: {
      actions: {
        backToGroupsList: 'Back to Groups',
        deleteStoreGroup: 'Delete Group',
        renameStoreGroup: 'Rename Group',
      },
      deleteStoreGroup: {
        dismiss: "Don't Delete",
        error: 'Unable to delete this group. Try again or contact support.',
        header: 'Delete Group',
        message:
          "Deleting this group is permanent and cannot be undone. Stores in this group will be removed from the group, and their data won't be affected.",
        submit: 'Delete Group',
      },
      renameStoreGroup: {
        dismiss: 'Cancel',
        inputLabel: 'Group Name',
        invalidNameError: 'Name this group',
        header: 'Rename Group',
        submit: 'Submit',
        submitFailedError: 'Unable to rename this group. Try again or contact support.',
      },
      groupStoresList: {
        title: 'Stores in this group',
        subtitle_one: '{{storeCount}} store',
        subtitle_other: '{{storeCount}} stores',
        emptyState: {
          title: 'This group doesn’t have any stores yet',
          subtitle:
            'Select stores and add them to this group. You can use groups to quickly view orders, reviews, or performance for multiple stores.',
        },
        headers: {
          nickname: 'Store Nickname',
          storeNumber: 'Store Number',
          address: 'Address',
        },
        actions: {
          removeStore: 'Remove',
        },
        errors: {
          headline: "Couldn't remove stores from this group",
          tagline:
            "We're sorry, but we're having trouble removing these stores from this group. Try again in a few minutes or contact our support team.",
        },
      },
      allStoresList: {
        title: 'Add stores to group',
        subtitle_one: '{{storeCount}} store available',
        subtitle_other: '{{storeCount}} stores available',
        emptyState: {
          title: 'All stores added to group',
          subtitle: 'All stores that you have access to are already in this group.',
        },
        storeSelection_one: '{{storeCount}} store selected',
        storeSelection_other: '{{storeCount}} stores selected',
        headers: {
          nickname: 'Store Nickname',
          storeNumber: 'Store Number',
          address: 'Address',
        },
        actions: {
          addStores: 'Add to group',
        },
        errors: {
          headline: "Couldn't add stores to this group",
          tagline:
            "We're sorry, but we're having trouble adding these stores to this group. Try again in a few minutes or <0>contact our support team</0>.",
        },
      },
    },
    OrderEntry: {
      EzDispatchWarningFlashMessage: {
        headline: 'This order has been accepted by ezDispatch.',
        message:
          'Editing the address, event date, and/or food items may require ezCater to reconfirm with the ezDispatch delivery partner.',
      },
      OrderEntryHeader: {
        buttons: {
          save: 'Save',
          cancel: 'Cancel',
          close: 'Close',
        },
        OrderTypeForm: {
          title: 'Order Type',
          close: 'Close',
          subtitle_incomplete: 'Edit order type',
          subtitle_complete:
            '$t(pages.OrderEntry.OrderEntryHeader.OrderTypeForm.types.{{ orderType }})',
          label: 'Order Type',
          description: 'Choose between Takeout and Delivery',
          placeholder: 'Order Type',
          ezDispatch: 'ezDispatch is now available for orders paid with a credit card!\n\n',
          ezDispatchDescription:
            'Request ezDispatch once the order has been placed.\n\nNote: Automatic ezDispatch enrollment does not apply to these orders. Request it each time you need it on Direct Entry orders.',
          types: {
            delivery: 'Delivery',
            takeout: 'Takeout',
            third_party_delivery: 'ezDispatch',
          },
          ezDispatchDisabledReason:
            'This order has been accepted by ezDispatch. We are unable to cancel ezDispatch once requested. Please contact 1-800-488-1803 with questions.',
        },
        AddressForm: {
          title: 'Where',
          close: 'Close',
          subtitle_incomplete: 'Edit event address',
          subtitle_complete:
            '{{ address.street }}, {{ address.city }}, {{ address.state }} {{ address.zip }}',
          label: 'Event Address',
          eventName: 'Event Name',
          eventNamePlaceholder: 'Event Name',
          name: 'Company or Location Name',
          namePlaceholder: "e.g. Dr. Smith's Office",
          street: 'Event Address',
          streetPlaceholder: 'Street and Number',
          street2Placeholder: 'Suite, unit, etc.',
          city: 'City',
          state: 'State',
          zip: 'Zip Code',
          addDeliveryContact: 'Add Delivery Contact',
          driverAskFor: 'Delivery Contact',
          phone: 'Phone',
          errors: {
            changedByServer:
              'This address was corrected from "{{oldValue}}". Please verify this new address is correct and save again',
            multipleAddresses: 'We found multiple matches. Please select the best address.',
          },
        },
        AddressSelectionModal: {
          header: 'Address Selection',
          message: 'We found multiple matches. Please select the best address.',
          cancel: 'Cancel',
        },
        CustomerForm: {
          title: 'Customer',
          close: 'Close',
          subtitle_incomplete: 'Edit customer',
          subtitle_complete: '{{firstName}} {{lastName}}',
          label: 'Customer Information',
          status: {
            customer: 'Customer',
            lead: 'Lead',
          },
          customerSearchPopup: {
            customers: 'Customers',
            leads: 'Leads',
          },
          fields: {
            email: {
              label: 'Email Address',
              description: '',
              placeholder: 'example@ezcater.com',
            },
            firstName: {
              label: 'First Name',
              description: '',
              placeholder: 'First Name',
            },
            lastName: {
              label: 'Last Name',
              description: '',
              placeholder: 'Last Name',
            },
            phone: {
              label: 'Phone Number',
              description: '',
              placeholder: '555-555-5555',
            },
            company: {
              label: 'Company',
              description: '',
              placeholder: 'Company',
            },
          },
        },
        OrderNotesForm: {
          title: 'Notes',
          label: 'Order Notes',
          subheading:
            'Please note: this is not a designated spot for credit card numbers or other sensitive information.',
          close: 'Close',
          kitchenInstructions: {
            placeholder: 'Notes for your kitchen staff. These will NOT be viewable by the customer',
            header: 'Kitchen Notes',
          },
          deliveryInstructions: {
            placeholder: 'Notes for your delivery driver. These will be viewable by the customer',
            header: 'Delivery Notes',
          },
          subtitleIncomplete: 'Edit order notes',
        },
        EventDateTimeForm: {
          title: 'When',
          subtitle_incomplete: 'Edit event date',
          subtitle_complete: '{{ date, ddd, M/DD}} @ {{ time, h:mm a }}',
          close: 'Close',
        },
        EventDateForm: {
          title: 'Event Information',
          label: 'Event Date',
          showCalendar: 'Show Calendar',
        },
        SimpleTimeForm: {
          label: 'Event Time',
          time: {
            earlier: 'Earlier',
            later: 'Later',
          },
        },
        Headcount: {
          title: 'Headcount',
          subtitle_incomplete: 'Edit headcount',
          subtitle_complete_one: '{{ headcount }} person',
          subtitle_complete_other: '{{ headcount }} people',
          name: 'headcount',
          label: 'Headcount',
          description: 'How many people will this order be serving?',
          placeholder: 'Headcount',
        },
      },
      NavigationBar: {
        breadcrumbs: 'Order > Order {{orderNumber}}',
        help: 'Get Help',
        order: 'Order {{orderNumber}}',
        saving: 'Saving',
        saved: 'Saved',
        backLink: 'Back to Orders',
        modifiedOrderBackLink: 'Back to Order',
        modifiedOrderBackLinkModal: {
          header: 'Stop editing order?',
          content:
            "You'll lose any changes you've just made. If you want to save your changes, continue editing and proceed to payment.",
          submit: 'Yes, go back to order',
          dismiss: 'Continue editing',
        },
      },
      OrderCart: {
        item: 'Item',
        quantity: 'Qty',
        price: 'Price',
        total: 'Total',
        noItems: 'You have no items in your cart.',
      },
      StoreSelector: {
        description: 'Which store should this order go to?',
        header: 'Store *',
        label: 'Store Select',
        heading: 'Choose store',
        placeholder: 'Select a Store',
        missingStoreErrorMessage: 'Please select a store',
        SwitchStoreAlert: {
          changeStores: 'Change Stores',
          cancel: 'Cancel',
          heading: 'Change Store',
          content:
            'Your selected menu items will be lost when you switch stores. Do you wish to continue?',
        },
      },
      sendQuoteForm: {
        title: 'Send Quote',
        success: 'Quote successfully sent',
        successFlashMesage:
          'Quote of <a>Order {{formattedOrderNumber}}</a> successfully sent to customer.',
        to: {
          placeholder: 'customer@gmail.com',
          label: 'To',
          requiredMessage: 'This field is required.',
          emailMessage: 'Must be a valid email address.',
        },
        replyTo: {
          placeholder: 'caterer@example.com',
          label: 'Reply To',
          requiredMessage: 'This field is required.',
          emailMessage: 'Must be a valid email address.',
        },
        cc: {
          placeholder: 'Enter emails separated by commas',
          label: 'Cc',
          errorMessage: 'Must be a valid email address. Separate multiple addresses by commas.',
        },
        subject: {
          placeholder: 'Enter email subject',
          label: 'Subject',
          default: 'Your catering quote from {{brand}}',
          requiredMessage: 'This field is required.',
        },
        message: {
          placeholder: 'Enter email message',
          label: 'Message',
          default:
            'Click the link below to view your quote from {{brand}}. Email us or call us at {{phone}} if you have questions or would like to finalize the order.',
        },
        customerPaymentMethod: {
          creditCard: 'Include link for credit card payment',
          externalPayment: 'In-store payment',
          houseAccount: 'House account',
          houseAccoutPlaceholder: 'Select House Account',
          createHouseAccount: 'Create House Account',
          ezDispatchTipHeader: 'ezDispatch is now available for orders paid with a credit card!',
          ezDispatchTipSubheader: 'Request ezDispatch once the order has been placed.',
        },
        previewQuote: 'Preview Quote',
        buttons: {
          edit: 'Edit Quote',
          quoteApproved: 'Approve Quote',
          deleteQuote: 'Delete Quote',
          sendQuote: 'Send Quote',
          cancel: 'Cancel',
        },
      },
      LegacyOrderBuilder: {
        OrderItems: {
          addMenuItem: '+ Add Menu Item',
          addOffMenuItem: '+ Add Custom Menu Item',
          columns: {
            item: 'Item',
            quantity: 'Qty',
            price: 'Price',
          },
          errors: {
            addingMenuItem: 'Please select an item or delete this entry.',
            editingMenuItem: 'Please finalize and save this entry.',
            loading: 'Please wait for your items to load.',
            minimumMenuItems: 'Please add at least one item.',
          },
          ItemForm: {
            delete: 'Delete',
            Quantity: {
              label: 'Quantity',
            },
            Name: {
              label: 'Item Name',
            },
            Price: {
              label: 'Price',
              placeholder: '$0.00',
            },
            Sizes: {
              inputGroupLabel: {
                volumePricing: 'Volume Pricing',
                dynamic: 'Select {{sizeLabel}}',
                static: 'Select Size',
              },
              size: {
                label: 'Serves {{serves}}',
                labelWithSize: '{{size}} (serves {{serves}})',
              },
            },
            Options: {
              warnings: {
                maxChoices: 'You have selected the max of $t(pluralize.choice) for this option.',
                minChoices: 'You must select a minimum of $t(pluralize.choice) for this option.',
              },
            },
            SpecialInstructions: {
              label: 'Special Instructions (optional)',
              placeholder: 'Special instructions for this menu item.',
            },
            submit: 'Save Item',
            SubQuantities: {
              '50': 'Half',
              '75': '3/4',
              '100': 'All',
            },
          },
          addingItemTooltip: 'You must save your most recent menu item before adding a new one.',
          missingStoreTooltip: 'You must select a store before adding a menu item.',
        },
        Tableware: {
          header: 'Tableware',
          save: 'Save',
          tablewareChoices: {
            includeLabel: 'Include:',
            doNotIncludeLabel: 'Do Not Include:',
          },
          specialInstructions: {
            label: 'Note:',
            placeholder: 'e.g. Plates for half headcount',
          },
        },
        Totals: {
          labels: {
            type: 'Line Item Type',
            name: 'Line Item Name',
            amount: 'Line Item Amount',
          },
          lineItems: {
            add: 'Add Discount or Fee',
            save: 'Save',
            cancel: 'Cancel',
            delete: 'Delete',
            error: 'One or more line items have errors',
            amountLabel: 'Amount',
          },
          placeholders: {
            type: 'Discount or Fee',
            name: 'Name of Discount or Fee',
          },
          selectionOptions: {
            discount: {
              key: 'Discount',
              text: 'Discount',
              value: 'DISCOUNT',
            },
            fee: {
              key: 'Fee',
              text: 'Fee',
              value: 'MISC_FEE',
            },
          },
        },
      },
      OrderBuilder: {
        header: {
          new: 'Create the order',
          modifyOrder: 'Modify Order {{orderNumber}}',
          modifyQuote: 'Modify Quote {{orderNumber}}',
        },
        menuPackage: 'Package: ',
        AddCustomMenuItem: {
          buttons: {
            addToOrder: 'Add to Order',
            addCustomMenuItem: 'Add Custom Menu Item',
          },
          nameLabel: 'Custom Item Name',
          descriptionLabel: 'Description (optional)',
          salesTaxCodeLabel: 'Category',
          salesTaxCodeSubheading: 'This is required for tax purposes',
          salesTaxCodeMiscFee: 'Miscellaneous Fee',
          placeholders: {
            name: 'Custom Menu Item Name',
            quantity: '#',
            price: '$0.00',
            specialInstructions: 'Special Instructions',
            salesTaxCode: 'Select a category',
          },
          validations: {
            salesTaxCodeRequired: 'Category is a required field',
          },
        },
        PastOrdersModal: {
          header: 'Order {{orderNumber}}',
          orderDetails: {
            address: 'Address',
            dateAndTime: 'Date & Time',
            expandedDateAndTime: '{{date}} at {{time}}',
            store: 'Store',
            headcount: 'Headcount',
            kitchenNotes: 'Kitchen Notes',
            deliveryNotes: 'Delivery Notes',
            foodItems: 'Food Items',
          },
          headcount: {
            people: '{{headcount}} people',
            person: '{{headcount}} person',
          },
          duplicate: 'Duplicate Order',
          duplicateOrderWarningLine1: 'Duplicate this order instead?',
          duplicateOrderWarningLine2: 'This will replace your current order.',
          cancel: 'Cancel',
          next: 'Next ›',
          previous: '‹ Previous',
          pagination: '{{currentPage}} of {{totalPages}}',
        },
        instructions: 'Select a store to get started building your order',
        OrderTotals: {
          subtotal: 'Subtotal',
          salesTax: 'Sales Tax',
          total: 'Total',
          negativeTotal:
            'Total amount must be greater than $0 including any ezDispatch or promotional fees.',
          discountOrFeesLabel: 'Discount / Fees',
          pricePerHead: 'Price Per Head',
          taxExempt: 'This order is tax exempt.',
          tip: {
            label: 'Tip',
            placeholder: '0.00',
          },
          deliveryFee: {
            label: 'Delivery Fee',
            placeholder: '0.00',
          },
        },
        MenuOrderItem: {
          addItem: 'Add {{itemName}} combination',
          missingMenuItemFlashMessage: {
            headline: 'Some items are no longer on the menu.',
            message: 'Please add them as custom or remove.',
          },
        },
        MenuSelection: {
          MenuSearch: {
            placeholder: 'Filter menu by item name',
          },
          MenuItem: {
            serves: 'Serves {{serves}}',
          },
        },
        OrderItem: {
          placeholders: {
            quantity: '#',
          },
          subtitle: {
            specialInstructions: 'Special Instructions: ',
          },
          removeItem: {
            tooltip: 'Remove Item',
          },
          remove: 'Remove',
          missingMenuItemTooltip: 'This item is no longer on the menu. Add it as custom or remove.',
          missingOptionOrChoiceTooltip: 'Some options are no longer on the menu.',
          missingOptionText: '{{optionName}} category no longer on the menu.',
          missingChoiceText: '{{optionName}} option no longer on the menu: {{choiceName}}.',
        },
        TransferItemToCustomItemButton: {
          text: 'Add as Custom',
        },
      },
      CartContents: {
        addMenuItem: '+ Add Menu Item',
        addingItemTooltip: 'You must save your most recent menu item before adding a new one.',
        missingStoreTooltip: 'You must select a store before adding a menu item.',
        unsavedOrderItem: 'Please save or delete this item to proceed.',
        missingOrderItems:
          'You must have at least ONE item in your cart before continuing. Please add an item to proceed.',
        DropdownSelector: {
          placeholder: 'Select a menu item or type to search',
        },
      },
      OrderNotes: {
        header: 'Order Notes',
        deliveryInstructions: {
          header: 'Delivery Notes',
          placeholder: 'Notes for your delivery driver. These will NOT be visible to the customer.',
        },
        kitchenInstructions: {
          header: 'Kitchen Notes',
          placeholder: 'Notes for your kitchen staff. These will NOT be visible to the customer.',
        },
      },
      PageActions: {
        sendQuote: 'Send Quote',
        saving: 'Saving',
        saved: 'Saved',
      },
    },
    EzDispatchPreferences: {
      title: 'ezDispatch Configuration',
      heading: 'Choose when ezDispatch will deliver your orders',
      introduction:
        "If there are conditions under which you want to always have orders delivered through ezDispatch, set those rules below. Even with these rules, you can always choose to have any order delivered with ezDispatch. If you're Interested in Automatic ezDispatch for all of your orders, complete the form <a>here</a>.",
      saveButton: 'Save changes',
      toggleLabel: 'Active',
      comparatorOptions: {
        GREATER_THAN: 'Greater than',
        LESS_THAN: 'Less than',
      },
      form: {
        flash: {
          successMessage: 'Your changes have been saved successfully.',
          errorMessage: 'There was an error submitting your changes. Please try again.',
        },
        validations: {
          required: 'Field is required',
          invalidNumberFormat: 'Value must be a number',
          DELIVERY_DISTANCE: {
            valueMax: "Distance can't be more than than 19 miles",
            valueMin: "Distance can't be a negative number",
          },
          EVENT_LEAD_TIME: {
            valueMin: 'Value must be greater than your store lead time',
            valueMax: 'Value exceeds maximum allowed time',
          },
          ORDER_SIZE: {
            valueMax: "Subtotal can't be more than $999,000",
            valueMin: "Subtotal can't be a negative amount",
          },
          TIME_OF_DAY: {
            dayOfWeekLimit: 'Cannot have more than 3 rules per day',
            endTimeFormatInvalid: 'End time is invalid',
            endTimeLessThanStartTime: 'End time must be after start time',
            startTimeFormatInvalid: 'Start time is invalid',
          },
        },
      },
      DeliveryDistance: {
        title: 'Delivery distance',
        subtitle:
          'Have ezDispatch deliver orders that are more than a certain distance from your location. As a reminder, ezCater’s maximum delivery distance is 20 miles.',
        ruleValueRootAriaLabel: 'Open select for delivery distance',
        ruleValuePrefix: 'More than',
        ruleValueSuffix: 'miles',
      },
      LeadTime: {
        title: 'Lead time',
        subtitle:
          "Have ezDispatch deliver orders within a period close to your restaurant's minimum lead time.",
        ruleValueAriaLabel: 'Select lead time',
        ruleValueRootAriaLabel: 'Open select for lead time',
        storeLeadTimeAlertOne: "Your store's minimum lead time is ",
        storeLeadTimeAlertTwo: '. You can edit this in ',
        valueOne: 'Have ezDispatch deliver orders that come between ',
        valueTwo: ' and ',
        valueThree: ' before the requested delivery time.',
      },
      TimeOfDay: {
        addRule: 'Another window',
        title: 'Time of day',
        subtitle:
          'Have ezDispatch handle all orders that need delivery during particular time windows. You can create up to 3 windows per day. Delivery windows you set here will not impact your operating hours, which are in your store settings.',
        dayOfWeekLabel: 'Select schedule day of week for row {{position}}',
        dayOfWeekRootAriaLabel: 'Open select for row {{position}} scheduling day of week',
        dayOfWeekTopLabel: 'Day of the week',
        endTimeLabel: 'Select schedule end time for row {{position}}',
        endTimeRootAriaLabel: 'Open select for row {{position}} scheduling end time',
        endTimeTopLabel: 'End time',
        removeRuleAriaLabel: 'Remove window for row {{position}}',
        removeRuleSmallLabel: 'Remove window',
        scheduleFrom: 'from',
        scheduleTo: 'to',
        startTimeLabel: 'Select schedule start time for row {{position}}',
        startTimeRootAriaLabel: 'Open select for row {{position}} scheduling start time',
        startTimeTopLabel: 'Start time',
      },
      MinimalLeadTimeAlert: {
        title: 'These settings are unavailable based on your minimum lead time',
        subtitle:
          'ezDispatch partners require a minimum of 90 minutes lead time. Your restaurant accepts orders with a minimum of {{formattedLeadTime}} lead time.',
        instructions:
          "To use any of these settings, you'll need to change your minimum lead time to 90 minutes or more in your ",
        storeSettings: 'store settings',
      },
      OrderSize: {
        title: 'Order size',
        subtitle:
          'Have ezDispatch deliver orders with a food and drink subtotal above or below a certain value.',
        comparatorSelectLabel: 'Greater or less than',
        comparatorRootAriaLabel: 'Open select for order size comparator',
        subtotalLabel: 'Subtotal',
      },
      ThirdPartyDeliveryOnly: {
        title: 'You use ezDispatch for all orders',
        subtitle:
          'The settings on this page are disabled because they do not apply to your store, which uses ezDispatch for all orders.',
      },
    },
    EzOrderingMarketing: {
      title: 'ezOrdering',
      header: 'ezOrdering',
      subheader: 'Catering sales on your website',
      heroBody:
        'Catering customers want to order online. Put the best ordering experience on your website to get (and keep) their business.',
      ctaButton: 'Sign Up Today',
      tripleBoxes: {
        one: {
          header: 'Built to sell catering',
          bodyOne: "We've spent years solving the complexities of catering orders.",
          bodyTwo:
            'Our catering ordering solution is used by more people than any other on the planet.',
        },
        two: {
          header: 'Growth from your site & ours',
          bodyOne: 'Online ordering boosts sales through your site. ezOrdering boosts it further.',
          bodyTwo:
            'It improves your search ranking on the ezCater Marketplace, so you get more orders there too.',
        },
        three: {
          header: 'Support you get nowhere else',
          bodyOne: 'When customers need help, our 5-star service team handles it.',
          bodyTwo:
            'If you want help delivering orders, get professional catering delivery on demand with ezDispatch.',
        },
      },
      moreTools: {
        header: 'Access more of ezCater’s tools',
        one: {
          strong: 'Get help with',
          strongLinkText: 'delivery',
          body: 'ezDispatch is our network of professional delivery providers. You can get drivers on demand for your ezOrdering orders.',
        },
        two: {
          strong: 'Create custom',
          strongLinkText: 'promotions',
          body: 'Get access to our Promotions tool in ezManage to create and run promotions on your ezOrdering site',
        },
        three: {
          strong: 'Apply custom colors.',
          body: 'Talk to our team about branding your ezOrdering page.',
        },
      },
      benefits: {
        one: {
          strong: 'Risk-free to join.',
          body: 'There’s no fine print or long-term commitment. Stop any time you want.',
        },
        two: {
          strong: 'You pay nothing until you get an order.',
          body: 'There’s a 7% commission on orders you accept – less than half our marketplace rate.',
        },
        three: {
          strong: 'Lock in the reduced commission.',
          body: 'When people who are new to ezCater order through your website, you lock in the ezOrdering rate on all their orders. Forever. Even orders from the ezCater Marketplace.',
        },
        four: {
          strong: 'We do all the work.',
          body: 'Our web experts can add ezOrdering to your website, optimized to give catering customers one-click access to online ordering.',
        },
      },
      footerHeader: 'Getting started is easy and setup is free',
      hubspotForm: {
        header: 'Get started with ezOrdering',
        submittedHeader: 'Thanks for reaching out.',
        message: 'Fill out the form below and a member of our team will be in touch soon.',
        submit: 'Submit',
        cancel: 'Cancel',
        success: 'Success! A member of our team will be in touch soon.',
      },
      contactTeam: 'Sign Up Today',
    },
    Onboarding: {
      header: "Let's get you started, {{userName}}!",
      subheader: 'Here are the steps to get your restaurant listed and taking your first orders.',
      topCard: {
        firstLine: 'Thanks for your interest! We’re excited to grow together.',
        secondLine:
          "If you want to connect with high value corporate customers who place large, frequent orders, there's no better partner than ezCater.",
        thirdLine: 'Watch this welcome video to learn how your restaurant can grow with ezCater.',
      },
      steps: {
        step1: {
          header: 'Provide your store information to an onboarding specialist',
          body: "If you haven't spoken to an onboarding specialist yet, check for an email from our team inviting you to connect and get started.",
        },
        step2: {
          header: 'Tell us how to pay you',
          body: 'Provide business and banking information to establish how you’ll receive payments. This form should take about 10 minutes.',
        },
        step3: {
          header: 'We’ll set up your menu and store page',
          body: 'We’ll get all the details of your listing posted as our Menu Mavens construct your catering menu on ezCater.',
        },
        step4: {
          header: 'Upload or schedule photos',
          body1: 'Good photos get orders. Learn how to',
          body2: 'book a photo session',
          body3: 'or get guidance on',
          body4: 'sending us your own photos.',
        },
        step5: {
          header: 'Go live on ezCater!',
          body: 'We’ll email you when your store is ready and listed on the marketplace.',
        },
      },
      solutions: {
        header: 'ezCater solutions',
        subheader: 'We make it easy to capture more catering orders and find new customers.',
        marketplace: {
          header: 'Explore our marketplace',
          body1: 'Tap into the',
          body2: 'largest business catering marketplace',
          body3: 'in the US',
        },
        ezOrdering: {
          header: 'Explore ezOrdering',
          body1: 'Take catering orders on your site easily',
          body2: ', using our technology and service.',
        },
        relish: {
          header: 'Serve whole workplaces with single deliveries',
          body1: 'Relish, our recurring lunch service',
          body2: ', brings you regular bulk orders',
        },
        learnMore:
          'Want more information? Your ezCater rep can answer questions and get you signed up.',
      },
      integrations: {
        header: 'Get started with ezCater integrations',
        subheader:
          'Streamline your ezCater orders through integrations with your existing tech stack.',
        olo: {
          header: 'Olo',
          body: 'Simplify sales and inventory processes by removing manual re-entry.',
        },
        checkmate: {
          header: 'Checkmate',
          body: 'Pass data directly between ezCater and Checkmate order records.',
        },
        learnMore: 'Learn more about our integrations',
      },
    },
    OperationalMetrics: {
      title: 'Operational Metrics',
      storeDropdownLabel: 'Change Store',
      downloadReport: 'Export',
      downloadError: 'Sorry, there was an error downloading your report.',
      tabs: {
        operationalMetricsLabel: 'Overview',
        operationalMetricsAccessibilityLabel: 'Operational Status',
        helpCenterLabel: 'Help center',
      },
      tableHeaders: {
        store: 'Store',
        storeNumber: 'Store number',
        rejectPercentRolling90Days: 'Rejected orders',
        cancelPercentRolling90Days: 'Canceled orders',
        responsivenessPercentRolling90Days: 'On-time acceptance',
        foodReadyPercentRolling90Days: 'Ready for ezDispatch',
        trackedDeliveryPercentRolling90Days: 'Delivery updates',
        ontimePercentRolling90Days: 'On-time delivery',
        orderAccuratePercentRolling90Days: 'Order accuracy',
        adjustedAvgStarRating: 'Star rating',
        orderCount: 'Order count',
        status: 'Status',
        reliabilityRockstar: 'Reliability Rockstar',
      },
      storeNotFound: 'Store not found.',
      operationalCards: {
        header: 'Your performance for the past 90 days',
        subheader:
          "These stats give a daily update of how you're meeting ezCater's standards for reliability.",
        goal: 'Goal:',
        belowStandard: 'Below standard',
        aboveStandard: 'Above standard',
        noData: 'No data',
        notApplicable: 'Not applicable',
        goalText: {
          higher: '% or higher',
          lower: '% or lower',
          equal: '%',
          nonPercent: ' or higher',
        },
      },
      banner: {
        title: 'Become a more reliable caterer',
        description:
          'How is your reliability measured? Why does it matter? We’ll answer these questions and more.',
        link: 'Deep dive on operational metrics',
      },

      alertBanner: {
        storeNumber: `<strong>Store #{{storeReference}} is temporarily paused on the ezCater marketplace</strong>
        <br/>
          `,
        storeAddress: `<strong>Store located at {{storeReference}} is temporarily paused on the ezCater marketplace</strong>
        <br/>`,
        first:
          'This store is unable to accept new marketplace orders, because it has fallen below our reliability standards for rejections, cancellations, and/or timeliness.',
        firstWithReason:
          'This store is unable to accept new marketplace orders because it has fallen below our reliability standards for {{reason}}.',
        secondary: `
        <br/>
        <br/>
        ezCater's Catering Partner Operations Team can help you get back on track.
        <br/>
        <br/>`,
        link: 'Why is your store paused?',
        belowLink: `
        <br/>
        <br/>
        <strong>All stores are still responsible for fulfilling previously placed orders.</strong>`,
        workRampLmsBlurb: {
          aboveLink: `
          <br/>
          <br/>
          If you would like to come off pause, please click this `,
          linkText: 'link',
          belowLink: ` to enroll into our course on {{reason}}. Once you have completed the course this store location will become automatically unpaused shortly afterwards.`,
        },
        pauseContactUsBlurb: {
          pauseCountTypes: {
            second: 'Second',
            caterer: 'Caterer',
          },
          aboveLink: `
            <br/>
            <br/>
            Your location will remain on pause until you reach out to the Catering Partner Operations Team at `,
          belowLink: ` to set up a meeting with us. We look forward to using this time to
            understand how we can best support you in becoming more reliable on
            our platform. Please email us with the following information:
            <br/>`,
          listItems: `
            <br/>
            <li>Specific Subject Line: {{pauseCount}} Pause Meeting</li>
            <li>Name of brand</li>
            <li>Location that is paused</li>
            <li>Your role at this location</li>
            <li>Reason for {{pauseCountLowerCase}} pause</li>
            `,
          belowList: `
            With this information, our team will be in touch to set up a meeting
            and discuss what changes need to be made in order for you to be
            reinstated on our platform.
            <br/>
            <br/>`,
          decommissionWarning: `
            As a reminder, when a location is paused for a third time, that
            location will be decommissioned from our platform and no longer
            able to operate on ezCater. In the event you fall below our
            reliability thresholds a third time, a member of our team will reach
            out to confirm your decommission.
            `,
        },
        pauseDecommissionBlurb: {
          aboveLink: `
            <br/>
            As this is the third time this location has been paused
            for {{reason}}, they are in line to be decommissioned and
            removed from the ezCater platform.
            <br/>
            <br/>
            If you have any questions regarding your store’s status, please
            reach out to the Catering Partner Operations Team at `,
        },
      },
      warningBanner: {
        storeNumber: `<strong>Store #{{storeReference}} is at risk of being temporarily paused on the ezCater marketplace</strong>
        <br/>
        `,
        storeAddress: `<strong>Store located at {{storeReference}} is at risk of being temporarily paused on the ezCater marketplace</strong>
        <br/>`,
        first:
          'This store is close to falling below our reliability standards due to order cancellations, rejections, and/or timeliness. Its performance could result in it being unable to accept new marketplace orders.',
        firstWithReason:
          'This store is close to falling below our reliability standards for {{reason}}, which could result in it being unable to accept new marketplace orders.',
        secondary: `
        <br/>
        <br/>
        Still have questions? ezCater's Catering Partner Operations Team can help you get back on track.
        <br />
        <br />`,
        link: 'Why are you seeing this warning?',
      },
      drawerInfo: {
        cancelPercentRolling90Days: {
          title: 'Canceled orders',
          infoAlert: 'A cancellation by the customer will <p>not</p> count against your total.',
          textAboveAlert: `Accepting and then canceling a customer's order is extremely damaging to your reliability.
          <break/><break/>
          Unless you are a high-volume caterer handling over 100 orders per month, even a single cancellation will cause you to fall below standard.`,
        },
        rejectPercentRolling90Days: {
          title: 'Rejected orders',
          textAboveAlert: `Manage your capacity proactively by using the tools in ezManage. You'll ensure that you only get orders you can handle - and don't have to reject any.
          <break/><break/>
          Unless you are a high-volume caterer handling over 100 orders per month, even a single rejection will cause you to fall below standard.`,
        },
        responsivenessPercentRolling90Days: {
          title: 'On-time acceptance',
          infoAlert:
            "Orders placed outside of normal operating hours don't count against your response time.",
          textAboveAlert: `Orders should be accepted within 15 minutes of being placed (during operating hours). The fastest way to see and respond to orders is by using the ezManage iOS app.`,
        },
        foodReadyPercentRolling90Days: {
          title: 'Ready for ezDispatch',
          textAboveAlert: `Percentage of orders which are ready at the scheduled pickup time. <strong>Remember that the pickup time can change even the morning of the delivery, so be sure to check for updates.</strong>
            <break/><break/>
            When using ezDispatch, any delivery issues after handoff to the driver do not count against your reliability.`,
        },
        orderAccuratePercentRolling90Days: {
          title: 'Order accuracy',
          textAboveAlert: `Total % of orders for which no customer issues have been reported.
            <break/><break/>
            Keep an eye out for the most common issues:
            <break/><break/>
            <list>
              <listItem>Missing food</listItem>
              <listItem>Missing utensils</listItem>
              <listItem>Food bad or inedible</listItem>
              <listItem>Packaging bad or damaged</listItem>
              <listItem>Dietary requests not accommodated</listItem>
            </list>`,
        },
        trackedDeliveryPercentRolling90Days: {
          title: 'Delivery tracking',
          textAboveAlert: `Total % of orders that:
            <break/>
            <list>
            <listItem>Have an assigned driver</listItem>
            <listItem>Have delivery status updates recorded for the order</listItem>
            <listItem>Are fully and accurately tracked from pickup through delivery</listItem>
            </list>
            <break/>
            For details, <a>visit delivery reporting</a>.`,
          textAboveAlertOld: `Total % of orders that have both an assigned driver and delivery status updates recorded on the order.`,
        },
        ontimePercentRolling90Days: {
          title: 'On-time delivery',
          infoAlert:
            "<primary>ezDispatch orders:</primary> You're only responsible for handing off the order <secondary>to the driver</secondary> on time. If the delivery is late because of traffic or any other reason thereafter, <secondary>it won't count against your on-time delivery score.</secondary>",
          textBelowAlert: `On-time delivery means a handoff to the customer at any point during the 15-minute window that we provide to our catering partners. Both early and late deliveries count against your reliability.`,
        },
        adjustedAvgStarRating: {
          title: 'Star rating',
          infoAlert:
            "If you're new to ezCater, we'll use Yelp reviews to calculate this rating. Once you start to get reviews from ezCater customers, we'll use that rating.",
          textAboveAlert: `You need an average customer rating of 4.8 stars or higher. We use data from the past 90 days to calculate your star rating. This ensures that you are able to make improvements over time.
          <break/><break/>
          Our highest-rated restaurants tend to:
          <break/><break/>
          <list>
            <listItem>Deliver orders on time</listItem>
            <listItem>Provide excellent service from receipt of the order through delivery</listItem>
            <listItem>Deliver exactly what the customer ordered</listItem>
            <listItem>Remember to include tableware</listItem>
            <listItem>Keep your menu up to date</listItem>
            <listItem>Have the right photos for products</listItem>
          </list>`,
        },
      },
      OpsCtaCard: {
        rejection: {
          helperTitle: 'AVOID REJECTION',
          title: `<strong>Capacity</strong> <br/> management`,
          description:
            "Tell us how many orders you want per day.  We'll give you the option to stop new orders when you've hit the limit.",
          linkText: 'Set daily capacity',
        },
        cancellation: {
          helperTitle: 'AVOID CANCELING',
          title: `<strong>Holiday</strong> <br/> availability`,
          description:
            "Are you closed for recurring holidays? Once you set them, you'll no longer receive orders for those days.",
          linkText: 'Set holiday closures',
        },
        onTimeAcceptance: {
          // adds extra space that an image would normal take
          helperTitle: `<br/>IMPROVE RESPONSIVENESS`,
          title: `Use the <br/> <strong>ezManage app</strong>`,
          description:
            "When you use the ezManage iOS app, you'll be notified as soon as an order comes through and can instantly accept.",
          linkText: 'Set holiday closures',
        },
        readyForDispatch: {
          helperTitle: 'AVOID CANCELING',
          title: `<strong>ezDispatch</strong> is <br/> here to help!`,
          description:
            'Driver trouble? You don’t have to cancel that order. Request ezDispatch to save the day.',
          linkText: 'Understand how',
        },
        delivery: {
          helperTitle: 'HELPS DELIVERY',
          title: `<strong>In-house</strong> <br/> drivers`,
          description:
            'Set the table for successful deliveries with first-party drivers. Use the Driver app to provide delivery updates.',
          linkText: 'Assign drivers',
        },
        accuracy: {
          helperTitle: 'HELPS ACCURACY',
          title: `<strong>Pickup</strong> <br/> instructions`,
          description:
            'If using ezDispatch, let drivers know where to park and how to pick up their orders from your restaurant.',
          linkText: 'Add pickup instructions',
        },
      },
      bestPractices: {
        title: 'Take action to improve today',
        carousel: {
          dailyCapacity: {
            highlightedTitle: 'Capacity',
            normalTitle: 'management',
            description:
              "Tell us how many orders you want per day.  We'll give you the option to stop new orders when you've hit the limit.",
            linkText: 'Set daily capacity',
          },
          holidayClosures: {
            highlightedTitle: 'Holiday',
            normalTitle: 'availability',
            description:
              "Are you closed for recurring holidays? Once you set them, you'll no longer receive orders for those days.",
            linkText: 'Set holiday closures',
          },
          pickupEdit: {
            highlightedTitle: 'Pickup',
            normalTitle: 'instructions',
            description:
              'If using ezDispatch, let drivers know where to park and how to pick up their orders from your restaurant.',
            linkText: 'Add pickup instructions',
          },
          drivers: {
            highlightedTitle: 'drivers',
            normalTitle: 'In-house',
            description:
              'Set the table for successful deliveries with first-party drivers. Use the Driver app to provide delivery updates.',
            linkText: 'Add in-house drivers',
          },
        },
      },
      yellowCard: {
        title: 'What do the top-performing restaurants on ezCater have in common?',
        listItem1: 'Using <bold>capacity tools</bold> to prevent rejections and cancellations',
        listItem2: 'Inspecting every order for <bold>missing food items</bold> and utensils',
        listItem3: 'Checking for <bold>last-minute changes</bold> the morning of delivery',
      },
      recommendations: {
        title: 'Conquer common problem areas',
        orderAccuracy: {
          text: 'The #1 cause of order accuracy issues? Missing food and utensils.',
          linkText: 'Ensure order accuracy',
        },
        deliveryUpdates: {
          text: "When customers get real-time delivery updates, they don't need to call to check on their order status.",
          linkText: 'Start sending delivery updates',
        },
        onTimeRating: {
          text: 'Late deliveries are the most common customer complaint — but early deliveries are bad, too.',
          linkText: 'Improve your on-time rating',
        },
        capacityTools: {
          text: 'We offer a suite of tools to help you reduce rejections and cancellations — even prevent them entirely.',
          linkText: 'Plan ahead with capacity tools',
        },
      },
      orderDrillDownTable: {
        titles: {
          canceled: 'Orders that were canceled',
          rejected: 'Orders that were rejected',
          orderAccuracy: 'Orders with reported issues',
          trackedDelivery: 'All driver updates',
          foodReady: 'Orders not ready for ezDispatch',
          onTime: 'Delivery issues',
          responsive: 'Orders impacting your performance',
        },
        columns: {
          canceledAt: 'CANCELED AT',
          lateness: 'LATENESS',
          order: 'ORDER',
          orderDate: 'ORDER DATE',
          received: 'RECEIVED',
          accepted: 'ACCEPTED',
          timeToAccept: 'TIME TO ACCEPT',
          whoAccepted: 'WHO ACCEPTED',
          reason: 'REASON',
          rejectedBy: 'REJECTED BY',
          rejectedOn: 'REJECTED ON',
          rejectedReason: 'REASON',
          driverAssigned: 'DRIVER ASSIGNED',
          enRoute: 'EN ROUTE',
          delivered: 'DELIVERED',
          issue: 'ISSUE',
          orderIssues: 'ORDER ISSUES',
        },
        emptyState: {
          message:
            'There are no orders that are currently impacting your 90 day rolling performance.',
          learnMore: 'Learn more here',
        },
      },
      orderDrillDownReviews: {
        title: 'User reviews',
        noReviews: 'No reviews available at this time',
        viewAllReviews: 'View all',
      },
    },
    Promotions: {
      title: 'ezOrdering',
      emptyState: {
        title: 'ezOrdering',
        message:
          'Drive new and repeat business by offering your customers promo codes for free or discounted food.',
        button: 'Create ezOrdering promotion',
      },
      table: {
        title: 'ezOrdering',
        activeCount_one: '{{count}} active promotion',
        activeCount_other: '{{count}} active promotions',
        expiredCount_one: '{{count}} expired promotion',
        expiredCount_other: '{{count}} expired promotions',
        subtitle: '{{activeCount}} and {{expiredCount}} at your stores.',
        newPromoLabel: 'Create new ezOrdering promotion',
        nameCodeLabel: 'Promo name & code',
        storeLabel: 'Participating stores',
        storeCount: '{{count}} stores',
        redemptionsLabel: 'Redemptions',
        orderTotalLabel: '$ Orders',
        dateActiveLabel: 'Dates active',
        statusLabel: 'Status',
      },
      statusBadge: {
        activeText: 'Active',
        expiredText: 'Expired',
      },
    },
    PromotionNew: {
      infoText:
        'Use promo codes to offer customers a limited-time discount on orders. Discounts are applied to the food and beverage amount only.',
      infoLink: 'Learn more about ezOrdering Promotions.',
      title: 'Create new ezOrdering promotion',
      breadcrumb: 'Back to promotions',
      formTitle: 'Promotion details',
      infoAlert:
        'Your promotion will become active as soon as it is created. You can’t edit, delete, or reuse a promo code, but you can end a promotion at any time.',
      form: {
        nameField: {
          label: 'Name your promotion',
          helperText: 'This will appear in ezManage and on customer receipts.',
        },
        codeField: {
          label: 'Unique promo code ',
          helperText: 'Customers will enter this at checkout to claim the discount.',
        },
        amountField: {
          label: 'Discount per order',
          helperText: 'The promotion amount is applied to the food and beverage amount.',
          dollarAmount: 'Dollar amount',
          percentage: 'Percentage',
        },
        minimumField: {
          label: 'Minimum food and beverage amount (optional)',
        },
        scheduleSection: {
          heading: 'Schedule',
          subheading:
            'Your promotion will become active upon creation. For best distribution and tracking, we recommend running it for no more than 12 weeks.',
          expirationField: {
            label: 'Expiration date',
            helperText: 'Customers can apply the promotion to orders placed by this date.',
          },
          eligibleDaysField: {
            heading: 'Eligible delivery days',
            weekdays: 'Weekdays only',
            all: 'All 7 days',
          },
        },
        participatingStoresSection: {
          heading: 'Participating stores',
          all: 'All my stores',
          specific: 'Choose specific stores',
        },
        termsSection: {
          heading: 'Terms',
          checkboxLabel: 'I have read and agree to the terms.',
          termOne: 'ezCater does not fund or market these promotions.',
          termTwo:
            'The value of a promotion will be deducted from the food and beverage amount prior to taxes and fees.',
          termThree: 'Promotions are valid on ezOrdering orders, not ezCater Marketplace orders.',
          termFour: 'The promotion goes into effect once you create it.',
          termFive: 'Codes cannot be deleted, edited, or reused.',
          termSix: 'You can end a promo at any time.',
        },
        submitButton: 'Create promotion',
        cancelButton: 'Cancel',
        validations: {
          nameRequired: 'Promotion name is required',
          codeRequired: 'Promotion code is required',
          discountAmountPositive: 'Promotion value must be positive',
          discountAmountRequired: 'Promotion value is required',
          discountAmountInteger: 'Promotion value must be a whole number',
          orderMinimumPositive: 'Minimum Order Value must be positive',
          expiresOnRequired: 'End date is required',
          legalRequired: 'Your agreement is required',
          orderMinimumMin: 'Minimum order value must exceed promotion value',
          discountAmountPercentMax: 'Percent cannot exceed 100',
          eligibleDaysRequired: 'Eligible days is required',
          participatingStoresRequired: 'Participating stores is required',
        },
        MultipleSelectDropdowns: {
          addButtonFirst: 'Add',
          addButtonMultiple: 'Add Another',
          loading: 'Loading...',
          noResults: 'No Results',
          removeButton: 'Remove',
          searchPlaceholder: 'Search...',
        },
      },
      confirmationModal: {
        headerText: 'Are you sure your details are correct?',
        alert:
          'You won’t be able to edit a promotion once it’s live. Codes cannot be deleted, edited, or reused.',
        promotionName: 'Promotion name',
        uniquePromoCode: 'Unique promo code',
        discountPerOrder: 'Discount per order',
        minimumOrderAmount: 'Minimum food and beverage amount',
        expirationDate: 'Expiration date',
        eligibleDeliveryDays: 'Eligible delivery days',
        participatingStores: 'Participating stores',
        allStores: 'All my stores',
        storeCount_one: '{{count}} selected store',
        storeCount_other: '{{count}} selected stores',
        submitLabel: 'Confirm and create',
        dismissLabel: 'Go back',
      },
    },
    PromotionDetails: {
      endPromoSuccessMessage: 'The promo has been ended.',
      PromoDetailLayout: {
        backToPromos: 'Back to promotions',
        overviewTabLabel: 'Overview',
        redemptionsTabLabel: 'Redemptions',
        EndPromo: {
          headerText: 'Are you sure you want to end this promo?',
          dismissLabel: 'Never mind',
          submitLabel: 'End promo',
          buttonText: 'End promo',
          descriptiveText:
            'This promo will expire immediately. The code will not work on future orders, but the promotional discount will still be honored on orders that have already been placed. You will still be able to access information about it from the promos table.',
        },
      },
      OverviewPane: {
        OverviewDetails: {
          header: 'Promotion details',
          CreatedBy: {
            label: 'Created by',
          },
          EligibleChannels: {
            label: 'Eligible channels',
            ezOrdering: 'ezOrdering',
            directEntry: 'Direct entry',
          },
          EligibleCustomers: {
            label: 'Eligible customers',
            newCustomers: 'New customers',
            existingCustomers: 'Existing customers',
          },
          EligibleDays: {
            label: 'Eligible days of the week',
            weekdaysOnly: 'Weekdays only',
            allDays: 'All days of the week',
          },
          EndDate: {
            label: 'Redemption end date',
          },
          FundedBy: {
            label: 'Funded by',
            caterer: 'Caterer',
            ezCater: 'ezCater',
          },
          RedemptionsPerCustomer: {
            label: 'Redemptions per customer',
            onePerCustomer: 'One per customer',
            unlimited: 'Unlimited',
          },
          StartDate: {
            label: 'Redemption start date',
          },
        },
        OverallPerformance: {
          header: 'Overall performance',
          TotalRedemptions: {
            label: 'Total redemptions',
            fulfilled: 'Fulfilled: {{count}}',
            upcoming: 'Upcoming: {{count}}',
          },
          TotalOrders: {
            label: 'Total orders ($)',
          },
          UniqueCustomers: {
            label: 'Unique customers',
            new: 'New: {{count}}',
            returning: 'Returning: {{count}}',
          },
          DaysActive: {
            label: 'Days active',
          },
        },
        PromoSummary: {
          header: 'Promotion summary',
          Shortlink: {
            label: 'Shortlink',
            noCode: 'n/a',
          },
          PromoCode: {
            label: 'Promotion code',
          },
          PromoValue: {
            label: 'Promotion value',
            text: '{{amount}} off',
          },
          OrderMinimum: {
            label: 'Order minimum',
            text: '{{amount}} minimum',
          },
        },
        CopyableDetailWithTitle: {
          copySuccessful: 'Copied!',
        },
        PerformanceByCaterer: {
          title: 'Performance by store',
          headers: {
            caterer: 'Caterer',
            redemptions: 'Redemptions',
            revenue: 'Revenue',
          },
        },
      },
      Redemptions: {
        title: 'Redemptions',
        subtitle_one: '1 order has been placed using the promo {{promoName}}.',
        subtitle_other: '{{count}} orders have been placed using the promo {{promoName}}.',
        orderSources: {
          CLUB_SODA: 'Club soda',
          DIRECT_ENTRY: 'Direct entry',
          EZ_ORDERING: 'ezOrdering',
          MARKETPLACE: 'Marketplace',
        },
        headers: {
          orderNumber: 'Order #',
          locationCustomer: 'Location / Customer',
          store: 'Store',
          submittedAt: 'Placed on',
          eventTime: 'Event date & time',
        },
        emptyState: {
          primaryHeading: 'No redemptions. Promote your promo!',
          message1:
            'Share your custom promo link on Facebook and Twitter, and promote this offer in your customer emails and loyalty program.',
          copyPromoLink: 'Copy promo link',
          helpHeading: 'Need some help?',
          mechandisingHelpText: 'For printed merchandising materials, visit our new website at',
          partnerSuccessHelpText1: 'Questions? Email our Partner Success team at',
          partnerSuccessHelpText2: 'or call (617) 874-5182.',
        },
      },
    },
    Rankings: {
      title: 'Marketing Tools',
      aboutSection: {
        primaryText: 'Be seen. Drive clicks. Get more orders.',
        secondaryText:
          'Catering partners who use the Preferred Partner Program (PPP) and ezRewards get an average of 30% more orders.',
        linkText: 'Learn how PPP and ezRewards work',
        videoCaption: 'How it works',
      },
      tableAriaLabel: 'Store Marketing Tools Table',
      tableHeading: 'Your Locations',
      viewOnlyAlert: 'You have view-only access. Contact your admin to make changes.',
      tableDescription:
        'You can set PPP & ezReward levels for individual stores, or select multiple stores to make bulk changes.',
      tableHeaders: {
        brand: 'Brand',
        location: 'Location',
        city: 'City',
        state: 'State',
        storeNumber: 'Store #',
        address: 'Address',
        preferredPartnerRate: {
          header: 'Preferred Partner Level',
          none: 'None',
          tooltip:
            'Preferred Partner level:\nThe level you select is a bid to improve your position in customer search results. It represents the percentage of the order total you’ll pay to receive the additional visibility. You only pay for orders you receive.',
          notEligible: {
            chipLabel: 'Not eligible',
            tooltip:
              'We’re replacing PPP with Sponsored Listings in select cities. Go to Sponsored Listings to create your first campaign.',
            toolttipLink: 'Go to Sponsored Listings',
          },
        },
        rewardsLevel: {
          header: 'ezRewards Level',
          tooltip:
            'ezRewards:\nThe multiplier you choose represents a percentage of the order total you will offer back to customers in the form of ezRewards. For example, a 2X rewards level costs 2% of the order total.',
        },
      },
      none: 'None',
      emptyState: {
        title: 'No matches found for "{{keyword}}"',
        subtitle:
          'Please try another search using Brand Name, Store #, Street Address, City or State.',
        clearSearch: 'Try Again',
      },
      tableActions: {
        readOnlyTooltip: 'You do not have edit access.',
        noneSelectedTooltip: 'Please select one or more stores to complete this action.',
        ezFieldLabelRewards: 'Set your ezRewards level',
        ezFieldLabelPPP: 'Set your Preferred Partner level',
        inputPlaceholder: 'Select level',
        truncatedStoresList: '{{listOfStores}}, plus {{additionalStoreCount}} other stores',
        storeChangeConfirmation:
          'You are changing the {{changeType}} level for {{storeCount}} locations',
        editPppSettings: {
          buttonText: 'Edit PPP Settings',
          modalHeader: 'Preferred Partner Program',
          rateOptions: {
            value: 'label',
          },
          flashMessage: 'Preferred Partner level successfully updated',
        },
        editEzRewards: {
          buttonText: 'Edit ezRewards',
          modalHeader: 'ezReward Settings',
          modalContext:
            'The ezRewards level you choose is charged as a percentage of the food total on orders. If you offer 3% ezRewards, your cost would be 3% of the food total on orders.',
          rateOptions: {
            value: 'label',
          },
          flashMessage: 'ezRewards successfully updated',
        },
      },
      search: {
        placeholder: 'Search by Brand, Store #, Address, City, State',
      },
      orderBy: {
        placeholder: 'Sort By',
        fields: {
          storeNumberAsc: 'Sort By: Store # (asc)',
          storeNumberDesc: 'Sort By: Store # (desc)',
          addressAsc: 'Sort By: Address (asc)',
          addressDesc: 'Sort By: Address (desc)',
          storeNameAsc: 'Sort By: Store Name (asc)',
          storeNameDesc: 'Sort By: Store Name (desc)',
        },
      },
    },
    RankingsDetail: {
      helmet: 'Marketing Tools for {{storeName}}',
      backLinkLabel: 'Back to Marketing Tools',
      backLinkAccessibilityLabel: 'Back to Marketing Tools',
      unsavedChangesFlashMessage: 'You have unsaved changes.',
      successFlashMessage: 'Changes to settings saved successfully.',
      confirmModal: {
        title: 'Confirm Changes',
        cancelLabel: 'Cancel',
        submitLabel: 'Continue',
      },
      sponsoredListingsBanner: {
        heading: 'Looking for PPP?',
        description:
          'We’re replacing PPP with Sponsored Listings in select cities. Go to Sponsored Listings to create your first campaign.',
        linkText: 'Go to Sponsored Listings',
      },
      editPppSettings: {
        primaryText: 'Increase search ranking to be found (and chosen) by more customers',
        secondaryTextA: 'PPP gets you the most views possible when people search for caterers.',
        secondaryTextB:
          'With a 4-star rating or higher, you can bid up to 20% of your food total. You only pay for orders you receive.',
        sectionTitle: 'Preferred Partner Program (PPP)',
        addressTable: {
          title: 'Estimate the impact of different bids',
          addressTablePrimaryText:
            'To test the possible impact of PPP spending, enter local delivery addresses in the estimator.\n\nResults below are estimates. Actual results may vary based on the customer and exact search inputs.',
          addAddressButtonText: 'Add delivery address',
          tableHeaders: {
            address: 'Address',
            estimatedRanking: 'Current Ranking',
            shiftInRanking: 'Estimated Change',
          },
          emptyPrimaryText: 'No Delivery Addresses Saved',
          emptySecondaryText:
            'Where will your PPP investment pay off? Add delivery addresses to see.',
          addressRankingNotAvailable: 'Not Available',
        },
        addressModal: {
          addAddressHeader: 'Add Delivery Address',
          addAddressPlaceholderText: 'Enter Street Address',
          addressFieldLabel: 'Address search',
          deleteAddressHeader: 'Delete Address',
          dismissLabel: 'Cancel',
          submitLabel: 'Add Address',
          deleteLabel: 'Confirm',
          successFlashMessage: 'Address successfully added',
          successDeleteFlashMessage: 'Address successfully deleted',
          deleteBodyText: 'Are you sure you wish to delete this address?',
        },
      },
      editEzRewards: {
        sectionTitle: 'ezRewards',
        successFlashMessage: 'ezRewards successfully updated',
        primaryText: 'Our customers love earning ezRewards',
        secondaryText:
          'Drive clicks with ezRewards. Get an ezRewards banner on your search results. Offer up to 5X ezRewards points customers can redeem towards future ezCater orders or Amazon gift cards.',
        linkText: 'How it works',
        aboutEzRewardsModal: {
          header: 'How ezRewards works',
          body1:
            'If you choose 3% as your ezRewards level, your cost will be 3% of the food total on orders. If you choose 2% ezRewards plus 5% as your Preferred Partner level, your cost will be 7% per order. And so on.',
          body2:
            'The cost will be reflected in the "Miscellaneous Fees" column on your order statements, and deducted from your payments. You will only be charged for orders submitted while you have these promotions turned on. You can change your promotion levels instantly, at any time.',
          linkText: 'Visit our Help Center for more information',
          submitLabel: 'Got it',
        },
      },
      ineligiblePPPCard: {
        header: 'Raise your customer rating to become a Preferred Partner',
        body: 'The Preferred Partner Program gets you the most views possible when people search for caterers. As a Preferred Partner, you can bid up to 20% of your food total to increase your search ranking. You only pay for orders you receive.',
        link: 'How it works →',
        howToQualify: {
          headline:
            'To qualify, focus on building your positive customer rating in the ezCater marketplace.',
          body: 'Once you’ve got a 4-star rating, you’ll be able to manage your Preferred Partner allocation here.',
        },
      },
      confirmationModalText:
        'You are changing the {{program}} level for {{storeName}} to {{changeValue}}%',
      confirmationModalWarning: 'Please Note: This will change your cost per order',
      cancelSaveSectionLabel: 'Cancel',
      saveSectionLabel: 'Save Changes',
    },
    ReliabilityRockstar: {
      title: 'Reliability Rockstar',
      badge: {
        reliability: 'Reliability',
        rockstar: 'Rockstar!',
        achievedBadgeFooter: 'Active for all of {{month}}',
      },
      BadgeSection: {
        rockstarStatusHeading: {
          notRollingRockstar: 'Not a Reliability Rockstar currently',
          rockstar: 'Congratulations, you are a Reliability Rockstar!',
          notRockstar: 'Not a Reliability Rockstar this month',
        },
        rockstarStatusSubheading: {
          learnMore: 'Learn more',
          howItWorks: 'How the Reliability Rockstar program works',
          rockstar:
            'ezCater marketplace customers will see this badge next to your restaurant through the end of the month.',
          rollingRockstar:
            'ezCater marketplace customers will see this badge next to your restaurant. Keep it up!',
          notRockstar: {
            subheadingOne: 'This store did not earn a badge this review cycle, but keep trying!',
            subheadingTwo:
              'Every order has an impact and can get you back on track earning your badge.',
          },
          notRollingRockstar: {
            subheadingOne:
              'See below to learn which areas need improvement in order to earn Rockstar status.',
            subheadingTwo:
              'Badges are based on the most recent 90 days. Every order has an impact!',
          },
        },
      },
      ProgressSection: {
        progressHeading: 'Progress toward your next evaluation',
        progressHeadingRolling90: "How you're trending",
        progressSubHeading:
          'To make sure we’re highlighting our most reliable catering partners, we will review the last three months of your performance on a monthly basis.',
        progressSubHeadingRolling90:
          'To make sure customers know who’s most reliable right now, we badge Rockstars based on the most recent 90 days.',
        orders: 'Orders',
        delivery: 'Deliveries',
        newStandards: {
          heading: 'Later in 2025: New standards for Rockstars',
          learnMore: `<a>Learn more</a> about accuracy & delivery metrics`,
          orderAccuracy: 'Order accuracy',
          deliveryTracking: 'Delivery tracking',
          seeDetails: 'See details',
          seeDetailsAriaLabel: 'Click to open details modal about {{metric}}',
        },
        charts: {
          orderVolume: 'Order volume',
          rejected: 'Rejected',
          canceled: 'Canceled',
          onTime: 'On-time',
          orderAccuracy: 'Order Accuracy',
          deliveryTracking: 'Delivery Tracking',
        },
        Tooltips: {
          Orders: {
            tip: 'Tip',
            header: 'Rejected & cancelled orders',
            meetGoals:
              'To meet these goals, you must have zero cancelled orders and no more than a 0.5% rejection rate.',
            selfService:
              'Use our self-service order requests feature in ezManage to communicate order changes to the customer before you reject or cancel the order.',
          },
          Delivery: {
            header: 'On-time delivery',
            deliveryGoal: 'You need a 98.5% on-time goal for all your deliveries.',
          },
        },
        linkLabels: {
          orderVolume: 'All orders',
          rejected: 'Rejections',
          canceled: 'Cancellations',
          onTime: 'All deliveries',
        },
        linkAriaLabels: {
          allOrders: 'View all orders',
          rejected: 'View rejected orders',
          canceled: 'View canceled orders',
          allDeliveries: 'View all deliveries',
          seeOrderAccuracyDetails: 'See order accuracy details',
          seeDeliveryTrackingDetails: 'See delivery tracking details',
        },
      },
      PreviewSection: {
        heading: 'Coming September 29th: New standards for Rockstars',
        description: 'Two changes are coming to Reliability Rockstar evaluations:',
        changes: {
          rollingWindow:
            "Introducing a rolling 90-day window. If you've met the standards for the past 90 days, you've got it. No waiting until the end of the month!",
          newMetrics:
            'Adding your order accuracy and delivery tracking measures as part of the Rockstar standard.',
        },
        previewNotice: "Here's a preview of how you'd be doing under those changes:",
      },
      RewardsSection: {
        heading: 'Grow your business as a Reliability Rockstar',
        subHeading:
          'Caterers who earn Reliability Rockstar status generally see immediate benefits.',
        footer: 'Please reach out with any questions or feedback at ',
        rewardsList: {
          ranking: {
            category: 'Ranking',
            heading: 'Increased Marketplace visibility',
            subHeading:
              'Your badge is prominently displayed in your store listing, and customers can filter search results to show only Rockstars.',
          },
          orders: {
            category: 'Orders',
            heading: 'More orders per location',
            subHeading:
              'Reliability Rockstar locations received 48% more orders than non-Rockstar locations over the past 6 months.',
          },
          revenue: {
            category: 'Revenue',
            heading: 'Increased order volume',
            subHeading:
              'The bigger the order, the more customers need to trust that a catering partner can come through.',
          },
        },
        mediaBox: {
          heading: 'Learn how to maintain your Reliability Rockstar status',
        },
      },
      storeDropdownLabel: 'Store',
    },
    ReadyForPickup: {
      openModalButton: 'Mark ready for pickup',
      viewPhotoButton: 'View pickup photo',
      markReadyForPickupModal: {
        title: 'Order ready for pickup',
        description:
          'To mark this order ready for pickup, scan this QR code on your phone and complete the presented steps.',
      },
      viewPhotoModal: {
        title: 'Pickup photo',
        description: 'Photo of the order',
        photoAltText: 'Pickup photo',
        noPhotoAvailable: 'No photo available',
      },
      headerTitle: '{{orderNumber}} marked ready at  <strong>{{timestamp}}</strong>',
      step: 'Step {{stepNumber}} of 3',
      step1: {
        title: 'Order ready for pickup',
        description: 'To complete this process, please continue to the next two steps:',
        tooltipModal: {
          header: 'What is this for?',
          description:
            'Recording this information helps us in the event a driver or customer reports the order late or incomplete. We will only look at the photos if there’s a dispute to resolve.',
          close: 'Got it',
        },
        bullet1: 'Add a package count',
        bullet2: 'Take a photo',
        buttonText: 'Next',
      },
      step2: {
        title: 'Enter package count',
        description: 'How many packages (bags, trays, boxes, etc) is this order packed into?',
        tooltipModal: {
          header: 'What is a package?',
          photoLabel: 'Package count example: 4 total',
          caption1: '1 Package',
          caption2: '2 Packages',
          description1:
            'Enter the number of separate packages the driver should expect to pick up.',
          description2:
            'A package may be a tray, if it is not in another container. If it’s in a bag or box, count the bag or box, not its contents.',
          close: 'Got it',
          package: 'Package:',
        },
        input: 'Number of packages',
        buttonText: 'Next',
      },
      step3: {
        title: 'Take a photo of the order',
        description:
          'Take a photo of all the packages included in this order. This helps if a dispute comes up.',
        helpfulTips: {
          title: 'Helpful tips:',
          bullet1: 'Make sure the photo is in a well lit area',
          bullet2: 'Try to get all the packages in the photo',
          bullet3: 'Make sure the image is in focus',
        },
        buttonText: 'Take photo',
        disclaimer: {
          title: 'Please Note:',
          description:
            "Upon submitting your photo, the order will be marked ready. You won't be able to return to this process.",
        },
      },
      alreadySubmitted: {
        title: 'All set!',
        description: "You've already marked this order ready for delivery at {{timestamp}}.",
        buttonText: 'Close window',
      },
      successfullySubmitted: {
        title: 'All Done',
        description1: "Thank you for marking this order ready. We'll let the driver know.",
        description2:
          'You can access the photo you just submitted on your Orders page in ezManage.',
        description3: 'Want to know more?',
        linkText: 'Learn how this will improve order disputes.',
        buttonText: 'Close window',
      },
      notEligible: {
        title: 'Delivery window not eligible',
        description:
          "This order can't be marked ready, as it is outside the 24-hour limit. Please check that you scanned the right code.",
        buttonText: 'Close window',
      },
      error: {
        unavailable: {
          title: 'Sorry this feature is currently unavailable.',
        },
        failedSubmission: {
          title: 'Something went wrong',
          description: 'Photo submission failed.',
          tryAgain: 'Try again',
        },
      },
    },
    ReviewOrder: {
      paymentFailedFlashMessageBody: 'Please get new credit card information',
      paymentFailedFlashMessageHeadline: 'Payment failed',
      ezDispatchWheneverBanner: {
        title: 'ezDispatch is now available for your Direct Entry orders paid with a credit card!',
        message:
          "ezDispatch lets you hand deliveries off to ezCater's vetted network of reliable delivery providers. The customer pays you your standard delivery fee. You pay 10% of the order subtotal with a $30 minimum for ezDispatch, and tips go to the driver.\n\nRequest ezDispatch once the order is placed.\nNote: Automatic ezDispatch enrollment does not apply to these orders. Request it each time you need it on Direct Entry orders.",
        learnMore: 'Learn more about ezDispatch',
      },
      Header: {
        title: 'Payment',
        modify: 'Order Review {{orderNumber}}',
        link: 'Back to edit order',
      },
      EditPromptModal: {
        header: 'Go back to edit order?',
        submit: 'Yes, go back to edit order',
        dismiss: 'Stay on this page',
        content: "You'll lose any changes you've just made on this page.",
      },
      edit: 'Edit',
      submit: 'Submit',
      saveAndSubmit: 'Save & Submit',
      tooltip: 'You must select a payment option before submitting',
      CustomerInformation: {
        title: 'Customer Information',
      },
      DeliveryInformation: {
        title: 'Delivery Information',
        deliveryContact: 'Delivery Contact:',
        deliveryInstructions: 'Delivery Instructions:',
        deliveryPartner: 'Delivery by {{thirdPartyDeliveryPartner}}',
      },
      TakeoutInformation: {
        title: 'Takeout Information',
      },
      EventInformation: {
        title: 'Event Information',
        people: 'people',
        person: 'person',
        DELIVERY: {
          withHeadcount: 'Delivery (for {{headcount}} {{people}})',
          withoutHeadcount: 'Delivery',
        },
        TAKEOUT: {
          withHeadcount: 'Takeout (for {{headcount}} {{people}})',
          withoutHeadcount: 'Takeout',
        },
        THIRD_PARTY_DELIVERY: {
          withHeadcount: 'ezDispatch (for {{headcount}} {{people}})',
          withoutHeadcount: 'ezDispatch',
        },
      },
      OrderItems: {
        columns: {
          quantity: 'Qty',
          item: 'Item',
          price: 'Price',
        },
        OrderItem: {
          nameAndPrice: '{{name}} @ ${{price}}',
          total: '${{total}}',
          sizeDescription: '{{sizeLabel}}: {{size}}',
          noteToCaterer: 'Note to caterer: {{noteToCaterer}}',
          specialInstructions: 'Special Instructions:',
          vegetarianQuantity_other: 'This group includes: {{count}} Vegetarians',
          vegetarianQuantity_one: 'This group includes: {{count}} Vegetarian',
          viewMoreDetails: 'View more details',
          labelForPerson: 'Label for: ',
          willBeIndividuallyPackagedPseudoOption: 'Packaging: Individual Packaging',
        },
      },
      OrderNotes: {
        title: 'Order Notes',
        deliveryNotes: 'Delivery Notes',
        kitchenNotes: 'Kitchen Notes',
        placeholder: '---',
      },
      Tableware: {
        header: 'Tableware',
        tablewareChoices: {
          includeLabelDescription: 'Include: {{include}}',
          doNotIncludeLabelDescription: "Don't Include: {{doNotInclude}}",
        },
        specialInstructionsDescription: 'Note: {{specialInstructions}}',
        price: '$0.00',
      },
      PaymentInformation: {
        title: 'Payment Information',
        flashMessages: {
          submit: 'Order {{orderNumber}} has been successfully submitted.',
          modify:
            'Order updated. We’ve sent your team a notification and emailed the customer a new receipt.',
        },
        disabledToolTip:
          'Payment type cannot be changed for {{status}} orders. For any questions, please call 781-519-6376.',
        PaymentChoices: {
          InStorePayment: {
            header: 'In-store payment',
            subheader: 'For all payments made outside of ezManage.',
          },
          ExternalPayment: {
            header: 'External payment',
            subheader: 'For all payments made outside of ezManage (e.g. in store payments)',
            fields: {
              paymentMethod: {
                label: 'External Payment Type',
                placeholder: 'Payment Method',
                options: {
                  inStore: 'Pay in Store',
                  invoice: 'Invoice',
                  lineOfCredit: 'Line of Credit',
                  houseAccount: 'House Account: {{companyName}}',
                },
              },
            },
          },
          CreditCard: {
            header: 'Pay with credit card',
            subheader: 'For payments through ezManage.',
            ezDispatchTipHeader: 'ezDispatch is now available for orders paid with a credit card!',
            ezDispatchTipSubheader: 'Request ezDispatch once the order has been placed.',
          },
          HouseAccount: {
            header: 'House Account',
            subheader: 'For billing your trusted customers later.',
            createLink: 'Create a House Account.',
            fields: {
              paymentMethod: {
                label: 'In Store Payment Type',
                placeholder: 'Select House Account',
                options: {
                  houseAccount: 'House Account: {{companyName}}',
                },
              },
            },
          },
        },
      },
      CcEmails: {
        header: 'Send Order Confirmation To Additional Email Addresses',
        fields: {
          ccEmails: {
            label: 'Additional Email Addresses (optional)',
            description: 'Please separate email addresses with commas.',
            placeholder: 'Additional Email Address',
            validation: 'Please enter a valid email address. Emails should be separated by commas',
          },
        },
      },
    },
    Reviews: {
      title: 'Reviews',
      orderLinkText: 'View Order',
      backLinkText: 'Back to Reviews',
      datetime: '{{ datetime, MM/DD/YY }} at {{ datetime, h:mm a }}',
      cityState: 'in {{city}}, {{state}}',
      deliveryProfessionalismFeedback: {
        label: 'Driver Professionalism',
        HIGHLY_UNPROFESSIONAL: 'Highly Unprofessional',
        UNPROFESSIONAL: 'Unprofessional',
        NEUTRAL: 'Neutral',
        PROFESSIONAL: 'Professional',
        HIGHLY_PROFESSIONAL: 'Highly Professional',
      },
      deliveryTimeFeedback: {
        label: 'Delivery',
        EARLY: 'Early',
        ON_TIME: 'On Time',
        LATE: 'Late',
      },
      paginationLabel: 'Reviews Per Page',
      zeroReviews: {
        heading: 'Wishing on a review?',
        message:
          'If your heart is in your dream no request is too extreme… but maybe try again tomorrow.',
      },
    },
    OrderIndex: {
      title: 'Orders',
      searchPlaceholder: '#2SC-A6B',
      searchLabel: 'Search by order number',
      tabs: {
        completed: 'Completed',
        rejected: 'Rejected',
        canceled: 'Canceled',
        unplaced: 'Unplaced',
        upcoming: 'Upcoming',
      },
      autoInterventionBannerFooterText:
        '{{responsibleParty}} are still responsible for fulfilling previously placed orders.',
      comboBanner: {
        header: 'Multiple stores are temporarily paused or at risk on the ezCater marketplace',
        warning: {
          single: '',
          multiple: `
          {{warnedStoresCount}} stores are close to falling below our reliability standards.
          <br/>
          <br/>
          `,
          oneStore: `
          1 of {{totalStoresCount}} stores is close to falling below our reliability standards.
          <br/>
          <br/>
          `,
        },
        paused: {
          single: '',
          multiple: `
          {{pausedStoresCount}} stores have fallen below our reliability standards and are unable to accept new marketplace orders.
          <br/>
          <br/>
          `,
          oneStore: `
          1 of {{totalStoresCount}} stores has fallen below our reliability standards and is unable to accept new marketplace orders.
          <br/>
          <br/>
          `,
        },
      },
      warningBanner: {
        single: `
        <strong>This store is at risk of being temporarily paused on the ezCater marketplace</strong>
        <br/>
        <br/>
        This store is close to falling below our reliability standards, which could result in it being unable to accept new marketplace orders.
        <br/>
        <br/>
        `,
        multiple: `
        <strong>{{warnedStoresCount}} stores are at risk of being temporarily paused on the ezCater marketplace</strong>
        <br/>
        These stores are close to falling below our reliability standards, which could result in them being unable to accept new marketplace orders.
        <br/>
        <br/>
        `,
        oneStore: `
        <strong>1 of {{totalStoresCount}} stores is at risk of being temporarily paused on the ezCater marketplace</strong>
        <br/>
        This store is close to falling below our reliability standards, which could result in it being unable to accept new marketplace orders.
        <br/>
        <br/>
        `,
      },
      pauseBanner: {
        listDescriptor: 'Multiple',
        single: `
        <strong>This store is temporarily paused on the ezCater marketplace</strong>
        <br/>
        This store has fallen below our reliability standards for {{reason}} and is unable to accept new marketplace orders until unpaused.
        <br/>
        <br/>
        `,
        multiple: `
        <strong>{{pausedStoresCount}} stores are temporarily paused on the ezCater marketplace</strong>
        <br/>
        These stores have fallen below our reliability standards and are unable to accept new marketplace orders.
        <br/>
        <br/>
        `,
        oneStore: `
        <strong>1 of {{totalStoresCount}} stores is temporarily paused on the ezCater marketplace</strong>
        <br/>
        This store has fallen below our reliability standards and is unable to accept new marketplace orders until unpaused.
        <br/>
        <br/>
        `,
      },
      unpausedBanner: `
        <strong>This store has been unpaused in the ezCater marketplace</strong>
        <br/>
        This store is now visible to customers and can accept new orders. Be sure to stay at or above these reliability standards to prevent a future pause.
      `,
      visitOperationalMetricsPage:
        'Visit the operational metrics page in ezManage for details and next steps.',
      operationalMetricsLink: 'Operational Metrics',

      ezOrderingMarketing: {
        header: 'Get more orders by adding ezOrdering to your website.',
        content:
          'Customers get an easy way to order catering from you online. You get customer contact info and a low commission.',
        action: 'Learn more',
      },
      OrdersDisplayContainer: {
        completedOrders: 'Completed Orders',
        rejectedOrders: 'Rejected Orders',
        canceledOrders: 'Canceled Orders',
      },
      OrdersCalendar: {
        unpaidStatus: 'Unpaid',
        modal: {
          header: 'Summary For {{date}}',
          orderNumber: 'Order #',
          setupRequired: 'Setup required',
          status: 'Status',
          date: 'Date',
          time: 'Time',
          timestamp: 'Customer requested delivery time',
          location: 'Location',
          headcount: 'Headcount',
          total: 'Total',
          address: 'Address',
          store: 'Store',
          orders: 'Orders',
          cancel: 'Cancel',
        },
      },
      DraftsAndQuotesTable: {
        expired: 'Expired',
        headers: {
          dateAndTime: 'Date & Time',
          customer: 'Customer',
          address: 'Address',
          store: 'Store',
          total: 'Total',
          created: 'Created',
          status: 'Status',
          orderId: 'Order #',
        },
        fields: {
          deleteButton: 'Delete',
        },
        DeleteModal: {
          header: 'Delete unplaced order {{orderNumber}}?',
          content: '',
          cancel: 'Cancel',
          delete: 'Delete',
          deleteFlashMessage: 'Unplaced order {{orderNumber}} deleted.',
        },
        noResults: 'No drafts or quotes.',
      },
      OrdersTable: {
        headers: {
          orderNumber: 'Order #',
          dateAndTime: 'Date & Time',
          customer: 'Customer',
          address: 'Address',
          setupRequired: 'Setup required',
          store: 'Store',
          source: 'Source',
          orderValue: 'Order Value',
          orderValueTooltip:
            'This represents what you would have earned from an accepted and completed order.',
          status: 'Status',
          deliveryStatus: 'Delivery Info',
          canceledBy: 'Canceled By',
          rating: 'Rating',
          rejectedBy: 'Rejected By',
          reason: 'Reason',
          fulfillmentIssues: 'Issues',
          rejectedOn: 'Rejected On',
          canceledOn: 'Canceled On',
          canceledRejectedOriginalOrderDate: 'Event Time',
          submittedAt: 'Submitted At',
        },
        fields: {
          address: {
            orderType: {
              thirdPartyDelivery: 'Delivery',
              takeout: 'Takeout',
            },
            notAvailable: 'N/A',
            pending: 'pending response from ezDispatch',
            byPartner: 'by {{partnerName}}',
          },
          store: {
            notAvailable: 'N/A',
          },
          time: {
            firstLine: '{{time, h:mm A}} -',
            secondLine: '{{time, h:mm A}}',
            firstLineOnTheHour: '{{time, h A}} -',
            secondLineOnTheHour: '{{time, h A}}',
          },
          dropoffWindowCallToAction: 'Deliver',
          pickupTime: '({{time}} pickup)',
          canceledByStore: 'Canceled by Store',
          canceledByCustomer: 'Canceled by Customer',
          customerCanceled: 'Customer',
          storeCanceled: 'Store',
          adminCanceled: 'Store (ezCater admin)',
          adminRejected: 'ezCater admin',
          storeRejected: 'Store',
          defaultRejected: 'Store user',
          noReview: 'No review',
          printOrder: 'Print order',
        },
        noResults: 'No Results Found.',
        paginationLabel: 'Rows per page',
      },
      actionRequiredCards: {
        title: 'Action needed',
        buttons: {
          viewOrder: 'View Order',
          reconfirm: 'Reconfirm',
          acknowledge: 'Acknowledge',
          assignDriver: 'Assign Driver',
          confirmModification: 'Review modification',
        },
        address: {
          orderType: {
            thirdPartyDelivery: 'ezDispatch',
            takeout: 'Takeout',
          },
        },
        acceptFlashMessage: 'Order {{orderNumber}} has been accepted',
        dropoffWindowCallToAction: 'Deliver',
        urgent: 'Urgent',
      },
      modificationModal: {
        singularTitle: `Today's order {{orderNumber}} has new modifications to review`,
        multipleTitle: '{{number}} orders today have last minute modifications',
        numberOfMods: '{{number}} modifications:',
        singularButton: 'Review modification',
        multipleButton: 'Continue to ezManage',
      },
      filters: {
        draftsAndQuotesTimeDropdown: {
          label: 'Time Dropdown',
          allTime: 'All Time',
          expired: 'Expired',
          upcoming: 'Upcoming',
        },
        calendarAriaLabel: 'Calendar',
        listAriaLabel: 'List',
        timeDropdownLabel: 'See orders from',
        time: {
          headers: {
            scheduled: 'Scheduled',
            historical: 'Historical',
          },
          options: {
            allScheduled: 'All Scheduled',
            today: 'Today',
            tomorrow: 'Tomorrow',
            allTime: 'All Time',
            yesterday: 'Yesterday',
            last7Days: 'Last 7 Days',
            last90Days: 'Last 90 Days',
            thisMonth: 'This Month',
          },
        },
      },
      generateReportButton: 'Generate Report',
      privateStoreMarketing: {
        header: 'It looks like you don’t have any orders through ezOrdering yet.',
        content:
          'Linking to ezOrdering from your website lets you take catering orders online, without ezCater branding and at a lower cost per order.',
        learnMore: 'Learn More',
      },
    },
    OrderDetails: {
      title: 'Order {{formattedOrderNumber}}',
      consolidatedOrderDetailsCardTitle: 'Order on {{date}} at {{time}}',
      customerRequestedTimeTooltip: 'The customer requested this time.',
      dropoffWindowCallToAction: 'Deliver',
      dropoffWindowTooltip: 'Orders delivered earlier or later will not be considered on time.',
      changeStoreButton: 'Change store',
      changeStoreHeader: 'Change Store',
      changeStoreDismissButton: 'Dismiss',
      changeStoreSubmitButton: 'Request Modification',
      changePending:
        'This order has a pending change request. Once approved, you’ll get a modified order to accept.',
      cancelModal: {
        header: 'Cancel Order',
        confirmMessage: 'Are you sure you want to cancel this order?',
        button: 'Cancel Order',
        flashMessage: {
          success: 'Order {{orderNumber}} has been successfully cancelled.',
        },
      },
      catererSubmittedRefundModal: {
        button: 'Refund',
        dismissLabel: 'Cancel',
        headerText: 'Refund Customer',
        submitLabel: 'Refund Customer',
        amountRefundTypeLabel: 'Amount',
        percentageRefundTypeLabel: 'Percentage',
        fullRefundRefundTypeLabel: 'Full Refund',
        fullRefundlabel: 'Full Refund Amount',
        refundSuccessFlashMessageWithNoReceiptSent:
          "Refund has been successfully added to order. We've sent your team a notification.",
        refundSuccessFlashMessageWithReceiptSent:
          "Refund has been successfully added to order. We've sent your team a notification and emailed the customer a new receipt.",
        refundSuccessFlashMessageCreditCardWithReceiptSent:
          "Refund issued. We've sent your team a notification and emailed the customer a new receipt.",
        currentTotalLabel: 'Original Total',
        newTotalLabel: 'New Total',
        newRefundLabel: 'Refund',
        creditCardPaymentMethodDisplay: '{{cardType}} ending in {{last4}}',
        refundAmountLabel: 'Refund Amount',
        refundDisabledZeroedTotal: 'This order was fully refunded',
        refundDisabledPastThirtyDays:
          'This order was fulfilled at least 30 days ago. For any refund questions please contact Direct Entry Tech Support via phone: 781-519-6376 or email: direct-entry-support@ezcater.com',
        refundPercentLabel: 'Refund Percentage',
        refundCustomPercentLabel: 'Custom Percentage',
        refundPercentPlaceholder: 'Custom',
        refundTypeLabel: 'Select refund type:',
        refundReasonHelperText: 'The customer will see this on the updated receipt',
        refundReasonLabel: 'Reason for refund',
        refundReasonPlaceholder: 'e.g Delivered 30mins late etc.',
        sendReceiptLabel: 'Send an updated receipt to the customer',
        validations: {
          amount: {
            requiredMsg: 'Refund is required',
            typeErrorMsg: 'Refund must be a positve amount',
            positiveNumberMsg: 'Refund must be a positive amount',
            exceedsTotal: 'Refund cannot exceed the current total',
          },
          percent: {
            requiredMsg: 'Refund is required',
            typeErrorMsg: 'Refund must be a positve percentage',
            positiveNumberMsg: 'Refund must be a positive percentage',
            exceedsTotal: 'Refund cannot exceed 100%',
          },
          percentage: {
            requiredMsg: 'Refund is required',
          },
          reason: {
            requiredMsg: 'Reason for refund in required',
          },
        },
      },
      ezDispatchRequired: 'ezDispatch Required',
      FulfillmentIssueCard: {
        title: 'Issues reported with this order',
        orderCanceled: 'This order has a cancellation',
        orderRejected: 'This order has a rejection',
        missingFood: 'Missing Food',
        otherIssues: 'Other Issues',
        deliveryIssue: 'Delivery Issue',
        catererIssue: 'Food was not ready for delivery',
        dispute: "If you'd like to dispute any of these issues, <a>contact us.</a>",
        fullyMissing: '(Missing in full)',
        partialMissing: '(Partially missing)',
        genericMissingItem: 'Unknown item',
        disputeButton: 'Dispute an issue',
      },
      ExistingDisputeCard: {
        titlePending: 'Issue dispute is pending',
        titleClosed: 'Issue dispute is closed',
        processTimeLengthAndEmail:
          "The dispute process generally takes up to two business days. We'll email our decision to: <br /><bold>{{email}}</bold>",
        issues: 'Issues',
        resolution: 'Resolution',
        status: {
          approved: 'Approved',
          denied: 'Denied',
          partialRefund: 'Partial refund',
        },
      },
      DisputeDrawer: {
        title: 'Order issue dispute',
        description: 'To dispute an issue or related compensation decision:',
        steps: [
          'Complete the form below',
          "We'll review the dispute within 2 days",
          "After a decision is made, we'll email you with an update",
        ],
        issueTabs: {
          issuesTitle: 'This order has {{count}} issue',
          issuesTitle_other: 'This order has {{count}} issues', // magic pluralization key
          issueName: 'Issue name',
          issueDescription: 'Description',
          notAvailable: 'Not available',
          partiallyMissing: 'partially missing',
          fullyMissing: 'fully missing',
          unknownItem: 'Unknown item',
          partiallyTrackedDescription:
            'This order is missing an event such as dropoff or has timestamps too close together to represent the full delivery.',
          invalidDataDescription:
            'This order has timestamps too close together to represent the full delivery.',
          missingRequiredDataDescription: 'This order is missing an event such as dropoff.',
          untrackedDescription: 'No tracking records were received for this delivery.',
        },
        evidenceSection: {
          deliveryTimestamp: 'Delivery timestamps:',
          orderPickedUp: 'Order picked up:',
          orderMarkedDelivered: 'Order marked delivered:',
          markFoodReadyPhoto: '"Mark food ready" photo:',
          deliveryPhotos: 'Delivery photos:',
          compensation: 'Compensation:',
          notAvailable: 'Not available',
          markFoodReadyPhotosNoData:
            'If using ezDispatch, or if the order is for takeout, use the “Mark food ready” QR code on the order sheet to ensure each order is logged as ready on time.  <a>Learn more</a>',
          deliveryPhotosNoData:
            'To strengthen your case, use ezDispatch or the ezManage Driver app to take photos of the order when it’s been delivered.  <a>Learn more</a>',
        },
        formSection: {
          whichIssue: 'Which issue would you like to dispute?',
          disputeReason: 'Reason for the dispute',
          recommendedRefund: 'What refund do you recommend? (Optional)',
          fileUpload:
            'Share screenshots, logs, photographs, or documents that support your case. (Optional)',
          dragDropText: 'Drag and drop or',
          selectFileText: 'select a file',
          toUploadText: 'to upload',
          selectedFilesText: 'Selected files:',
          removeText: 'Remove',
          noFilesText: '0 files added',
          submitNote:
            "<strong>Please note:</strong> Once you submit this form, you won't be able to make any changes to it.",
          submitButton: 'Submit',
          selectedIssuesError: 'At least one selection is required.',
          disputeReasonError: 'Please explain your reason for disputing the selected issue(s).',
          submittingButton: 'Submitting...',
          submitSuccessMessage: "We've received your dispute and will be in touch shortly.",
          orderCanceled: 'Canceled order',
          orderRejected: 'Rejected order',
        },
      },
      KitchenInstructions: {
        header: 'Kitchen Notes',
      },
      ModificationBanner: {
        ezCaterSupportPhoneNumber: 'ezCater Support Phone Number',
        ezCaterSupportEmail: 'ezCater Support Email',
        confirmationTitle: 'Review and confirm new modifications',
        modificationTitle: "Here's what changed",
        helperText: `Can't make these changes? We can help. Call <a>1-800-488-1803</a> or email <email>support@ezcater.com</email>.`,
      },
      RequestModificationModal: {
        header: 'Order Support',
        button: 'Order Support',
        ContactEzCaterFormSection: {
          nameField: 'Who are we speaking with?',
          phoneField: 'Phone number (optional)',
          helpDetails: 'Describe how ezCater can help with this order.',
          helpDetailsSubtext:
            'Please be as specific as possible. The more details you provide, the better we can help you.',
          nextSteps: {
            line1: "We'll be in touch with next steps.",
            line2: 'This typically takes around 15-30 minutes, depending on urgency.',
            line3: 'Prefer to call us? 1 (800) 488-2085',
          },
          descriptionDetails: {
            contactDetails: 'Contact: {{catererContactName}}\n',
            otherRequestWithPhone: 'Other request: {{catererContactPhone}}: {{helpDetails}}',
            otherRequestWithoutPhone: 'Other request: {{helpDetails}}',
          },
          error: 'Field required',
        },
        ChangeStoreFormSection: {
          dropdownLabel: 'Choose a new store',
          subLabel: 'Sorted by distance to event address',
          currentStoreLabel: 'Current Store',
          catererDistance: '({{distance}}mi)',
          unknown: 'N/A',
          nextSteps: {
            line1: 'Next, an ezCater representative will update this (may take up to 24 hours)',
            line2: "You'll get a modified order when this change has been made.",
          },
          descriptionDetails: {
            contact: 'Contact: {{catererAccountName}}\n',
            requestedStoreChange: 'Store change request: {{newStore}}\n',
            newStoreValue: 'New store ID {{catererId}}, Store address: {{storeAddress}}',
          },
        },
        StructuredRequestModificationForm: {
          header: 'Support for Order {{orderNumber}}',
          supportTypes: {
            modifyOrder: 'Modify Order',
            clarifyWithCustomer: 'Clarify with Customer',
            contactEzCater: 'Contact ezCater (Other)',
          },
          fields: {
            title: 'What kind of modification?',
            modificationTypes: {
              deliveryTime: 'Request a new delivery time',
              replaceAnItem: 'Replace an item',
              addItem: 'Add an item',
              modifyItem: 'Modify an item',
              changeStore: 'Change store',
              addItemTypes: {
                addMenuItem: 'Add an existing item from my menu',
                addOffMenuItem: 'Add an off menu item',
              },
            },
          },
          firstTimeTooltip: {
            header: 'New: Order Support Requests',
            body: 'Better communication with ezCater customers on all orders. Request modifications to food, clarify an order with customers, and request partner support from ezCater.',
          },
          ReplaceItemSection: {
            sectionLabel: 'Which item(s) do you want to modify?',
            dropdownLabel: 'Replace with',
            dropdownPlaceholder: 'Choose a replacement item',
            orderItemLabel: '{{quantity}} {{name}} @ {{price}}',
            substitutionLabel: '{{name}} @ {{price}}',
            textareaLabel: 'Details about the replacement or removal',
            noOptionSelectedError: 'Select one of the options below',
            fieldLevelError: 'Ensure all selected options have the necessary information',
            textareaError: 'Ensure all selected options have the necessary information',
          },
          NewDeliveryTimeFormSection: {
            currentDeliveryTime: 'Current Delivery Time',
            selectLabel: 'New delivery time',
            selectPlaceholder: 'Choose a delivery time',
            newDeliveryTimeDetails: 'Details about the new delivery time (optional)',
            nextSteps: {
              line1: "Next, we'll contact the customer for approval (may take up to 24 hours)",
              line2: "Once the change is approved, you'll get a modified order to accept.",
            },
            descriptionDetails: {
              contact: 'Contact: {{catererAccountName}}\n',
              requestedNewDeliveryTime:
                'Requested new delivery time: {{newDeliveryTime}} {{timezone}}\n',
              messageFromCP: 'Message from CP: {{newDeliveryTimeDetails}}\n',
            },
          },
          customerClarification: {
            title: 'What do you need clarification on?',
            clarificationTypes: {
              contactInfo: 'Contact information',
              orderInfo: 'Order information',
              specialInstructions: 'Special instructions',
              other: 'Other',
            },
            form: {
              input: {
                label: 'Describe what you need clarified',
                helperText: 'Provide as much detail for the customer as possible',
                error: 'Please add clarification details.',
              },
            },
            nextSteps: {
              line1: 'A customer service representative will notify the customer right away.',
              line2: 'You will receive a response from the customer shortly.',
            },
            descriptionDetails: {
              contact: 'Contact: {{catererAccountName}}\n',
              clarificationNeededAbout: 'Clarification needed about: {{clarificationType}}\n',
              messageFromCP: 'Message from CP: {{clarificationDetails}}',
            },
          },
          ModifyItemFormSection: {
            label: 'Which item(s) do you want to modify?',
            nextSteps: {
              line1: "Next, we'll contact the customer for approval (may take up to 24 hours)",
              line2: "Once the change is approved, you'll get a modified order to accept.",
            },
          },
          AddItemFormSection: {
            label: 'What item would you like to add?',
            addMenuItemForm: {
              itemLabel: '{{name}}',
              itemValue: '{{name}}. Price: {{price}}',
              menuItemSelect: {
                label: 'Additional Item',
                placeholder: 'Choose a menu item',
              },
              quantitySelect: {
                label: 'Item quantity',
                placeholder: 'Choose a quantity',
              },
              textAreaLabel: 'Details about the new item (optional)',
            },
            addOffMenuItemForm: {
              itemName: {
                label: 'Item name',
                placeholder: 'Enter a name',
                error: 'Enter an item name',
              },
              itemCategory: {
                label: 'Item category',
                placeholder: 'Choose a category',
              },
              itemPrice: {
                label: 'Item price',
                placeholder: 'Enter a price',
                error: 'Enter a price',
              },
              itemQuantity: {
                label: 'Item quantity',
                placeholder: 'Choose a quantity',
              },
              textAreaLabel: 'Details about the new item (optional)',
            },
            description: {
              contact: 'Contact: {{catererAccountName}}\n',
              addOffMenuItem: 'Add off menu item to order: {{itemName}}. ',
              addMenuItem: 'Add menu item to order: {{itemName}}. ',
              price: 'Price: ${{price}}. ',
              quantity: 'Quantity: {{quantity}}. ',
              itemCategory: 'Category: {{itemCategory}}.\n',
              freeText: 'Message from CP: {{freeText}}\n',
            },
          },
        },
        RequestModificationForm: {
          fields: {
            reason: {
              label: 'How can we help you with this order?',
              placeholder: 'Select an option',
              required: 'Tell us how we can support you with this order.',
              dropdown: {
                itemUnavailable: 'Item Unavailable',
                priceAdjustment: 'Adjust Price',
                deliveryTime: 'Change Delivery Time',
                changeStore: 'Change Store',
                requestEzDispatch: 'Request ezDispatch',
                requestClarification: 'Request Clarification from Customer',
                other: 'Other',
              },
            },
            description: {
              label: 'Provide additional information',
              subheader:
                'Please be as specific as possible about your requested change or question.',
              required: 'Tell us how we can support you with this order.',
            },
            changeStore: {
              dropdownLabel: 'Change To',
              subLabel: 'Stores are sorted by distance to the delivery address',
              currentStoreLabel: 'Current Store',
              catererDistance: '({{distance}}mi)',
              unknown: 'N/A',
            },
          },
        },
        dismiss: 'Dismiss',
        submit: {
          default: 'Submit Request',
          requestModification: 'Request Modification',
          requestClarification: 'Request Clarification',
          contactEzCater: 'Send Message',
        },
        success:
          'We will do our best to accommodate your request and will reach out with any additional questions.',
      },
      RejectButton: {
        buttonText: 'Reject',
        flashMessages: {
          error: 'Unable to reject this order. Try again or contact support.',
          success: 'Order {{orderNumber}} was successfully rejected.',
          orderCapacitySuccess: 'Temporary closure successfully set for {{orderDate}}',
          temporaryClosureFailure: 'Sorry, your Temporary Closures could not be updated.',
        },
        dialog: {
          header: 'Why do you need to reject this order?',
          subheader:
            'Frequently rejecting orders hurts your search rank in the ezCater marketplace.',
          setTemporaryClosuresLabel:
            'Set a temporary closure for the rest of the day (prevent having to reject more orders)',
          alertTemporaryClosureAlreadySet: 'A temporary closure is already set for this day',
          footer: {
            cancel: "Nevermind, don't reject",
            submit: 'Reject',
            submitWithTemporaryClosure: 'Reject and add temporary closure',
          },
          performanceWarning:
            'Rejecting this order puts you at risk of falling below our reliability standards.',
          selectRejectionReason: {
            label: 'Select Rejection Reason',
            options: {
              foodPrep: 'Food Prep',
              delivery: 'Delivery',
              store: 'Store',
              other: 'Other',
            },
          },
          rejectionReason: {
            label: 'Reason for Rejection',
          },
          additionalContext: {
            label: 'Additional Context',
          },
          RequestEzDispatch: {
            button: 'Request ezDispatch',
            heading: 'Did you know you can get delivery help on demand?',
            subheading:
              'ezDispatch lets you hand deliveries off to ezCater’s vetted network of reliable delivery partners.',
            pitchList: {
              bullet1: 'You request ezDispatch on an order you can’t deliver.',
              bullet2: 'ezCater emails you when we confirm a delivery partner.',
              bullet3: 'A driver picks up the order and delivers it for you.',
            },
            payment:
              'The customer pays you your standard delivery fee. You pay {{value, currency}} for ezDispatch, and tips go to the driver.',
            learnMore: 'Learn more about ezDispatch',
          },
        },
      },
      completeExternalPayment: {
        button: 'Mark as Paid',
        modal: {
          submitButton: 'Mark as Paid',
          dismissButton: 'Cancel',
          header: 'Mark as Paid',
          description: 'Are you sure you want to mark this order as paid?',
          sendReceiptToCustomerLabel: 'Send an updated receipt to the customer',
        },
        flashMessageWithoutReceipt:
          'Order has been successfully marked as paid. We’ve sent your team a notification.',
        flashMessageWithReceipt:
          'Order has been successfully marked as paid. We’ve sent your team a notification and emailed the customer a receipt.',
      },
      markAsUnpaid: {
        button: 'Mark as Unpaid',
        modal: {
          description: 'Are you sure you want to mark this order as unpaid?',
          dismissButton: 'Cancel',
          header: 'Mark as Unpaid',
          submitButton: 'Mark as Unpaid',
        },
        flashMessage:
          "Order has been successfully marked as unpaid. We've sent your team a notification.",
      },
      buttons: {
        reconfirm: 'Reconfirm',
        cancel: 'Cancel',
        confirmCancel: 'Confirm Cancellation',
        accept: 'Accept',
        edit: 'Edit',
        duplicateOrder: 'Duplicate Order',
        requestEzDispatch: 'Request ezDispatch',
        confirmOrderModification: 'Confirm modification',
        requestModification: 'Order Support',
        dismiss: 'Never mind',
      },
      disabledEditMessageEzD:
        'ezDispatch accepted orders cannot be edited within 90 minutes of the fulfillment time. For any last minute edits to this order, please call 1-800-488-1803',
      disabledEditMessageFinalized:
        'Orders can only be edited in the 20 days after fulfillment or cancellation',
      AnonymousContactMessages: {
        accept: 'Order Accepted!',
        reconfirm: 'Order Reconfirmed!',
        content: {
          login:
            'Optimize your catering business. ezManage is your ezCater home base. Log in to manage your orders, boost your search ranking, and monitor your performance and reviews.',
          signUp:
            'Optimize your catering business. ezManage is your ezCater home base. Create your account to manage your orders, boost your search ranking, and monitor your performance and reviews.',
        },
        actions: {
          login: 'Log in to ezManage',
          signUp: 'Create your ezManage account',
        },
      },
      CatererOrderMessage: {
        CANCELLATION_CONFIRMED_BY_CATERER: {
          message: `Note: This order has been canceled. <strong>If you'd like to dispute this cancellation, </strong><a>contact us.</a>`,
        },

        NEEDS_ACCEPTANCE_AFTER_THIRD_PARTY_DELIVERY_FAILED: {
          message:
            'Unfortunately, our partners do not have a driver available to deliver this order. Please accept or reject this order.',
        },
        NOTE: {
          message: 'Note: {{note}}',
        },
        PCP_TRIAL_EXPIRED: {
          message:
            'Your Preferred Partner Trial has expired.\nWe will deduct an extra {{note}}% marketing fee from the subtotal of this order.',
        },
        REJECTED: {
          message: `Note: This order has been rejected. <strong>If you'd like to dispute this rejection, </strong><a>contact us.</a>`,
        },
        REVISED: {
          message: 'Order changed: {{note}}',
        },
        THIRD_PARTY_DELIVERY_REQUEST_ACCEPTED: {
          message: 'ezDispatch confirmed. A driver has accepted this delivery.',
        },
        THIRD_PARTY_DELIVERY_REQUESTED: {
          actionText: 'ezDispatch Requested!',
          message:
            'We will contact you shortly to confirm whether one of our partners can deliver this order.',
        },
        STANDARD_GROUP_ORDER: {
          actionText: 'Group Order!',
          message: 'If a name appears with an item, please label it with that name.',
        },
      },
      flashMessages: {
        reconfirm: {
          success: 'Order {{orderNumber}} reconfirmed.',
        },
        accept: {
          success: 'Order {{orderNumber}} accepted.',
        },
        requestEzDispatch: {
          success: 'ezDispatch successfully requested for {{orderNumber}}.',
        },
        confirmCancelledOrder: {
          success: 'Order {{orderNumber}} cancellation confirmed.',
        },
        confirmOrderModification: {
          success: 'Change confirmed.',
        },
        remainingOrders_one: 'You have 1 more order that requires your action. View it <a>here</a>',
        remainingOrders_other:
          'You have {{count}} more orders that require your action. View them <a>here</a>',
        contactUs: 'If something comes up, please call us at 1-617-712-0090.',
      },
      confirmationDetails: {
        confirmationCode: {
          label: 'Confirmation Number',
          tooltip:
            'Questions regarding this order? Use this confirmation number when calling our support team',
        },
        exportOrderOptions: {
          label: 'Select options',
          modificationConfirmationLabel: 'Do you want to print an updated order sheet?',
          displayPrices: 'Show prices',
          displayKitchenInstructions: 'Display kitchen instructions',
          displayItemDescriptions: 'Display item descriptions',
        },
        downloadPDFModal: {
          openButton: 'Download PDF',
          header: 'Please select options for your PDF:',
          cancel: 'Never mind',
          confirm: 'Download PDF',
        },
        printOrderModal: {
          openButton: 'Print order',
          header: 'Printing order {{orderNumber}}:',
          confirm: 'Print order sheet',
          secondaryConfirm: 'Download PDF',
        },
      },
      taxExempt: {
        notice: 'Tax-exempt order',
        link: '(view certificate)',
      },
      backToIndex: 'Back to Orders',
      backToHouseAccount: 'Back to House Account',
      backToCustomerTimeline: 'Back to Customer',
      backToLeadTimeline: 'Back to Lead',
      deliveryDetails: {
        title: 'Delivery Details',
        consolidatedDeliveryDetailsTitle: 'Deliver to',
        deliverySetup: 'Setup required',
        deliverySetupTooltip: 'The driver will unpack and lay out the items in the order.',
        distance: 'Distance',
        distanceDisplay: '{{distance}} mi',
        driverAskFor: 'Upon Delivery Ask For',
        phone: 'Phone',
        deliveryInstructions: 'Delivery Instructions',
        locationLabel: 'Location',
        addressLabel: 'Address',
        partner: 'Partner',
        deliveryStatus: 'Delivery Status',
        assignedDriver: 'Assigned Driver',
        pickupTime: 'Pickup Time',
        ezDispatchWhenever: {
          button: 'Request ezDispatch',
          modal: {
            header: 'Request ezDispatch',
            contentOne:
              "ezDispatch lets you hand deliveries off to ezCater's vetted network of reliable delivery providers.",
            contentTwo:
              'The customer pays you your standard delivery fee. You pay {{deliveryCharge}} for ezDispatch, and tips go to the driver.',
            contentTwoDefault:
              'The customer pays you your standard delivery fee. You pay 10% of the order subtotal with a $30 minimum for ezDispatch, and tips go to the driver.',
            contentThree: 'Learn more about ezDispatch',
          },
          flashMessages: {
            success:
              'ezDispatch requested! We will contact you shortly to confirm whether one of our partners can deliver this order.',
          },
          disabledToolTip: {
            default: 'ezDispatch is unavailable for this order.',
            nonCreditCardOrder:
              'ezDispatch is currently only available for orders paid with a credit card.',
          },
        },
        orderType: {
          DELIVERY: 'Delivery',
          TAKEOUT: 'Takeout',
          THIRD_PARTY_DELIVERY: 'ezDispatch',
        },
      },
      driverAssignmentFlashMessage: {
        small: {
          headline: 'You must assign a driver to the delivery.',
          message: '',
        },
        large: {
          headline: 'This delivery does not have a driver assigned.',
          message: 'You must assign a driver to the delivery.',
        },
        learnMore: 'Learn More',
      },
      customerDetails: {
        title: 'Customer Details',
        name: 'Name',
        phone: 'Phone Number',
        email: 'Email',
        company: 'Company',
      },
      orderDetails: {
        unknownHouseAccount: 'Unknown House Account',
        title: 'Order Details',
        confirmationCodeTooltip:
          'Questions regarding this order? Use this confirmation number when calling our support team',
        inStorePaymentDisplay: 'In-store',
        creditCardPaymentDisplay: '{{cardType}} ending in {{last4}}',
        houseAccountPaymentDisplay: 'House Account {{houseAccountName}}',
        labels: {
          status: 'Order Status',
          orderType: 'Order Type',
          date: 'Date & Time',
          time: 'Time',
          headcount: {
            people: '{{headcount}} people',
            person: '{{headcount}} person',
            label: 'Headcount',
            display_value_one: '{{count}} person',
            display_value_other: '{{count}} people',
          },
          payment: 'Payment',
          location: 'Location',
          address: 'Address',
          store: 'Store',
          externalOrderNumber: 'Invoice number',
          confirmationCode: 'Confirmation code',
          customerRequestedTime: 'Customer requested delivery time',
          customerPickupTime: 'Customer pickup time',
          dropoffWindow: 'Delivery window',
        },
        orderType: {
          DELIVERY: 'Delivery',
          TAKEOUT: 'Takeout',
          THIRD_PARTY_DELIVERY: 'ezDispatch',
        },
        pickupTime: '({{pickupTimeString}} pickup)',
        cardSectionTitle: 'Order on {{date}} at {{eventTimeString}}',
      },
    },
    OrderMessage: {
      title: 'Contact Customer',
      backToOrderBreadcrumb: 'Back to Order {{orderNumber}}',
      submissionSuccessFlashMessage:
        "Message sent! You'll get an update when the customer responds.",
      submissionFailureFlashMessage:
        'Oh Crumbs! There was a problem sending your message. Please try again or contact support.',
      BuildTheMessageCard: {
        title: 'Create Message',
        selectMessageTypeLabel: 'What kind of request?',
        selectMessageTypePlaceholder: 'Select an option',
        messageTypes: {
          changeTime: 'New {{orderType}} time',
          addItem: 'Added charge for customer request',
          modifyItem: 'Item adjustment for customer request',
          itemUnavailable: 'Substitution for unavailable item',
          askAQuestion: 'More information',
        },
        TimeChangeRequest: {
          currentTimeLabel: '{{orderType}} time',
          requestedTimeLabel: 'Customer requested {{orderType}} time',
          requestedDeliveryTimeTooltip:
            'The customer originally requested this time. A 15 minute buffer will be added.',
          newTimeLabel: 'New {{orderType}} time',
          newTimePlaceholder: 'Choose a {{orderType}} time',
          reasonForRequestLabel: 'Reason for request',
          reasonForRequestPlaceholder: 'e.g. I am double booked during this time...',
          defaultCustomerMessage:
            'Hello. Is your {{orderType}} time flexible? Please let us know if this new time is okay. Thank you.',
        },
        AskAQuestionRequest: {
          clarificationLabel: 'What do you need clarification on?',
          clarificationPlaceholder: 'Select clarification',
          clarificationTypes: {
            contactInformation: 'Contact information',
            deliveryInformation: 'Delivery information',
            dietaryRestrictions: 'Dietary restrictions',
            other: 'Other',
            quantityOrSizeOfOrder: 'Quantity or size of order',
            specialInstructions: 'Special instructions',
            utensils: 'Utensils',
          },
        },
        ItemUnavailableRequest: {
          ReplaceItemOption: {
            quantityLabel: 'How many items?',
            selectItemLabel: 'Substitute with',
            reasonLabel: 'Reason for substitution?',
            reasonPlaceholder: 'e.g. ran out of ingredient',
          },
          whichItemsToReplace: 'Which item(s) do you want to modify?',
          substituteWith: 'Substitute with',
          reasonForSubstitution: 'Reason for substitution',
          defaultCustomerMessage:
            'Hello. Items you ordered are unavailable. Please let us know if this substitution is okay. Thank you.',
        },
        ModifyItemRequest: {
          header: 'Which item(s) do you want to modify?',
          quantityLabel: 'How many items?',
          reasonForRequestPlaceholder: 'e.g. Customer requested extra sauce',
          reasonForRequestLabel: 'Reason for modification?',
          defaultCustomerMessage:
            'Hello. We’ve updated your order based on your request. Please let us know if this looks correct. Thank you.',
        },
        MessageCustomerField: {
          label: 'Message for the customer',
          placeholder: 'Type a message for the customer',
        },
        MenuItemForm: {
          sizeLabel: 'Select size:',
          choicesLabel: 'Select:',
          subQuantityLabel: 'Select sub-quantity:',
        },
        AddItemRequest: {
          menuItemTypeLabel: 'What item would you like to add?',
          addMenuItemLabel: 'Add an existing item from my menu',
          addOffMenuItemLabel: 'Add an off-menu item',
          optionsLabel: 'Specify the item options:',
          selectItemLabel: 'What do you want to add?',
          quantityLabel: 'How many items?',
          reasonForRequestPlaceholder: 'e.g. customer asked for extra bread',
          reasonForRequestLabel: 'Reason for addition?',
          defaultCustomerMessage:
            'Hello. There’s an added item for your request. Please let us know if this is okay. Thank you.',
        },
        SelectMenuItem: {
          selectItemPlaceholder: 'Start typing or select an item from the dropdown',
        },
        OffMenuItemForm: {
          name: {
            label: 'What do you want to add?',
            placeholder: 'Item name',
          },
          cost: {
            label: 'How much does it cost?',
            placeholder: '10.00',
          },
          quantity: {
            label: 'How many items?',
            placeholder: '1',
          },
        },
      },
    },
    Performance: {
      title: 'All Stores',
      performanceMetricsLink: 'Return to new performance page',
      filters: {
        timespan: {
          label: 'Timeframe',
          options: {
            MONTH: 'Month to Date',
            WEEK: 'Week to Date',
            YEAR: 'Year to Date',
          },
        },
        orderSources: {
          label: 'Sources',
          ezOrderingPopup: {
            header: 'More catering business. For less.',
            content:
              'Take catering orders from your website with ezOrdering. Get the same online ordering experience without ezCater branding at a lower cost per order.',
            link: 'Learn more about ezOrdering',
          },
        },
      },
      summary: {
        totalSales: {
          header: 'Caterer Total Due',
          tooltip: 'Caterer Total Due is the amount ezCater paid you in this timeframe.',
        },
        totalFood: {
          header: 'Food Sales',
          tooltip:
            'Food Sales is the dollar amount of food sold in this timeframe. It does not include taxes, tips, delivery fees, commission, or modifications.',
        },
        totalOrderCount: 'Total Order Count',
        averageOrderValue: 'Average Order Value',
      },
      table: {
        headers: {
          storeNickname: 'Store Nickname',
        },
        titles: {
          default: 'All Stores',
          personalStoreGroup: 'Stores in this group',
        },
        subtitle: 'Compared to the same period last year',
        toggle: {
          label: 'Show growth as',
          percentSymbol: '%',
          currencySymbol: '$',
        },
      },
      viewSalesForAllStores: 'View Sales for All Stores',
    },
    PerformanceMetrics: {
      title: 'Performance',
      storesTable: {
        title: 'All stores',
        headers: {
          name: 'NAME',
          catererTotalDue: 'CATERER TOTAL DUE',
          sales: 'SALES',
          totalOrders: 'TOTAL ORDERS',
          newCustomers: 'NEW CUSTOMERS',
          aov: 'AOV',
        },
      },
      backLink: 'Revert to previous performance page',
      filters: {
        timeframe: 'Time range',
        stores: 'Stores',
        orderSources: 'Sources',
        compareTo: 'Compare to',
        allSources: 'All sources',
        allStores: 'All stores',
        allStoresOption: 'Select all stores',
        storesSelected_one: '{{count}} store selected',
        storesSelected_other: '{{count}} stores selected',
        groupDisplay: '(Group) - {{name}}',
        orderSourceOptions: {
          ezOrdering: 'ezOrdering',
          marketplace: 'Marketplace',
          relish: 'Relish',
          directEntry: 'Direct Entry',
        },
        compareToOptions: {
          lastYear: 'Previous year',
          restaurantsLikeMe: 'Restaurants like me',
        },
      },
    },
    PerformanceStore: {
      header: {
        defaultTitle: 'Unknown Location',
      },
      filters: {
        timespan: {
          label: 'Timeframe',
        },
      },
    },
    Payments: {
      title: 'Financials',
      currentPayPeriod: 'Current pay period',
      nextPayment: 'Payment processed by ezCater',
      estimatedPaymentDate: 'Estimated payment date',
      tabs: {
        reports: 'Reports',
      },
      paymentDateTooltip: {
        ach: 'Payments sent via ACH usually arrive on the payment date, except if the date falls on a weekend.',
        check:
          'Payments sent via Check usually arrive in 7-10 business days but are affected by the speed of the postal service.',
      },
      PaymentRecipient: {
        forCaterer: 'Caterer',
        forBillingBlock: 'Billing Block',
      },
      table: {
        headers: {
          sentOn: 'Sent on',
          method: 'Method',
          recipient: 'Recipient',
          amount: 'Amount',
        },
        rows: {
          viewDetails: 'View Details',
          paymentWithProcessor: '{{paymentMethod}} processed by {{processedBy}}',
          paymentMethod: {
            ach: 'ACH',
            check: 'Check',
            credit_card: 'Credit Card',
            no_payment: 'No Payment',
            one_off_check: 'Check',
            manual_check: 'Check',
          },
          pendingPayment: 'Pending',
          paymentHeldReason: {
            minimumPayment:
              'The minimum payout is {{minimumAmount}}. This amount will be rolled into future orders until your total is greater than {{minimumAmount}}.',
            default:
              'This payout is temporarily on hold. Your money is secure. If you need help right away, contact Partner Support.',
          },
        },
        emptyState: {
          header: 'We’re plating your first payment',
          description:
            'We send payments out every week, and the next payment is scheduled to be sent out on {{nextPaymentDate, MM/DD/YY}}. It can take a few business days for payments to show up in your bank account or arrive by mail.',
          contact: 'Contact <a>{{supportEmail}}</a> if you have any questions.',
        },
      },
    },
    PaymentDetails: {
      title: '{{sentOn}} Payment Details',
      pendingTitle: 'Pending payout breakdown',
      breadcrumb: 'Back to all payments',
      backToPaymentDetails: 'Back to Payment Details',
      pending: 'Pending',
      info: 'The minimum payout is ${{minimumAmount}}. Balances below ${{minimumAmount}} will be rolled into your payout from future orders.',
      breakdown: {
        title: 'Payment Breakdown',
        food: 'Food Total',
        deliveryFees: 'Delivery Fees',
        allCommission: 'Commission',
        marketplaceCommission: 'Marketplace Orders',
        ezOrderingCommission: 'ezOrdering Orders',
        directEntryCommission: 'Direct Entry Orders',
        clubSodaCommission: 'Relish Orders',
        salesTax: 'Sales Tax',
        salesTaxCollected: 'Sales Tax Collected',
        salesTaxLearnMore: 'Learn more',
        salesTaxRemitted: 'Sales Tax Remitted By ezCater',
        tips: 'Tips',
        marketplaceFeesTax: 'Marketplace Fees Tax',
        adSpend: 'Ad Spend',
        marketingTax: 'Marketing Tax',
        marketingCredit: 'Marketing Credit',
        creditCardFees: 'Payment Transaction Fee',
        adjustments: 'Adjustments',
        discounts: 'Discounts',
        miscFees: 'ezDispatch Charges & Misc. Fees',
        externalIntegrationFees: 'External Integration Fees',
        allMarketingSpend: 'Marketing Spend',
        preferredCatererMarketingSpend: 'Preferred Partner Program',
        ezRewardsMarketingSpend: 'ezRewards Program',
        sponsoredListingsMarketingSpend: 'Sponsored Listings',
        sponsoredListingsMarketingTax: 'Sponsored Listings Tax',
        ezDispatchFees: 'ezDispatch Fees',
        paidByEzCater: 'Paid by ezCater',
        pendingPayout: 'Pending payout',
        promoSpend: 'Promotions',
        adjusted: {
          header: 'Adjusted payment total',
          explanation:
            'Orders in this payment period were adjusted by ezCater after the original payment was sent. The difference will be reflected in the payment period those orders were adjusted in.',
          orderDetailsPrompt:
            'Orders with adjustments are shown in the downloadable order details report.',
        },
        allOrdersTotal: 'Total for all orders',
        separatelyPaid: 'Paid to you separately by ezCater',
        tooltips: {
          adjustments:
            'Discounts or Credits made to an order on your behalf by ezCater’s support staff. Individual orders with adjustments can be found in the downloadable order report.',
          allMarketingSpend:
            'Programs to boost your marketplace ranking and get more orders. Visit the Marketing Tools page to see or change your settings.',
          discounts:
            'Promotional discounts applied to an order. Individual orders with discounts can be found in the downloadable order report.',
          miscFees:
            'Includes ezDispatch charges paid by the caterer, as well as fees like automatic gratuity and packaging fees that are paid by the customer. The downloadable order report provides a further breakdown of individual order details.',
          externalIntegrationFees:
            'Fees for external system integrations (e.g., third-party ordering platforms).',
          calculations: {
            foodTotal: 'Food Total',
            deliveryFees: 'Delivery Fees',
            commissionRate: 'Commission Rate',
            taxRate: 'Tax Rate',
            salesTax: 'Sales Tax',
            creditCardFee: 'Payment Transaction Fee',
            varies: 'Varies',
            variesBySource: 'Varies by source',
          },
          salesTax: {
            description:
              'This is the total sales tax passed through for you to remit. Sales tax is assessed for all applicable order items which may include food, beverages, and/or service fees. The sales tax rate used on your orders is based on the store location.',
          },
          promoSpend:
            "Promotions you've created and funded for your ezOrdering site, that were active and redeemed during this payment period. Visit the Promotions page to view or end your promotions.",
          allOrdersTotal: 'Includes any order completed or adjusted during this payment period.',
          separatelyPaid:
            'This amount was included in a separate payment. It appears in this report because this order has been adjusted after at least one payment was issued.',
        },
      },
      overview: {
        includesOrdersFrom: 'Payment includes orders from',
        method: 'Method',
        paidByEzCater: 'Paid by ezCater',
        paymentMethod: '{{paymentMethod}} processed by {{processedBy}}',
        recipient: 'Recipient',
      },
      reports: {
        downloadAction: 'Download Order Details',
        downloadInProgress: 'Creating your report...',
        reportLink: 'Download my report',
      },
      table: {
        title: 'Orders in this Payment',
        headers: {
          order: 'Order #',
          date: 'Date',
          location: 'Location',
          address: 'Address',
          source: 'Order Source',
          paid: 'Paid by ezCater',
        },
      },
    },
    Payoneer: {
      unregisteredTitle: {
        headerText: 'Payoneer registration',
        subheader: `To complete your Payoneer application, you'll need to complete 2 steps of verification. If you're the financial contact for multiple businesses, a separate application is available here for each.`,
      },
      approvedTitle: {
        headerText: 'Accessing Payoneer',
        subheader: `Now that you're fully registered with Payoneer, your payments will be processed on your regular schedule. There's no need to log in to Payoneer, as ezCater will continue to handle payments support. For any questions, check the FAQ below.`,
      },
      successFlashMessage: 'Form Submitted succesfully',
      registeredBusinessCard: {
        headers: {
          address: 'ADDRESS',
          federalTaxId: 'TAXPAYER ID',
          federalTaxIdPrefix: 'TIN ending in',
          payoneerAccountEmail: 'PAYONEER USERNAME',
          stepOneTitle: 'Step 1 - Registration',
          status: 'Status',
        },
        statusDetails: {
          pending: `Payoneer has received your application. They will reach out to you by email after several business days, and we'll update your account status here.`,
          approved:
            "You're approved by Payoneer and ready to receive payments! All the details are in an email from Payoneer.",
          notApproved: 'Payoneer was unable to approve your account.',
          notApprovedLine2:
            'Check for an email from Payoneer with the details and steps you can take.',
        },
        prepopulationNotice:
          'Please pre-fill my application with the details you have on file. I understand this means sharing ezCater account information with Payoneer solely for this purpose, and only to the extent necessary for my application.',
        errorMessage: 'There was an error processing your request',
        stepTwo: {
          title: 'Step 2 - Tax ID',
          alert:
            'Please complete Step 1 first. The information you enter in Step 1 will create the tax form for Step 2.',
          alert2: `Thanks for completing Step 1. Your tax form is being created.
It should only take a moment, so refresh the page. If there’s a delay, we’ll also send you an email when the form is ready.`,
          link: 'Start tax form',
          chipCompleted: 'Completed',
          chipPending: 'Pending',
        },
        declinedStatus: 'Not approved',
        usernameTooltip:
          'You shouldn’t need to access the Payoneer site, but if you ever want to, this version of your email address will be your username. Any email communication will go to your regular address we have on file. The information you enter in Step 1 will create the tax form for Step 2.',
        usernameAlert:
          'Your Payoneer username is automatically assigned to you based on your email address. You would only use this to log in to the Payoneer website. There is no change to how ezCater communicates with you.',
        locationsModal: {
          trigger: 'See associated stores',
          header: 'Associated Stores',
          dismiss: 'Dismiss',
          storeCount_one: '{{count}} total store',
          storeCount_other: '{{count}} total stores',
        },
      },
      supportLink: `We are moving all of our restaurant partners to a new payment platform called Payoneer. This new platform will help us send you payments and tax information more smoothly and efficiently. Click on the 'Begin application' button next to the name of your business to start the registration process.
      <br /><br /> For more help, please contact <4>partnersuccess@ezcater.com</4>.`,
      FAQNav: [
        {
          label: 'General',
          accessibilityLabel: 'General Questions',
        },
        {
          label: 'Registration',
          accessibilityLabel: 'Registration Questions',
        },
        {
          label: 'Support',
          accessibilityLabel: 'Support Questions',
        },
        {
          label: 'Payments',
          accessibilityLabel: 'Payment Questions',
        },
      ],
      FAQ: {
        title: 'Frequently Asked Questions',
        videoTitle: 'What is Payoneer?',
        videoSubTitle: 'Check out our videos and help center articles.',
        General: [
          {
            question: 'What is Payoneer?',
            answer:
              "Payoneer is ezCater's new payment processor. All catering partners on ezCater must register with Payoneer to get paid.",
          },
          {
            question: 'What information will I need to complete this registration?',
            answer:
              'You will need your business license/registration (or certificate of incorporation) and W-9 form to complete the registration.',
          },
          {
            question: 'Why do I need to register with Payoneer?',
            answer:
              'So we can pay you! Please register with Payoneer as soon as possible to ensure you continue to receive your payments from ezCater.',
          },
          {
            question: 'Where will this application link take me?',
            answer:
              'This link will open up a secure registration form that will ask you to fill in relevant personal, company, bank, and tax information.',
          },
        ],
        Registration: [
          {
            question: 'How will I know when my payment setup is complete?',
            answer:
              'Payoneer will send you an approval email once you complete your registration. They will also provide email updates once your tax form has been completed. You can also come back and check your status on this page anytime.',
          },
          {
            question: 'What happens after I complete the registration?',
            answer:
              'It may take up to 3 business days to review and process your application. Payoneer will notify you with an email when you are approved. If required, Payoneer may reach out for additional verification information.\n\nYou can always return to this page to view your approval status.',
          },
          {
            question: 'What changes will I see after I complete my registration and tax forms?',
            answer:
              "Your payments will still be running on the same schedule as before and ezCater will still send the same payment emails you're used to. Additionally, Payoneer will provide you with transactional email updates throughout the Payment setup process or if they need any additional information.",
          },
          {
            question: 'What should I do if I have multiple stores/brands on ezCater?',
            answer:
              "If you have multiple businesses on ezCater, you will need to complete the Payoneer registration and tax forms for each business. Start by clicking 'begin application' next to one of your businesses. Once the Payoneer registration is complete, fill out the tax forms and complete the process.\n\nYou will need to follow the same steps for each business.\n\n(Please note, being marked as approved means your registration is complete. Payoneer will send you a separate email to notify you of approval or ask for more information.)\n\nYou can check the status of each business on the payment setup page at any time.\n\n",
          },
        ],
        Support: [
          {
            question:
              'Where is the best place to access all my payment information — my Payoneer account or the payments tab in ezManage?',
            answer:
              'The payments tab in ezManage is the best place for all payment-related information and reporting. Use the payments tab to view your customer payment history and billing cycle.',
          },
          {
            question: "I don't understand what to do. Who can I contact for help?",
            withLink: 'supportLink',
          },
          {
            question: 'Who should be designated as my financial contact?',
            withLink: 'financialContactLink',
          },
        ],
        supportLink: `Click on the 'Begin application' button next to the name of your business to start the registration process. You'll be guided through the application from there.\n\nFor more help, email <4>partnersuccess@ezcater.com</4>.`,
        financialContactLink: `Your financial contact will be responsible for filling out all financial, bank, and tax information on behalf of your registered business. This could be your business owner, financial manager, accountant or another team member.<br/><br/>To update your financial contact information, please email <a>partnersuccess@ezcater.com</a>.`,
        Payments: [
          {
            question: 'Is there a minimum payout amount for my payments?',
            answer:
              "Yes, our new payment platform requires a $20 minimum payout amount. Your payout will stay with ezCater until your total payout amount is larger than $20. At that time, all of your previous smaller payouts will be paid to you in that week's payout run.",
          },
          {
            question:
              'If I need to change my banking info later, how do I update my ezCater payments?',
            withLink: 'paymentsUpdateInfo',
          },
          {
            question: 'Will this impact my current ezCater payment schedule?',
            withLink: 'paymentsImpactSchedule',
          },
          {
            question: 'Is this new payment platform secure?',
            withLink: 'paymentsPlatformLink',
          },
          {
            question:
              'I currently get paid through check. Why do I have to change my payment method from check to ACH?',
            answer:
              'Payoneer makes direct payments through ACH only. This is a faster and safer way to pay you. In order to keep your payments running smoothly, please complete the registration above.\n\nPlease be prepared with your business, bank, and tax details. Your ACH information will be collected in the Payoneer registration form.',
          },
        ],
        paymentsUpdateInfo: `To change how your direct deposits (ACH) are routed, you can update the information using our link here: <a>http://ezcater.com/ach</a>. Once the form is submitted ezCater will process the request.`,
        paymentsImpactSchedule: `No. Once you've been approved through Payoneer, your ezCater payment schedule will remain the same. We aim to ensure that your payment schedule remains uninterrupted. <br/><br/>
<strong>If you received payments via check:</strong> Please note, check payments are no longer supported. If you have not transitioned to direct deposit (ACH) yet, please do so at your earliest convenience.`,
        paymentsPlatformLink: `Yes. Payoneer is a global payment platform company that specializes in secure financial transactions and tax solutions. Learn more <a>on the Payoneer site</a>.`,
      },
    },
    Settings: {
      title: 'Settings',
      groups: {
        title: 'Groups',
        table: {
          title: 'Groups',
          groupCount_one: '{{totalCount}} group',
          groupCount_other: '{{totalCount}} groups',
          headers: {
            name: 'Name',
            stores: 'Stores',
          },
          columns: {
            storeCount_one: '{{totalCount}} store',
            storeCount_other: '{{totalCount}} stores',
          },
          search: {
            placeholder: 'Filter groups by name',
          },
        },
        createGroup: {
          callToAction: 'Create Group',
          modal: {
            header: 'Create Group',
            groupName: 'Group Name',
            submit: 'Submit',
            dismiss: 'Cancel',
            submitFailedError: 'Unable to create this group. Try again or contact support.',
          },
        },
        emptyState: {
          title: "You don't have any groups yet",
          subtitle:
            'Create a group of stores to quickly view orders, performance, and reviews for those stores.',
        },
      },
      services: {
        title: 'Services & fees',
      },
      users: {
        title: 'Users & permissions',
        table: {
          title: 'All Users',
          headers: {
            name: 'Name',
            email: 'Email',
            accountType: 'User Type',
            accountStatus: 'Account Status',
          },
          search: {
            placeholder: 'Filter users by name, email',
          },
          clearFilters: 'Clear filters',
          accountType: {
            unrestricted: 'Brand Admin',
            standard: 'Standard User',
          },
          accountStatusMap: {
            ACTIVE: 'Active',
            NEEDS_ACTIVATION: 'Needs Activation',
            PASSWORD_RESET: 'Password Reset',
            DEACTIVATED: 'Deactivated',
            NO_ACCOUNT: 'Not yet invited',
          },
          accountStatusFilters: {
            nonDeactivated: 'All',
            active: 'Active',
            invited: 'Invited',
            noAccount: 'Not yet invited',
            deactivated: 'Deactivated',
          },
          userCount_one: '{{formattedCount}} user',
          userCount_other: '{{formattedCount}} users',
          actions: {
            addNewUser: 'Add New User',
          },
        },
      },
      settingsBanner: {
        alertBanner: {
          storeAddress: `<strong>Store located at {{storeReference}} is temporarily paused on the ezCater marketplace</strong>
          <br/>`,
          storeNumber: `<strong>Store #{{storeReference}} is temporarily paused on the ezCater marketplace</strong>
          <br/>`,
          body: `This store is unable to accept new marketplace orders because it has fallen below our reliability standards. Adjusting your capacity settings and keeping them current will help you to maintain high reliability.`,
          bodyWithReason: `This store is unable to accept new marketplace orders because it has fallen below our reliability standards for {{reason}}. Adjusting your capacity settings and keeping them current will help you to maintain high reliability.`,
        },
        warningBanner: {
          storeAddress: `<strong>Store located at {{storeReference}} is at risk of being temporarily paused on the ezCater marketplace</strong>
          <br/>`,
          storeNumber: `<strong>Store #{{storeReference}} is at risk of being temporarily paused on the ezCater marketplace</strong>
          <br/>`,
          body: `This store is close to falling below our reliability standards, which could result in its being unable to accept new marketplace orders.
          <a>Visit the operational metrics page in ezManage</a> for details and next steps.`,
          bodyWithReason: `This store is close to falling below our reliability standards, which could result in its being unable to accept new marketplace orders.
          <a>Visit the operational metrics page in ezManage</a> for details and next steps.`,
        },
      },
      account: {
        title: 'Account',
        cancel: 'Cancel',
        changePassword: {
          action: 'Send Password Reset Email',
          description: 'Change the password you use to sign into ezManage',
          flashSuccess: 'Password reset request processed. Please check your email.',
          modal: {
            description: 'Change the password you use to sign into ezManage.',
          },
          title: 'Password',
        },
        changeUsername: {
          title: 'Username',
          description: 'Change the username you use to sign into ezManage',
          action: 'Change Username',
          flashSuccess: 'Username successfully changed!',
          modal: {
            description: 'Change the username you use to sign in to ezManage.',
            username: 'Username',
            password: 'Confirm password',
            errors: {
              username: {
                blank: 'Username can’t be blank',
                invalid: 'Username is invalid',
              },
              currentPassword: 'Password can’t be blank',
            },
          },
        },
      },
      store: {
        index: {
          title: 'Store settings',
          search: {
            prompt: 'Filter stores by name, number, or address',
            clear: 'Clear filters',
          },
          table: {
            title: 'All stores',
            storeCount_one: '{{count}} store',
            storeCount_other: '{{formattedCount}} stores',
            headers: {
              storeNickname: 'Store nickname',
              storeNumber: 'Store number',
              storeAddress: 'Address',
              demographicDataUpdatedAt: 'Last updated',
            },
            bulkEditAction: {
              actionText: 'Edit selected',
              noStoresSelected: 'Select stores to edit',
              selectedStoreCount_one: '{{formattedCount}} store selected',
              selectedStoreCount_other: '{{formattedCount}} stores selected',
            },
          },
        },
        details: {
          backButton: 'Back to Store Settings',
          viewMarketplace: 'View your live menu here',
          requestStoreUpdates: 'Request store updates',
          requestUpdateLink: 'Request Update →',
          editSetting: 'Edit',
          updateSettingsCallToAction: {
            header: 'Need to update these settings?',
            subheader: 'Request an update or email partnersuccess@ezcater.com with your changes.',
            button: 'Request Update →',
          },
          storeProfile: {
            title: 'Store Profile',
            storeDetails: {
              header: 'Store Details',
              table: {
                headers: {
                  storeNickname: 'Store Nickname',
                  storeNumber: 'Store Number',
                  pickupInstructions: 'Pickup instructions',
                },
              },
            },
            contactInformation: {
              header: 'Contact Information',
              table: {
                headers: {
                  address: 'Address',
                  phone: 'Phone',
                  email: 'Email',
                },
              },
            },
          },
          notifications: {
            title: 'Notifications',
            storeContacts: {
              header: 'Store Contacts',
              subheader:
                'Depending on your account type, you may not see all people associated with this store.',
              table: {
                headers: {
                  name: 'Name',
                  phone: 'Phone',
                  email: 'Email',
                  notifications: 'Notifications',
                },
              },
              phoneLabels: {
                phone: 'phone',
                mobile: 'mobile',
                work: 'work',
                home: 'home',
                office: 'office',
                kitchen: 'kitchen',
                catering: 'catering',
                store: 'store',
              },
              notificationSettings: {
                notActive: 'Does not receive notifications',
                catererAccept: 'New order',
                foodPrep: 'Reconfirm order',
                orderTransmission: 'New order reminder',
                email: 'email',
                fax: 'fax',
                phone: 'call',
                text: 'text',
              },
            },
          },
          storeUsers: {
            title: 'Store Users',
            users: {
              header: 'Users',
              addUser: 'Add New User',
              table: {
                headers: {
                  name: 'Name',
                  phone: 'Phone',
                  email: 'Email',
                  notifications: 'Notifications',
                },
              },
              phoneLabels: {
                phone: 'phone',
                mobile: 'mobile',
                work: 'work',
                home: 'home',
                office: 'office',
                kitchen: 'kitchen',
                catering: 'catering',
                store: 'store',
              },
              notificationSettings: {
                notActive: 'Does not receive notifications',
                catererAccept: 'New order',
                foodPrep: 'Reconfirm order',
                orderTransmission: 'New order reminder',
                email: 'email',
                fax: 'fax',
                phone: 'call',
                text: 'text',
              },
            },
          },
          orderManagement: {
            dailyCapacity: {
              automaticTempClosureHeader:
                'Do you want us to set a temp closure when you hit capacity?',
              automaticTempClosure: 'Temporary closure is turned ',
              autoAccept: 'Order auto accept is turned ',
              on: 'on',
              off: 'off',
              automaticTempClosureLabel:
                'Prevent new orders for the time period once my limit is met',
              title: 'Daily Capacity Limits',
              // TODO: clean up these subtitles when we remove the useCapacityImprovements / FX:CapacityImprovements feature flag
              subtitleCapacityImprovements:
                'Set your limits for ezCater orders either as a total for the day or by meal time. You can set your own temporary closures from Settings.',
              subtitle:
                "Tell us how many orders you can handle each day. When you hit your daily limit, we'll send you a notification, giving you the choice to set a Temporary Closure.",
              subtitleWithAutoClosure:
                'Tell us how many orders you can handle for each day or meal. Based on your current settings, we will temporarily close your store to new orders when your limit is exceeded.',
              errors: {
                multipleError: `<strong>Your changes haven't been saved.</strong> To set capacity targets for the selected stores, edit the fields that say "Multiple" to your target numbers and click Save Changes. If you don't want the same limits for each store, edit each store's capacity individually.`,
                multipleAndMaxError: `<strong>Your changes haven't been saved.</strong> To set capacity targets for the selected stores, edit the fields that say "Multiple" to your target numbers and click Save Changes. The numbers may not exceed 1,000. If you don't want the same limits for each store, edit each store's capacity individually.`,
                maxError: `<strong>Your changes haven't been saved.</strong> Daily capacity limits may not exceed 1,000. Please correct the fields that are above 1,000 and click Save Changes.`,
                inlineMultipleError:
                  'Breakfast, lunch, and dinner counts must either all be "Multiple" or all be numbers.',
                inlineMultipleAndMaxError:
                  'Breakfast, lunch, and dinner counts must either all be "Multiple" or all be numbers. Numbers may not exceed 1,000.',
                inlineErrorsHeader: 'Please correct the following errors:',
                breakfast: 'Breakfast count may not exceed 1,000',
                lunch: 'Lunch count may not exceed 1,000',
                dinner: 'Dinner count may not exceed 1,000',
                daily: 'Daily count may not exceed 1,000',
              },
              dropdownLabel: "Set each day's capacity by",
              dailyTotalOrders: 'Daily total orders',
              limitsPerMealtime: 'Limits per mealtime',
              editLinkTitle: 'Edit',
              successMessage: 'Daily capacity was successfully saved',
              errorMessage: 'There was an error saving the daily capacities',
              permissionError: 'You do not have permission to edit daily capacity',
              bannerText:
                "If you're new to ezCater, set a low number at first to avoid having to reject or cancel orders.",
              tableHeaders: {
                days: 'Days',
                dailyMaxOrders: 'Daily max orders',
                breakfast: 'Breakfast',
                lunch: 'Lunch',
                dinner: 'Dinner',
              },
            },
            autoAccept: {
              title: 'Do you want to automatically accept orders?',
              subtitle: `Orders will be automatically accepted when customers submit them, without review by you or your staff. Do not turn this on unless you are confident you can accept orders without reviewing them.
                <br/>
                <br/>
                If you turn on auto accept, you'll be able to set an dollar amount above which you will still individually review orders.`,
              bulkEditMessage: 'This feature is not available in bulk edit mode.',
              toggleLabelEnabled: 'Yes, auto-accept all orders below {{amount}}',
              toggleLabelDisabled: 'No, I will manually accept all my orders',
              changeLimit: 'Change auto-accept limit',
              successMessage: 'Auto-acceptance limit was successfully saved',
              errorMessage: 'There was an error saving the auto-acceptance limit',
              modal: {
                title: 'Turn on auto-accept?',
                subtitle: `It looks like you don't have temp closures turned on. <strong>We highly recommend you do this if you'll be auto-accepting orders.</strong> Set your capacity limits to prevent getting more orders than you can handle. `,
                subtitleAutoAccept:
                  'Orders will be automatically accepted when customers submit them, without review by you or your staff. Do not turn this on unless you are confident you can accept orders without reviewing them.',
                description:
                  'Enter the order value at which you still want to manually review orders. Orders below this amount will be automatically accepted.',
                inputLabel: 'Auto-acceptance limit',
                inputPlaceholder: 'Enter amount',
                submit: 'Turn auto-accept on',
                cancel: 'Cancel',
                errorMaxValue: 'Auto-acceptance limit may not exceed ${{max}}.',
              },
            },
          },
          storeHoursSettings: {
            title: 'Incoming order management',
            storeHoursSection: {
              header: 'Standard Hours',
              description: 'Your normal business hours (updates are permanent).',
              bannerText: `It's a good idea to revisit this section periodically to make sure it's up to date.`,
              alert: {
                header: 'ezDispatch is active for all delivery orders',
                content:
                  'Customers will be able to receive orders within the delivery hours listed below. Delivery partners may need to pick up the food before your earliest delivery time.',
              },
              apiManagedHours: {
                header: 'Updates to Standard Hours are Disabled',
                content:
                  'Hours are managed via your integration with ezCater. Please update hours in your integrated system or contact Partner Success at partnersuccess@ezcater.com.',
              },
              table: {
                headers: {
                  delivery: 'Delivery',
                  takeout: 'Takeout',
                },
                tooltips: {
                  delivery: 'Hours where customers will be able to place new delivery orders.',
                  takeout: 'Hours where customers will be able to place new takeout orders.',
                },
              },
            },
            advanceNotice: {
              leadTime: {
                sameDayOrdersLabel: 'Accepts same day orders?',
                noticeInMinutesLabel: 'Advance notice for orders',
                dayBeforeLabel: 'Day before cutoff time',
                acceptsSameDayOrders: 'Yes',
                doesNotAcceptSameDayOrders: 'No',
                bannerText: `<strong>Low lead times — risk and reward</strong>
                <break/>
                Shorter lead times can generate more orders, but these orders have a higher rate of customer-reported issues. Focus on maximizing the number of orders you can fulfill <strong>reliably.</strong>`,
              },
              legacyDayBeforeCutoffTime: {
                header: 'Day-Before Cutoff',
                description:
                  'The latest time you accept orders for the following day. Your minimum lead time is used if it provides a larger buffer than your day-before cutoff.',
                label: 'Currently set to',
                alert: {
                  header: 'Avoid day-before cutoffs to get more orders',
                  content:
                    '11% of orders are same-day orders. A day-before cutoff prevents your customers from placing same-day orders.',
                },
              },
              legacyLeadTime: {
                header: 'Lead Time',
                description: 'The minimum advance notice you require for new orders.',
                label: 'Currently set to',
                infoAlert: {
                  header: 'Low lead times — risk and reward',
                  content:
                    'Shorter lead times can generate more orders, but these orders have a higher rate of customer-reported issues. Focus on maximizing the number of orders you can fulfill <strong>reliably.</strong>',
                },
                alert: {
                  header: 'Choose a low lead time to get more orders',
                  content:
                    '47% of orders are fulfilled by partners with a 4-hour or shorter lead time.',
                },
              },
            },
            vacationsSection: {
              header: 'Temporary Closures',
              description:
                "Days you're temporarily closed to new orders (e.g., capacity, holidays).",
              description_granular:
                "Select a period of time in which your store won't receive new orders from ezCater",
              bannerText: `You can schedule a temporary closure for any reason, for as little as a 15-minute period.`,
              table: {
                emptyState: 'No temporary closures scheduled.',
                headers: {
                  start: 'From',
                  end: 'Through',
                  duration: 'Total time closed',
                  marketplace: 'ezCater',
                  relish: 'Relish',
                },
                rows: {
                  forCapacity: 'Capacity Closures',
                },
              },
            },
          },
          delivery: {
            deliveryFees: {
              header: 'Delivery Fees',
              description: 'Your delivery fees and order minimum, based on delivery area/distance.',
              table: {
                headers: {
                  deliveryFee: 'Delivery Fee',
                  orderMinimum: 'Order Minimum',
                  deliveryAreaDistance: 'Delivery Area/Distance',
                },
                row: {
                  deliveryFee: {
                    fixed: '{{fee}}',
                    per_mile: '{{fee}} per mile',
                    percent_of_food: '{{fee}}% of food total',
                    custom: 'Custom',
                  },
                  deliveryAreaDistance: {
                    zip_code_one: '{{count}} zip code',
                    zip_code_other: '{{count}} zip codes',
                    city_one: '{{count}} city',
                    city_other: '{{count}} cities',
                    distance_one: 'Within {{count}} mile by driving',
                    distance_other: 'Within {{count}} miles by driving',
                    circle_one: '{{count}} custom map region',
                    circle_other: '{{count}} custom map regions',
                    polygon_one: '{{count}} custom map region',
                    polygon_other: '{{count}} custom map regions',
                    rectangle_one: '{{count}} custom map region',
                    rectangle_other: '{{count}} custom map regions',
                  },
                  andMoreCities_one: ', and {{count}} more city',
                  andMoreCities_other: ', and {{count}} more cities',
                  andMoreZips_one: ', and {{count}} more zip code',
                  andMoreZips_other: ', and {{count}} more zip codes',
                },
              },
            },
          },
          holidayClosures: {
            header: 'Holiday Closures',
            description: 'Recurring holidays when your business is closed.',
            emptyState: 'No holiday closures scheduled.',
            bannerText: `Once you set a holiday, you'll be marked as closed every year unless you remove the setting.`,
            table: {
              headers: {
                holiday: 'Holiday',
              },
            },
          },
        },
      },
      Integrations: {
        title: 'Integrations',
        generateCredentials: {
          title: 'Generate Credentials',
          subtitle: 'Warning: You will only be able to generate these credentials once!',
          submitButton: 'Generate',
          documentationCopy:
            'If you would like more information on integrating with ezCater via our API, please click ',
          CredentialModal: {
            header: 'Authentication Token',
            dismiss: 'Close',
            generateAuthHeaderError:
              'Authorization headers have already been generated. If you need to regenerate, please contact integrations@ezcater.com',
            closeModalAlert:
              'Your authorization header can only be generated once, please make sure to copy it.',
          },
        },
      },
      addNewStore: {
        title: 'Add new store',
      },
      payment: {
        title: 'Tax info',
      },
    },
    SettingsServicesAndFees: {
      allActiveServices: 'All Active Services',
      availableUpgrades: 'Available Upgrades',
      commissionRate: '{{rate}}% commission',
      creditCardFee: '{{fee}}% payment transaction fee',
      customerCommission: '{{commissionRate}}% commission for {{customerType}} customers',
      customerService: "ezCater's Customer Service Team",
      directEntry: 'Offline orders processed through ezManage',
      directEntryCCFees: '{{fee}}% payment transaction fee',
      ezCaterMarketplace: 'ezCater Marketplace',
      ezDispatch: 'ezDispatch',
      ezDispatchFee: '{{subtotalFee}} ezDispatch fee when the order subtotal is {{subtotalBounds}}',
      ezManage: 'ezManage  |  Catering management portal',
      ezOrdering: 'ezOrdering',
      ezOrderingIntro:
        '{{commissionRate}}% commission for ezOrdering customers until {{introEndDate}}',
      freeWithMembership: 'Free with your membership.',
      learnMoreAboutEzOrdering: 'Learn more about ezOrdering',
      howWeCalculateOurFees: 'How We Calculate Our Fees',
      noFees: 'No fees.',
      rateVariesAcrossStores: {
        creditCardFee: 'Payment transaction fee varies across stores',
        commissionRate: 'Commission rate varies across stores',
        introRate: 'Intro rate varies across stores',
        general: 'Varies across stores',
      },
      relish: 'Relish',
      relishFee: 'Fees are listed on the Relish Fees section of the Relish tab',
      requestEzOrdering: 'Request ezOrdering',
    },
    EditStoreDetails: {
      sidebar: {
        label: 'Changes will be made to',
      },
      form: {
        header: 'Edit Store Details',
        submit: 'Save Changes',
        success: 'Changes were successfully made to {{nickname}}',
        nickname: {
          label: 'Store Nickname',
          hint: 'Display name shown only to you and your team, not your customers.',
          error: 'Store Nickname must be fewer than 200 characters',
        },
        storeNumber: {
          label: 'Store Number',
          hint: "A number to identify your store's location (e.g. MA123).",
          error: 'Store Number must be fewer than 50 characters',
        },
        pickupInstructions: {
          label: 'Pickup Instructions',
          hint: 'Add instructions to help drivers find parking and locate the restaurant.',
        },
      },
    },
    EditTemporaryClosures: {
      error: 'Sorry, but you do not have permission to edit Temporary Closures',
      sidebar: {
        label: 'Changes will be made to',
      },
      main: {
        header: 'Edit Temporary Closures',
        subheader: "Days you're temporarily closed to new orders (e.g. capacity, holidays).",
        subheader_granular:
          'Close for an hour or days, simply use the date and time picker below to adjust your temporary closures.',
        submit: 'Add a closure',
        zero: 'No temporary closures scheduled.',
      },
      form: {
        header: 'Upcoming Closures',
        addAnotherButton: 'Add another',
        submit: 'Save Changes',
        success: 'Saved changes to Temporary Closures',
        remove: 'Remove',
        error: 'Choose both a start date and end date for your temporary closure',
        failure: 'Sorry, your Temporary Closures could not be updated.',
      },
      table: {
        headers: {
          start: 'From',
          end: 'Through',
          duration: 'Total time closed',
        },
      },
      timeDurationDisplay: {
        year_one: '{{count}} year',
        year_other: '{{count}} years',
        month_one: '{{count}} month',
        month_other: '{{count}} months',
        day_one: '{{count}} day',
        day_other: '{{count}} days',
        hour_one: '{{count}} hour',
        hour_other: '{{count}} hours',
        minute_one: '{{count}} minute',
        minute_other: '{{count}} minutes',
        missingValue: '--',
      },
    },
    BulkEditTemporaryClosures: {
      subNav: {
        header: 'Edit Temporary Closures',
        backLink: 'Back to Settings Selection',
      },
      header: 'Edit Temporary Closures',
      form: {
        title: 'Edit Temporary Closures',
        subtitle:
          'Close for an hour or days, simply use the date and time picker below to adjust your temporary closures.',
        submit: 'Save Changes',
      },
      confirm: {
        content: 'Add temporary closures for the following locations',
      },
      confirmation: {
        setting: 'Temporary Closures',
        description: 'Temporary Closures updated',
        header: 'Success!',
      },
      error: {
        default: 'Sorry, something went wrong. Please try again.',
      },
    },
    BulkEditDailyCapacity: {
      header: 'Edit Daily Capacity',
      subNav: {
        backLink: 'Back to Settings Selection',
      },
      alertMessage: {
        headline: "You're editing multiple locations",
        tagline: "Saving will overwrite each store's settings.",
      },
    },
    BulkEditHolidayClosures: {
      header: 'Edit Holiday Closures',
      subNav: {
        header: 'Edit Holiday Closures',
        backLink: 'Back to Settings Selection',
      },
      form: {
        title: 'Add Holiday Closures (Recurring)',
        subtitle:
          'By checking the boxes below, your store won’t show up on our marketplace for the selected days.',
      },
    },
    BulkEditOperatingSchedules: {
      subNav: {
        header: 'Edit Operating Schedules',
        backLink: 'Back to Settings Selection',
      },
      header: 'Edit Operating Hours',
      form: {
        title: 'Edit Standard Hours',
        subtitle: 'Normal business hours (updates are permanent).',
        sameTakeoutHoursLabel: 'Same as delivery hours',
        sameThirdPartyDeliveryHoursLabel: 'Same as takeout hours',
        submit: 'Save Changes',
      },
      confirm: {
        content: 'Change operating hours',
      },
      confirmation: {
        setting: 'Hours',
        description: 'Operating hours updated',
        header: 'Success!',
      },
      error: {
        default: 'Sorry, something went wrong. Please try again.',
      },
      validation: {
        blockedStores: {
          disabledHeader: 'Bulk editing is not available',
          disabledMessage:
            'The following {{count}} store(s) have hours managed via your integration with ezCater and cannot be bulk edited: {{storeNames}}. Please update hours in your integrated system or contact Partner Success at partnersuccess@ezcater.com',
        },
      },
    },
    EditOperatingSchedules: {
      subNav: {
        header: 'Edit {{nickname}}',
        backLink: 'Back to Store Settings',
      },
      form: {
        title: 'Operating Hours',
        subtitle: 'Hours you are able to prepare delivery and takeout orders.',
        sameTakeoutHoursLabel: 'Same as delivery hours',
        submit: 'Save Changes',
      },
      success: 'Saved changes to Operating Hours',
      error: {
        default: 'Sorry, something went wrong. Please try again.',
        dateParsing: 'Unable to parse date',
      },
    },
    BulkEditLeadTimes: {
      subNav: {
        header: 'Edit Lead Time',
        backLink: 'Back to Settings Selection',
      },
      header: 'Edit Lead Time',
      form: {
        title: 'Edit Lead Time',
        subtitle: 'The minimum advance notice required for new orders.',
      },
      proposedChange: {
        noticeInMinutes: 'Update lead time to {{formattedMinutes}}',
        cutoffTime: 'Update day before cutoff time to {{cutoffTime}}',
      },
      confirmChanges: {
        description: 'Update lead time',
      },
      confirmation: {
        setting: 'Lead Times',
        description: 'Lead times updated',
      },
      error: {
        default: 'Unable to save your changes. Please try again or contact support.',
      },
    },
    EditLeadTime: {
      subNav: {
        header: 'Edit {{nickname}}',
        backLink: 'Back to Store Settings',
      },
      form: {
        title: 'Lead Time',
        subtitle: 'The minimum advance notice required for new orders.',
      },
      success: 'Saved changes to Lead Time',
      error: {
        default: 'Sorry, something went wrong. Please try again.',
      },
    },
    Menu: {
      storeTablePageHeader: 'Menus',
      table: {
        title: 'Stores',
        subtitle: 'Please select the store whose menu you would like to update.',
        search: {
          placeholder: 'Search stores',
        },
      },
      sidePanel: {
        selectedStore: 'Selected Store',
        changeStore: 'Change selected store',
        viewMenu: {
          title: "Want to view this store's menu?",
          link: 'View menu in ezCater Marketplace →',
        },
        requestPhotoUpdates: {
          title: 'Want to update photos?',
          link: 'Request photo updates →',
        },
      },
      requestMenuUpdate: {
        title: 'Request Menu Updates',
        subheader: 'You can request menu updates by submitting the form below.',
        backLink: 'Back to Store Selection',
      },
      form: {
        title: 'Menu Update',
        priceMatchMessage:
          'If your update includes price changes or additions, due to our Equal-Price Guarantee, ezCater must match the requested prices to your website. If the requested prices do not match, there may be a delay in your update.',
        selectedStore: {
          label: 'Selected Store',
          menuLink: 'Current Menu',
        },
        contactInfo: {
          name: 'Full Name',
          email: 'Email',
          emailHelper: 'Please limit to one email address',
          phone: 'Phone',
        },
        hasMultipleLocations: {
          alert: {
            headline: 'When updating multiple locations',
            tagline:
              'Please let us know which locations you would like the updates applied to. If you have different updates for different locations, please provide those details in the “Notes” section, or submit multiple forms if it is easier.',
          },
          label: 'Will these updates apply to multiple locations?',
          yesOptionLabel: 'Yes',
          noOptionLabel: 'No',
          required: 'This field is required',
        },
        affectedLocations: {
          label: 'Please provide a list of locations these updates will apply to:',
          required: 'This field is required',
        },
        submit: 'Submit',
        menuUpdateDestination: {
          label: 'Please select where this update should be applied:',
          ezcater: 'Apply this update to my ezCater menu only',
          relish: 'Apply this update to my Relish menu only',
          both: 'Apply this update to both my ezCater and Relish menus',
          required: 'This field is required',
        },
        updates: {
          label: 'Please select all the updates you would like to make to your menu below:',
          priceChangeLessThanFiveLabel: 'Price changes (less than 5 items)',
          priceChangeMoreThenFiveLabel: 'Price changes (more than 5 items)',
          removeItemsLabel: 'Remove items',
          addMenuItemLabel: 'Add items (include description, serving size & price)',
          changeSizeLabel: 'Change the serving size/minimum order size of an item(s)',
          changeDescriptionLabel: 'Change description of an item',
          replaceMenuLabel: 'Replace current menu with new menu',
          otherLabel: 'Other',
          required: 'This field is required',
        },
        individualPackaging: {
          label: 'Are the items you are adding:',
          yesLabel: 'Always Individually Packaged',
          noLabel: 'Never Individually Packaged',
          notesLabel: 'Notes',
          required: 'This field is required',
        },
        menuUrl: {
          label:
            'Paste a link to your most up to date online catering menu in the text box below. The update process may be delayed without a link to your menu.',
        },
        specificInstructions: {
          label:
            'Please provide specific instructions for your menu update so that we can complete it quickly and accurately.',
          required: 'This field is required',
        },
        menuFiles: {
          firstLabel:
            'If your menu is not available online, please upload a copy of your menu. (25MB max)',
          secondLabel: 'Upload a second file. (25MB max)',
          thirdLabel: 'Upload a third file. (25MB max)',
        },
        flashMessages: {
          error: 'There was an error processing your request',
        },
        success: {
          title: 'Success!',
          message: 'You will receive an email confirmation once your request has been completed.',
          action: 'Request Additional Updates',
        },
      },
    },
    MenuPerformance: {
      title: 'Menu Performance',
      lastUpdated: 'Last updated on {{date}}',
      ProductMixTable: {
        mainHeading: 'Product mix',
        ariaLabel: 'Product mix table',
        mainSubheading:
          'This is a snapshot of the performance of all menu items across all of your businesses. Compare to performance to previous period of time.',
        resetFilters: 'Reset filters',
        displayingDataFor: 'DISPLAYING DATA FOR:',
        comparedTo: 'compared to',
        allBrands: 'All brands',
        timeFrame: 'Time frame',
        headers: {
          menuItem: 'MENU ITEM',
          pricePerItem: 'PRICE (PER ITEM)',
          itemsSold: 'ITEMS SOLD',
          percentChange: '%CHG',
          revenue: 'REVENUE',
          orders: 'ORDERS',
        },
      },
    },
    StoreBuildInProgress: {
      title: "Great news! We're working to get your account and menu up and running.",
      subtitle: 'We will reach out when we are finished.',
    },
    PaymentSettings: {
      achBanner: {
        headline: 'Get paid quickly and reliably with ACH/Direct Deposit.',
        message:
          'No more waiting for checks to arrive in the mail. Sign up for ACH to have your ezCater payments in your bank account only 2 business days after we process the payment.',
        action: 'Edit Payment Info',
      },
      taxInfoCardTitle: 'Tax Info',
      taxInfoCardEdit: 'Edit',
      paymentInfoCardTitle: 'Payment Info',
      paymentInfoCardEdit: 'Edit',
      requiredTaxIdBanner: {
        line1: 'Your stores do not have required tax information.',
        line2:
          "You must add a taxpayer identification number (TIN). We will place your account on hold by 1/3/23 if we don't receive your tax information.",
        link: ' Add it here',
      },
      businessNameLabel: 'Business Name',
      addressLabel: 'Address',
      taxIdLabel: 'Federal Tax Id',
      paymentMethodLabel: 'Payment Method',
      paymentMethodCheck: 'Check',
      paymentMethodAch: 'ACH/Direct Deposit',
      accountTypeLabel: 'Account Type',
      accountTypeBusiness: 'Business',
      accountTypeIndividual: 'Individual',
      payableNameLabel: 'Payable Name on Account',
      routingNumberLabel: 'Routing Number',
      accountNumberLabel: 'Account Number',
      accountAddressLabel: 'Account Address',
      disabledPaymentEditButtonMessage:
        'First, add tax info. You must update your tax info before you can change payment details.',
      requiredTaxIdText: 'required',
    },
    TaxInfoSettings: {
      backLink: 'Back to Tax Settings',
      pageTitle: 'Edit Tax Info',
      requiredErrorMessage: 'Required',
      placeholderText: 'required',
      labels: {
        registeredName: 'Registered Name',
        taxId: 'Taxpayer Identification Number (TIN)',
        address1: 'Address Line 1',
        address2: 'Address Line 2 (Suite, Building, Apt, etc.)',
        city: 'City',
        state: 'State',
        zip: 'ZIP Code',
        submit: 'Save Changes',
        cancel: 'Cancel',
      },
      helperText: {
        registeredName: 'Registered name as it appears on Box 1 of your W-9.',
        taxId: '9-digit number found in Part 1 of your W-9.',
        taxIdTooltip:
          'For business entities, this is your employer identification number (EIN). For indiviuals, this is generally your social security number (SSN).',
      },
      registeredAddress: {
        title: 'Registered Address',
        description: 'Registered address as it appears on your W-9.',
      },
      successFlashMessage: 'Your changes were saved. Tax info updated.',
      genericErrorFlashMessage: 'There was an error processing your request',
    },
    Subway: {
      orderSearch: {
        title: 'Search by order number',
        placeholder: '#ABC-123',
        label: 'Search by order number',
        submit: 'Search Order',
        noResults: 'No orders found. Please try again.',
        multipleResults:
          'We found more than one order. Please search again with a more specific order number.',
        returnLinkText: 'Back to order and store search',
      },
      storeSearch: {
        title: 'Search for store',
        placeholder: 'Search by number, nickname or address',
        label: 'Search by number, nickname or address',
        submit: 'Search Store',
        noResults: 'No stores found. Please try again.',
        multipleResults:
          "Not finding what you're looking for? Please search again with a more specific keyword to see additional results.",
        storeLink: '#{{storeNumber}}, {{nickname}}, {{address}}',
      },
    },
    MarketingTools: {
      campaignActions: {
        pauseCampaignModal: {
          headerText: 'Pause {{address}}',
          contentText: 'Are you sure you want to pause your campaign at {{address}}?',
          confirmButtonText: 'Yes, pause campaign',
          cancelButtonText: 'Nevermind',
        },
        resumeCampaignModal: {
          headerText: 'Resume campaign',
          contentText:
            'Are you sure you want to resume your campaign? Once you resume your campaign, your sponsored listing will be live.',
          confirmButtonText: 'Yes, resume campaign',
          cancelButtonText: 'Nevermind',
          error: {
            headline: 'Error resuming campaign.',
            tagline: 'Please try again.',
          },
        },
        deleteCampaignModal: {
          headerText: 'Delete campaign at {{address}}?',
          contentText:
            'Your listing will stop showing in search. Pause instead to resume later. If there are any order charges from ad views, it will show in your Activity tab.',
          confirmButtonText: 'Delete campaign permanently',
          cancelButtonText: 'Nevermind',
          error: {
            headline: 'Error deleting campaign.',
            tagline: 'Please try again.',
          },
        },
      },
      campaignGroupActions: {
        actions: {
          pause: 'Pause campaign',
          resume: 'Resume campaign',
          edit: 'Edit campaign',
          delete: 'Delete campaign',
        },
        pauseCampaignGroupModal: {
          headerTextSingleStore: 'Pause campaign at {{address}}?',
          headerTextMultiStore: 'Pause campaign at {{count}} stores?',
          contentTextSingleStore:
            'Once paused, your sponsored listing for {{address}} will stop showing in search results.',
          contentTextMultiStore:
            'Once paused, your sponsored listing for these stores will stop showing in search results:',
          confirmButtonText: 'Pause campaign',
          cancelButtonText: 'Nevermind',
        },
        resumeCampaignGroupModal: {
          headerTextSingleStore: 'Resume campaign at {{address}}?',
          headerTextMultiStore: 'Resume campaign at {{count}} stores?',
          contentTextSingleStore:
            'Once resumed, your sponsored listing for {{address}} will start showing in search results.',
          contentTextMultiStore:
            'Once resumed, your sponsored listing for these stores will start showing in search results:',
          confirmButtonText: 'Yes, resume campaign',
          cancelButtonText: 'Nevermind',
          error: {
            headline: 'Error resuming campaign.',
            tagline: 'Please try again.',
          },
        },
        deleteCampaignGroupModal: {
          headerTextSingleStore: 'Delete campaign at {{address}}?',
          headerTextMultiStore: 'Delete campaign at {{count}} stores?',
          contentTextSingleStore:
            'Your listing will stop showing in search. Pause instead to resume later. If there are any order charges from ad views, it will show in your Activity tab.',
          contentTextMultiStore:
            'Your listing will stop showing in search. Pause instead to resume later. If there are any order charges from ad views, it will show in your Activity tab.',
          confirmButtonText: 'Delete campaign permanently',
          cancelButtonText: 'Nevermind',
          error: {
            headline: 'Error deleting campaign.',
            tagline: 'Please try again.',
          },
        },
      },
      header: 'Sponsored Listings',
      tabTitles: {
        startACampaign: 'Start a campaign',
        myCampaigns: 'My campaigns',
        activity: 'Activity',
      },
      newCampaignButton: 'New Campaign',
      marketingToolsTab: {
        header: {
          getMoreOrders: 'Get more orders with sponsored listings',
          howItWorks: 'How sponsored listings work',
        },
        howItWorksDescription:
          'Each time a customer searches on ezCater, a portion of the results are reserved for sponsored listings, displaying restaurants that pay to reach the most relevant customers based on cuisine and location. Appearing in those spots is an easy way to boost your profile and get new customers. We’ll guide you through it.',
        button: 'Get started',
        createButton: 'Create Sponsored Listing campaign',
        faq: 'Frequently asked questions',
        reachNewCustomers: {
          heading: 'Reach new customers',
          description:
            'Appear in dedicated, highly visible areas of ezCater where customers are searching for restaurants like yours.',
        },
        makeYourSpendCount: {
          heading: 'Make your spend count',
          description:
            'Get even more high-value orders, only paying for orders that come from your ad.',
        },
        quickAndSimple: {
          heading: 'Quick, simple, and transparent',
          description:
            'Set up campaigns in just a few clicks, choose your budgets and spending limits, and easily track campaign performance.',
        },
        selectLocation: {
          heading: 'Select locations',
          description: 'Choose the stores you want to promote and set your budget.',
        },
        chooseSpendingStrategy: {
          heading: 'Choose spending strategy',
          description: 'Set a maximum budget and choose how you want to use it.',
        },
        trackCampaign: {
          heading: 'Track your campaign',
          description: 'Manage your sponsored listing and get detailed stats in “My campaigns”.',
        },
        readyToStart: {
          heading: 'Ready to start? Get more orders with sponsored listings',
          description: 'Build a campaign today to get your restaurant in front of new customers.',
        },
      },
      sponsoredListingCampaignsTab: {
        header: 'My Campaigns',
        newCampaign: 'New campaign',
        noCampaign: {
          heading: 'No campaigns to show',
          description:
            'Once you start a campaign and receive orders, your campaign performance will appear here.',
        },
        noCampaignActivity: {
          heading: 'No activity yet',
          description:
            'Performance data will appear here once you receive engagement with your campaigns.',
        },
      },
      sponsoredListingCampaignDetails: {
        timeRangeLabel: 'Time range',
        budget: 'Budget {{amount}} / week',
        budgetDistributeEvenly: 'Spending capped at {{amount}}/week at {{count}} locations.',
        budgetDistributeByDemand: 'Distributed across {{count}} locations based on demand.',
        runTime: '{{startDate}} - {{endDate}}',
        runTimeUntilPaused: 'Until paused',
        biddingAutomatic: 'Automatic',
        biddingManual: 'Manual bidding: {{amount}}',
        numberOfLocations: '{{count}} locations',
        salesFromAds: 'Sales from ads',
        tableHeading: 'Locations in this campaign',
        conversion: '{{conversionRate}}%',
        errorResume: 'There was an error enabling the location',
        errorPause: 'There was an error disabling the location',
        editCampaign: 'Edit campaign',
        status: {
          paused: 'Paused',
          completed: 'Completed',
        },
      },
      sponsoredListingCampaignsReports: {
        timeRangeLabel: 'Time range',
        campaignLabel: 'Campaign',
        report: {
          amount: '${{amount}}',
          amountSpentOnAds: 'Amount spent on ads',
          amountSpentOnAdsText:
            'How much you’ve spent on sponsored listings during the selected time period',
          conversionRate: 'Conversion rate',
          conversionRateText:
            'What percentage of customers who’ve viewed your menu went on to order',
          customers: 'Customers',
          impressions: 'Impressions',
          percentage: '{{percentage}}%',
          roas: 'Return on ad spend (ROAS)',
          roasText: 'You’ve earned ${{amount}} for every $1 spent across your campaigns',
          sales: 'Sales',

          adViews: 'Ad views',
          xTimes: '{{times}}x',
          tooltip: {
            adViews: 'Ad views',
            clicks: 'Clicks',
            orders: 'Orders',
            sales: 'Sales',
            customers: 'Customers',
            customerNewLabel: 'New',
            customerExistingLabel: 'Existing',
            customerLapsedLabel: 'Lapsed',
            customerNew: 'Never placed an order at this location',
            customerExisting: 'Placed an order at this location within the past 90 days',
            customerLapsed: 'Placed an order at this location, but not within the past 90 days',
          },
          downloadReport: 'Download CSV',
          downloadError: 'Sorry, there was an error downloading your report.',
        },
        campaignsSelector: {
          placeholder: 'All campaigns',
        },
        customerEngagementChart: {
          newCustomers: '{{count}} New',
          existingCustomers: '{{count}} Existing',
          lapsedCustomers: '{{count}} Lapsed',
          tooltip: {
            title: 'Customers',
          },
        },
        salesFromAds: 'Sales from ads',
      },
      sponsoredListingCampaignsTable: {
        tableHeading: 'Campaigns',
        conversion: '{{conversionRate}}%',
        roas: '{{returnOnAdSpend}}x',
        paused: 'Paused',
        untilPaused: 'Until paused',
        untilDate: '{{startDate}} - {{endDate}}',
        budget: 'Budget {{amount}}/week',
        autoBid: 'Auto-bid',
        manualBid: '{{amount}} bid',
        locationCampaignsStatus: {
          ongoing: '{{index}}. Ongoing until paused',
          startDateUntilPaused: '{{index}}. {{startDate}} - Until paused',
          startDateUntilEndDate: '{{index}}. {{startDate}} - {{endDate}}',
        },
      },
      sponsoredListingCampaignGroupsTable: {
        tableHeading: 'Campaigns',
        conversion: '{{conversionRate}}%',
        roas: '{{returnOnAdSpend}}x',
        paused: 'Paused',
        completed: 'Completed',
        untilPaused: 'Until paused',
        untilDate: '{{startDate}} - {{endDate}}',
        budgetDistributeByDemand: 'Budget {{amount}}/week',
        budgetDistributeEvenlyMultiStore: 'Budget {{totalAmount}}/week ({{storeAmount}}/store)',
        budgetDistributeEvenlySingleStore: 'Budget {{totalAmount}}/week',
        autoBid: 'Auto-bid',
        manualBid: '{{amount}} bid',
        locationCampaignsStatus: {
          ongoing: '{{index}}. Ongoing until paused',
          startDateUntilPaused: '{{index}}. {{startDate}} - Until paused',
          startDateUntilEndDate: '{{index}}. {{startDate}} - {{endDate}}',
        },
      },
      sponsoredListingCampaignOrdersModal: {
        heading: '{{ordersCount}} orders for {{campaignIdentifier}}',
      },
      sponsoredListingsActivities: {
        title: 'Activity',
        tableTitle: 'Marketing Activity',
        emptyState: {
          heading: 'No activity yet',
          description:
            'Marketing activity will appear here once you receive orders from your campaigns.',
        },
      },
      sponsoredPromos: {
        header: 'Marketplace promos',
        increaseConversion: 'Increase conversion with marketplace promotions',
        newPromoButton: '+ New promo',
        createCampaign: 'Create campaign',
        howItWorks: 'How marketplace promos work',
        faq: 'Frequently asked questions',
        buildYourOffer: {
          heading: 'Build your offer',
          description: 'Decide what incentive you want to offer, and when it should be valid.',
        },
        controlYourCampaigns: {
          heading: 'Control your campaign',
          description:
            'You choose what to offer, with the option of an order minimum. You can track your campaign’s performance and adjust or pause it any time.',
        },
        inviteNewCustomers: {
          heading: 'Attract more customers',
          description:
            'People who haven’t tried your food yet will have more reason to try when you offer a percentage or fixed-dollar discount.',
        },
        noActivity: {
          heading: 'No activity yet',
          description:
            'Performance data will appear here once you receive engagement with your campaigns.',
        },
        readyToStart: {
          heading: 'Ready to start? Get more orders with a promotional offer',
          description: 'Build a campaign today to raise your appeal to new customers.',
          button: 'Get started',
        },
        standOutInSearch: {
          heading: 'Stand out in search',
          description:
            'Your promotion will make your listing more visible and draw attention among competitors.',
        },
        selectLocations: {
          heading: 'Select locations',
          description: 'Choose the stores you want to promote and set your budget.',
        },
        trackYourCampaign: {
          heading: 'Track your campaign',
          description: 'Manage your promo and get detailed stats in its performance.',
        },
        faqItems: {
          howMarketplacePromosWork: {
            question: 'How do marketplace promotions work?',
            answer: `When you create a promotion, you’re offering a discount to attract customers when they’re selecting a restaurant in the ezCater marketplace. The discount will be visible with your listing in search results, so customers are aware of it when deciding which restaurants to consider.

You can offer customers a percentage or fixed-dollar discount, and optionally can set an expiration date and an order minimum. `,
          },
          campaignSuccessful: {
            question: 'How do I know if my campaign is successful?',
            answer: `Your criteria for success may vary depending on your goals. Once you’ve created a promo, its performance details will be visible on this page. You'll be able to track how many times your promotion was redeemed and the dollar value of sales from those orders. You'll also be able to track your promo visibility and sales trends over time, and view the performance of different promotions if you're running more than one.`,
          },
          doINeedAdExperience: {
            question: 'Do I need ad experience or a marketing team to run a promo?',
            answer: `No, our goal is to make promos accessible and successful for all restaurant owners, regardless of the size of their team or the scale of their business.

We’ll guide you through the process of building a campaign if this is your first.`,
          },
          whoWillSee: {
            question: 'Who will see my promotion?',
            answer: `Your promotion will appear 1) as part of your listing in the search results and 2) on your menu page.

In search results, it will be seen by customers searching in your delivery or takeout area. Your regular listing will appear organically in results, but if you pair your promotion with a sponsored listing, you can get more prominent placement within search results.

On your restaurant’s page, it will appear at the top of the menu, so more potential customers are aware of the offer and can redeem it.

Over time, we may introduce features that let you target more specific audiences.`,
          },
          promotionalDiscount: {
            question: 'How does a promotional discount appear impact an order’s cost and payment?',
            answer: `When a customer applies the discount you’re offering, they will see the regular menu price and subtotal of all food and drink items in their order, and the discount will be applied as a separate line item below the subtotal.

When receiving payment from ezCater for the order, the standard ezCater commission will be based on the order subtotal as usual, not the discounted value.`,
          },
        },
      },
      sponsoredPromoCampaignsTable: {
        header: 'Marketplace promos',
        tableHeadings: {
          name: 'PROMO NAME',
          store: 'STORE',
          redemptions: 'REDEMPTIONS',
          orderTotal: '$ ORDERS',
          datesActive: 'DATES ACTIVE',
          status: 'STATUS',
          actions: 'ACTION',
        },
        action: {
          end: 'End promo',
          endSuccess: 'Promo has ended successfully',
        },
        endSponsoredPromoModal: {
          headerText: 'End this promotion today?',
          contentText:
            "Ending this campaign will halt the promotion. It can't be restarted but you can create a new one.",
          confirmButtonText: 'Yes, end today',
          cancelButtonText: 'Cancel',
          errorHeadline: 'Error ending promotion',
          errorTagline: 'Please try again later.',
        },
      },
      sponsoredPromoCampaignsCharts: {
        sales: 'Sales',
        salesFromPromos: 'Sales from promos',
        amount: '${{amount}}',
        totalRedemptions: 'Total redemptions',
        totalRedemptionsText: 'Total number of times customers redeemed this promo',
        tooltip: {
          sales: 'Sales',
          views: 'Views',
        },
      },
      sponsoredPromosReport: {
        timeRange: 'Time range',
        promos: 'Promos',
        downloadReport: 'Download CSV',
        downloadError: 'Sorry, there was an error downloading your report.',
      },
      sponsoredPromoDetails: {
        header: 'Promo',
        breadcrumb: 'Marketplace promos',
        locationSelectorLabel: 'Location',
        allLocations: 'All locations',
      },
      sponsoredPromoDetailsTable: {
        tableHeadings: {
          store: 'STORE',
          redemptions: 'REDEMPTIONS',
          orderTotal: '$ ORDERS',
        },
        header: 'Locations in this promo',
      },
    },
    CreateSponsoredListing: {
      title: 'Create sponsored listing campaign',
      backLink: 'Back to marketing tools',
      ReviewStep: {
        locations: {
          titleForSingleLocation: 'At 1 location',
          titleForMultiLocations: 'At {{count}} locations',
          tooltipForSingleLocation: 'This is the only location available for sponsored listings.',
          tooltipForEditCampaign: 'The location cannot be changed for this campaign.',
        },
        budget: 'Budget {{budget}}/week',
        budgetCalloutForDistributeEvenly:
          'Spending capped at {{budgetAmount}}/week at {{count}} locations',
        budgetCalloutForDistributeByDemand:
          'Budget will be distributed across {{count}} locations based on demand.',
        budgetDistribution: {
          evenly: 'Distribute budget evenly',
          byDemand: 'Distribute budget by demand',
          helpText: 'Budget distribution can’t be changed for live campaigns.',
        },
        duration: {
          untilPaused: 'Running until paused',
          scheduledDate: 'Running from {{startDate}} to {{endDate}}',
        },
        spendingStrategy: {
          automatic: 'Automatic bidding - {{autoBidGoal}}',
          manual: 'Manual bidding: ${{manualSpendingLimit}}',
          description: {
            efficiency:
              'Maximize your return on investment by bidding on the most profitable listings.',
            balanced: 'Balance your budget across all listings to ensure consistent performance.',
            visibility: 'Increase your visibility in search results to attract more customers.',
          },
        },
        editBiddingStrategy: {
          callout: {
            automatic:
              'You can change automatic approaches any time. Changing between automatic and manual strategies requires creation of another campaign.',
            manual:
              'You can change manual bids at any time. Changing between automatic and manual strategies requires creation of another campaign.',
          },
          modal: {
            error: {
              headline: 'Error pausing campaign.',
              tagline: 'Please try again.',
            },
            heading: 'Change spending strategy?',
            description:
              'Changing between automatic and manual spending requires you to create a new campaign. This will pause your existing campaign and create a new one.',
            autoBidDescription:
              'You can adjust your auto-bid setting between Efficiency, Balanced, and Visibility any time.',
            manualBidDescription: 'You can adjust your manual bid amount any time.',
            autoBidConfirmBtn: 'Edit auto-bid setting',
            manualBidConfirmBtn: 'Edit manual bid limit',
            cancelBtn: 'Cancel',
            confirmBtn: 'Change spending strategy',
          },
        },
      },
    },
    EditSponsoredListing: {
      title: 'Editing campaign: {{name}}',
      backLink: 'Back to my campaigns',
    },
    CreatePromo: {
      title: 'Create promo',
      backLink: 'Back to marketing tools',
    },
  },
  pageTitles: {
    default: 'ezManage',
    deliveryPerformanceReporting: 'Delivery reporting',
    orderIndex: 'Orders - ezManage',
    performance: 'Performance - ezManage',
    performanceGroup: '{{groupName}} - ezManage',
    paymentDetails: '{{sentOn}} Payment Details - ezManage',
    paymentIndex: 'Payments - ezManage',
    orderShow: 'Order {{formattedOrderNumber}} - ezManage',
    orderEntry: 'Create New Order - ezManage',
    ezDispatchPreferences: 'ezDispatch Configuration - ezManage',
    ezOrderingMarketing: 'Get more orders - ezManage',
    settings: 'Settings - ezManage',
    settingsStoreDetails: '{{nickname}} - ezManage',
    editDailyCapacity: 'Edit {{nickname}}',
    editHolidayClosures: 'Edit {{nickname}}',
    editStoreDetails: 'Edit {{nickname}}',
    editTemporaryClosures: 'Edit {{nickname}}',
    editOperatingSchedules: 'Edit {{nickname}}',
    editLeadTime: 'Edit {{nickname}}',
    reviews: 'Reviews - ezManage',
    clubsoda: 'Relish - ezManage',
    personalStoreGroupDetails: '{{groupName}} - ezManage',
    menu: 'Menus - ezManage',
  },
  util: {
    directEntryExternalPaymentOptions: {
      inStore: 'Pay in Store',
      invoice: 'Invoice',
      lineOfCredit: 'Line of Credit',
      houseAccount: 'House Account: {{companyName}}',
      houseAccountWithoutCompany: 'House Account',
    },
    subQuantityOptions: {
      '50': 'Half',
      '75': '3/4',
      '100': 'All',
      other: '{{percentage}}%',
    },
  },
  orderStatuses: {
    accepted: 'Accepted',
    cancelled: 'Cancelled',
    changes_requested: 'Changes Requested',
    completed: 'Completed',
    draft: 'Draft',
    food_delivered: 'Completed',
    food_prepped: 'Reconfirmed',
    needs_acceptance: 'New',
    needs_acknowledgement: 'New (Direct Entry)',
    needs_confirm_cancellation: 'Cancelled',
    needs_confirm_modification: 'Modified',
    needs_driver_assignment: 'Needs Driver',
    needs_food_prep: 'Needs Confirmation',
    new: 'New',
    overdue: 'Invoice Overdue',
    paid: 'Paid',
    payment_failed: 'Payment Failed',
    pending_payment: 'Completed',
    quote: 'Quote Sent',
    rejected: 'Rejected',
    reviewed: 'Reviewed',
    sent: 'Invoice Sent',
    third_party_delivery_requested: 'ezDispatch Requested',
    unpaid: 'Unpaid',
    upcoming: 'Upcoming',
  },
} as const;
